(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3432],{

/***/ 88996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$x": function() { return /* binding */ getCustomerCatalog; },
/* harmony export */   "DG": function() { return /* binding */ updateCustomerCatalogAlias; },
/* harmony export */   "JG": function() { return /* binding */ getCustomerCatalogInitState; },
/* harmony export */   "MB": function() { return /* binding */ initCustomerCatalog; },
/* harmony export */   "dF": function() { return /* binding */ removeCustomerCatalogItems; },
/* harmony export */   "eL": function() { return /* binding */ getCustomerCatalogLots; },
/* harmony export */   "eX": function() { return /* binding */ pinCustomerCatalogItem; },
/* harmony export */   "fW": function() { return /* binding */ searchCustomerCatalogProduct; },
/* harmony export */   "fY": function() { return /* binding */ addCustomerCatalogItems; },
/* harmony export */   "nb": function() { return /* binding */ arrangeCustomerCatalog; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97582);
/* harmony import */ var _Clients__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38307);



var FRONTEND_APIS_PREFIX = "/marketplace/frontend-apis/v2";
function initCustomerCatalog() {
    return _initCustomerCatalog.apply(this, arguments);
}
function _initCustomerCatalog() {
    _initCustomerCatalog = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_0__/* .POST */ .a4)((_tmp.url = "".concat(FRONTEND_APIS_PREFIX, "/screen/customer-catalog/init"), _tmp))
            ];
        });
    });
    return _initCustomerCatalog.apply(this, arguments);
}
function getCustomerCatalogInitState() {
    return _getCustomerCatalogInitState.apply(this, arguments);
}
function _getCustomerCatalogInitState() {
    _getCustomerCatalogInitState = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_0__/* .GET */ .HT)((_tmp.url = "".concat(FRONTEND_APIS_PREFIX, "/screen/customer-catalog/init-state"), _tmp))
            ];
        });
    });
    return _getCustomerCatalogInitState.apply(this, arguments);
}
function getCustomerCatalog() {
    return _getCustomerCatalog.apply(this, arguments);
}
function _getCustomerCatalog() {
    _getCustomerCatalog = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var ref, _search, search, _chip, chip, _category, category, _sort, sort, _offset, offset, _limit, limit, _tmp, _tmp1;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            _tmp = {};
            ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : _tmp, _search = ref.search, search = _search === void 0 ? "" : _search, _chip = ref.chip, chip = _chip === void 0 ? "" : _chip, _category = ref.category, category = _category === void 0 ? "" : _category, _sort = ref.sort, sort = _sort === void 0 ? "" : _sort, _offset = ref.offset, offset = _offset === void 0 ? 0 : _offset, _limit = ref.limit, limit = _limit === void 0 ? 0 : _limit;
            _tmp1 = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_0__/* .GET */ .HT)((_tmp1.url = "".concat(FRONTEND_APIS_PREFIX, "/screen/customer-catalog"), _tmp1.params = {
                    search: search,
                    chip: chip,
                    category: category,
                    sort: sort,
                    offset: offset,
                    limit: limit
                }, _tmp1))
            ];
        });
    });
    return _getCustomerCatalog.apply(this, arguments);
}
function getCustomerCatalogLots(productId) {
    return _getCustomerCatalogLots.apply(this, arguments);
}
function _getCustomerCatalogLots() {
    _getCustomerCatalogLots = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(productId) {
        var _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_0__/* .GET */ .HT)((_tmp.url = "".concat(FRONTEND_APIS_PREFIX, "/screen/customer-catalog/lots"), _tmp.params = {
                    productId: productId
                }, _tmp))
            ];
        });
    });
    return _getCustomerCatalogLots.apply(this, arguments);
}
function searchCustomerCatalogProduct(_) {
    return _searchCustomerCatalogProduct.apply(this, arguments);
}
function _searchCustomerCatalogProduct() {
    _searchCustomerCatalogProduct = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(param) {
        var text, _limit, limit, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            text = param.text, _limit = param.limit, limit = _limit === void 0 ? 20 : _limit;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_0__/* .POST */ .a4)((_tmp.url = "".concat(FRONTEND_APIS_PREFIX, "/screen/customer-catalog/search"), _tmp.body = {
                    text: text,
                    limit: limit
                }, _tmp))
            ];
        });
    });
    return _searchCustomerCatalogProduct.apply(this, arguments);
}
function addCustomerCatalogItems(productIds) {
    return _addCustomerCatalogItems.apply(this, arguments);
}
function _addCustomerCatalogItems() {
    _addCustomerCatalogItems = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(productIds) {
        var _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_0__/* .POST */ .a4)((_tmp.url = "".concat(FRONTEND_APIS_PREFIX, "/screen/customer-catalog/add"), _tmp.body = {
                    productIds: productIds
                }, _tmp))
            ];
        });
    });
    return _addCustomerCatalogItems.apply(this, arguments);
}
function removeCustomerCatalogItems(productIds) {
    return _removeCustomerCatalogItems.apply(this, arguments);
}
function _removeCustomerCatalogItems() {
    _removeCustomerCatalogItems = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(productIds) {
        var _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_0__/* .PUT */ .uO)((_tmp.url = "".concat(FRONTEND_APIS_PREFIX, "/screen/customer-catalog/remove"), _tmp.body = {
                    productIds: productIds
                }, _tmp))
            ];
        });
    });
    return _removeCustomerCatalogItems.apply(this, arguments);
}
function pinCustomerCatalogItem(_) {
    return _pinCustomerCatalogItem.apply(this, arguments);
}
function _pinCustomerCatalogItem() {
    _pinCustomerCatalogItem = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(param) {
        var productId, isPinned, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            productId = param.productId, isPinned = param.isPinned;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_0__/* .PUT */ .uO)((_tmp.url = "".concat(FRONTEND_APIS_PREFIX, "/screen/customer-catalog/pin"), _tmp.body = {
                    productId: productId,
                    isPinned: isPinned
                }, _tmp))
            ];
        });
    });
    return _pinCustomerCatalogItem.apply(this, arguments);
}
// "Tên thuốc hay dùng" khách tự đặt cho product; alias rỗng = xoá tên
function updateCustomerCatalogAlias(_) {
    return _updateCustomerCatalogAlias.apply(this, arguments);
}
function _updateCustomerCatalogAlias() {
    _updateCustomerCatalogAlias = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(param) {
        var productId, alias, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            productId = param.productId, alias = param.alias;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_0__/* .PUT */ .uO)((_tmp.url = "".concat(FRONTEND_APIS_PREFIX, "/screen/customer-catalog/alias"), _tmp.body = {
                    productId: productId,
                    alias: alias
                }, _tmp))
            ];
        });
    });
    return _updateCustomerCatalogAlias.apply(this, arguments);
}
function arrangeCustomerCatalog(productIds) {
    return _arrangeCustomerCatalog.apply(this, arguments);
}
function _arrangeCustomerCatalog() {
    _arrangeCustomerCatalog = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(productIds) {
        var _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_0__/* .PUT */ .uO)((_tmp.url = "".concat(FRONTEND_APIS_PREFIX, "/screen/customer-catalog/arrange"), _tmp.body = {
                    productIds: productIds
                }, _tmp))
            ];
        });
    });
    return _arrangeCustomerCatalog.apply(this, arguments);
}


/***/ }),

/***/ 20616:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var constants_data__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66520);
/* harmony import */ var _Clients__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38307);
/* harmony import */ var _ProductClientV2__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22997);





function searchKeywords(keyword) {
    return _searchKeywords.apply(this, arguments);
}
function _searchKeywords() {
    _searchKeywords = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(keyword) {
        var body, _tmp, res, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    body = (_tmp.text = keyword, _tmp.offset = 0, _tmp.limit = constants_data__WEBPACK_IMPORTED_MODULE_0__/* .PAGE_SIZE_30 */ .AV, _tmp);
                    _tmp1 = {};
                    return [
                        4,
                        (0,_ProductClientV2__WEBPACK_IMPORTED_MODULE_2__/* .getFuzzySearchClient */ .Qm)((_tmp1.body = body, _tmp1))
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        (0,_Clients__WEBPACK_IMPORTED_MODULE_1__/* .getData */ .Yu)(res)
                    ];
            }
        });
    });
    return _searchKeywords.apply(this, arguments);
}
function searchByKeywords(keyword) {
    return _searchByKeywords.apply(this, arguments);
}
function _searchByKeywords() {
    _searchByKeywords = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(keyword) {
        var hasIngredients, searchStrategy, _tmp, body, _tmp1, _tmp2;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            hasIngredients = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : true;
            _tmp = {};
            searchStrategy = (_tmp.text = true, _tmp.keyword = true, _tmp.ingredient = hasIngredients, _tmp);
            _tmp1 = {};
            body = (_tmp1.text = keyword, _tmp1.offset = 0, _tmp1.limit = constants_data__WEBPACK_IMPORTED_MODULE_0__/* .PAGE_SIZE_30 */ .AV, _tmp1.searchStrategy = searchStrategy, _tmp1);
            _tmp2 = {};
            // const res = await POST({ url, body });
            return [
                2,
                (0,_ProductClientV2__WEBPACK_IMPORTED_MODULE_2__/* .getFuzzySearchClient */ .Qm)((_tmp2.body = body, _tmp2))
            ];
        });
    });
    return _searchByKeywords.apply(this, arguments);
}
/* harmony default export */ __webpack_exports__["Z"] = ({
    searchKeywords: searchKeywords,
    searchByKeywords: searchByKeywords
});


/***/ }),

/***/ 1553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Header_CountDownBar; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/atoms/LinkComp/index.js
var LinkComp = __webpack_require__(24618);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./src/clients/MarketingClient.js
var MarketingClient = __webpack_require__(13124);
// EXTERNAL MODULE: ./src/context/Auth/index.js + 4 modules
var Auth = __webpack_require__(95581);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/sysconfig/index.js
var sysconfig = __webpack_require__(66225);
// EXTERNAL MODULE: ./src/utils/localStorageUtils.js
var localStorageUtils = __webpack_require__(49327);
// EXTERNAL MODULE: ./src/clients/AddressClient.js
var AddressClient = __webpack_require__(79836);
;// CONCATENATED MODULE: ./src/hooks/useRegions.js






function useRegions() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ttl = ref.ttl, ttl = _ttl === void 0 ? sysconfig/* TTL_CACHE_LOCAL */.m1 * 1000 : _ttl;
    var FIELDS = [
        "code",
        "name",
        "provinceCodes"
    ];
    var getRegionByCode = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(code) {
            var ref, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getRegionMapByCodes([
                                code
                            ])
                        ];
                    case 1:
                        data = _state.sent();
                        return [
                            2,
                            (ref = Object.values(data)) === null || ref === void 0 ? void 0 : ref[0]
                        ];
                }
            });
        });
        return function(code) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    var getRegionMapByCodes = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(codes) {
            var regions, _tmp, missingCodes, cachedRegions, _tmp1, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, code, region, res, _tmp2, _tmp3;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        regions = _tmp;
                        missingCodes = [];
                        _tmp1 = {};
                        cachedRegions = (0,localStorageUtils/* getWithExpiry */.jE)(localStorageUtils/* CACHE_KEY.REGIONS */.oy.REGIONS) || _tmp1;
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(_iterator = codes[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                code = _step.value;
                                if (code === "00") continue; // Don't map region_code for TOANQUOC
                                if (cachedRegions[code]) {
                                    region = (0,localStorageUtils/* deserializeFunc */.OW)(cachedRegions[code], FIELDS);
                                    regions[code] = region;
                                } else {
                                    missingCodes.push(code);
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        if (!(missingCodes.length > 0)) return [
                            3,
                            2
                        ];
                        _tmp2 = {};
                        return [
                            4,
                            (0,AddressClient/* getRegions */.JL)((_tmp2.codes = missingCodes, _tmp2))
                        ];
                    case 1:
                        res = _state.sent();
                        _tmp3 = {};
                        if (res.status !== "OK") {
                            console.error("[Error] Get regions", res);
                        } else {
                            res.data.forEach(function(region) {
                                var serializedData = (0,localStorageUtils/* serializeFunc */.eX)(region, FIELDS);
                                cachedRegions[region.code] = serializedData;
                                regions[region.code] = (0,localStorageUtils/* deserializeFunc */.OW)(serializedData, FIELDS);
                            });
                            // Update cache
                            (0,localStorageUtils/* setWithExpiry */.w4)(localStorageUtils/* CACHE_KEY.REGIONS */.oy.REGIONS, cachedRegions, (_tmp3.ttl = ttl, _tmp3));
                        }
                        _state.label = 2;
                    case 2:
                        return [
                            2,
                            regions
                        ];
                }
            });
        });
        return function(codes) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    return {
        getRegionByCode: getRegionByCode,
        getRegionMapByCodes: getRegionMapByCodes
    };
}

;// CONCATENATED MODULE: ./src/hooks/useCountdownBars.js









function useCountdownBars() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ttl = ref.ttl, ttl = _ttl === void 0 ? sysconfig/* TTL_CACHE_SERVER */.dq * 1000 : _ttl;
    var ref1 = (0,react.useState)([]), countdownBarList = ref1[0], setCountdownBarList = ref1[1];
    var getRegionMapByCodes = useRegions().getRegionMapByCodes;
    var user = (0,Auth/* useAuth */.aC)().user;
    (0,react.useEffect)(function() {
        (0,_async_to_generator/* default */.Z)(function() {
            var key, countdownBars, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        key = "".concat(localStorageUtils/* CACHE_KEY.COUNTDOWNBAR */.oy.COUNTDOWNBAR).concat(user === null || user === void 0 ? void 0 : user.provinceCode, "_").concat((user === null || user === void 0 ? void 0 : user.customerID) || "guest");
                        countdownBars = (0,localStorageUtils/* getWithExpiry */.jE)(key);
                        if (!!countdownBars) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            getActiveCountdownBars(getRegionMapByCodes, user)
                        ];
                    case 1:
                        countdownBars = _state.sent();
                        _tmp = {};
                        (0,localStorageUtils/* setWithExpiry */.w4)(key, countdownBars, (_tmp.ttl = ttl, _tmp));
                        _state.label = 2;
                    case 2:
                        setCountdownBarList(countdownBars);
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        user
    ]);
    return {
        countdownBarList: countdownBarList
    };
}
function getActiveCountdownBars(getRegionMapByCodes, user) {
    return _getActiveCountdownBars.apply(this, arguments);
}
function _getActiveCountdownBars() {
    _getActiveCountdownBars = (0,_async_to_generator/* default */.Z)(function(getRegionMapByCodes, user) {
        var countdownBarRes, countdownBarList, regionCodesToFetch, mapRegionWithProvinces, nationwideCountdownBar, userProvinceCountdownBar;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,MarketingClient/* getCountdownBarList */.iE)()
                    ];
                case 1:
                    countdownBarRes = _state.sent();
                    countdownBarList = ((countdownBarRes === null || countdownBarRes === void 0 ? void 0 : countdownBarRes.data) || []).filter(function(item) {
                        if (!(item === null || item === void 0 ? void 0 : item.isActive)) return false;
                        var currentTime = new Date();
                        var startDisplayTime = new Date(item.startDisplayTime);
                        if (currentTime < startDisplayTime) return false;
                        var endDisplayTime = new Date(item.endDisplayTime);
                        if (currentTime > endDisplayTime) return false;
                        return true;
                    }).sort(function(cd1, cd2) {
                        return new Date(cd2 === null || cd2 === void 0 ? void 0 : cd2.startDisplayTime) - new Date(cd1 === null || cd1 === void 0 ? void 0 : cd1.startDisplayTime);
                    });
                    regionCodesToFetch = countdownBarList.map(function(c) {
                        return c.regionCodes || [];
                    }).flat();
                    return [
                        4,
                        getRegionMapByCodes(regionCodesToFetch)
                    ];
                case 2:
                    mapRegionWithProvinces = _state.sent();
                    nationwideCountdownBar = [];
                    userProvinceCountdownBar = [];
                    countdownBarList.forEach(function(param) {
                        var _imageType = param.imageType, imageType = _imageType === void 0 ? "" : _imageType, _imageUrl = param.imageUrl, imageUrl = _imageUrl === void 0 ? "" : _imageUrl, _name = param.name, name = _name === void 0 ? "" : _name, _type = param.type, type = _type === void 0 ? "" : _type, _url = param.url, url = _url === void 0 ? "" : _url, _code = param.code, code = _code === void 0 ? "" : _code, _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? "" : _backgroundColor, _countdownbarID = param.countdownbarID, countdownbarID = _countdownbarID === void 0 ? "" : _countdownbarID, _regionCodes = param.regionCodes, regionCodes = _regionCodes === void 0 ? [] : _regionCodes;
                        var ref, ref1;
                        var provinceCodes = [];
                        regionCodes.forEach(function(regionCode) {
                            var ref;
                            provinceCodes = provinceCodes.concat(((ref = mapRegionWithProvinces[regionCode]) === null || ref === void 0 ? void 0 : ref.provinceCodes) || []);
                        });
                        var item = {
                            imageType: imageType,
                            imageUrl: imageUrl,
                            name: name,
                            type: type,
                            url: url,
                            code: code,
                            backgroundColor: backgroundColor,
                            countdownbarID: countdownbarID,
                            regionCodes: regionCodes,
                            provinceCodes: provinceCodes
                        };
                        if ((ref = item.provinceCodes) === null || ref === void 0 ? void 0 : ref.includes(user === null || user === void 0 ? void 0 : user.provinceCode)) {
                            userProvinceCountdownBar.push(item);
                        } else if ((ref1 = item.regionCodes) === null || ref1 === void 0 ? void 0 : ref1.includes("00")) {
                            nationwideCountdownBar.push(item);
                        }
                    });
                    return [
                        2,
                        (0,_to_consumable_array/* default */.Z)(userProvinceCountdownBar).concat((0,_to_consumable_array/* default */.Z)(nationwideCountdownBar))
                    ];
            }
        });
    });
    return _getActiveCountdownBars.apply(this, arguments);
}

// EXTERNAL MODULE: ./src/utils/ImageFallback.tsx
var ImageFallback = __webpack_require__(43931);
// EXTERNAL MODULE: ./src/utils/gtag.js
var gtag = __webpack_require__(57059);
// EXTERNAL MODULE: ./src/components-v2/layout/Header/header.js
var header = __webpack_require__(49752);
// EXTERNAL MODULE: ./src/components-v2/layout/Header/styles.module.css
var styles_module = __webpack_require__(4530);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components-v2/layout/Header/CountDownBar.js








function CountDownBar(param) {
    var _type = param.type, type = _type === void 0 ? header/* ENUM_COUNTDOWN_BAR_TYPE.WEBSITE */.c.WEBSITE : _type;
    var countdownBarList = useCountdownBars().countdownBarList;
    // Chỉ lấy countdown bar cài cho vị trí này; bar cũ không có type coi như WEBSITE
    var countdownBarByType = countdownBarList.filter(function(cd) {
        return ((cd === null || cd === void 0 ? void 0 : cd.type) || header/* ENUM_COUNTDOWN_BAR_TYPE.WEBSITE */.c.WEBSITE) === type;
    });
    var countdownBarHalf = countdownBarByType.filter(function(cd) {
        return (cd === null || cd === void 0 ? void 0 : cd.imageType) === header/* ENUM_COUNTDOWN_BAR_IMAGE_TYPE.HALF */.t.HALF;
    });
    var countdownBarFull = countdownBarByType.filter(function(cd) {
        return (cd === null || cd === void 0 ? void 0 : cd.imageType) === header/* ENUM_COUNTDOWN_BAR_IMAGE_TYPE.FULL */.t.FULL;
    });
    // tracking impresssion
    (0,react.useEffect)(function() {
        if ((countdownBarHalf === null || countdownBarHalf === void 0 ? void 0 : countdownBarHalf.length) >= 2 || (countdownBarFull === null || countdownBarFull === void 0 ? void 0 : countdownBarFull.length) > 0) {
            gtag/* default.displayCountDownBar */.ZP.displayCountDownBar();
        }
    }, [
        countdownBarHalf,
        countdownBarFull
    ]);
    if ((countdownBarHalf === null || countdownBarHalf === void 0 ? void 0 : countdownBarHalf.length) >= 2) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (styles_module_default()).countdownBarHalfWrapper,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).countdownBarHalf,
                children: countdownBarHalf.slice(0, 2).reverse().map(function(cd) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).countdownBarHalfLimit,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkComp/* default */.Z, {
                            href: cd.url,
                            style: {
                                padding: 0
                            },
                            onClick: function() {
                                return gtag/* default.clickCountdownbar */.ZP.clickCountdownbar(cd);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackBanner */.Up, {
                                isGIF: true,
                                src: cd.imageUrl,
                                fallbackSrc: cd.imageUrl,
                                objectFit: "contain",
                                quality: 100,
                                layout: "fill",
                                width: 2100,
                                alt: cd.name,
                                priority: true
                            })
                        })
                    }, cd.code);
                })
            })
        });
    }
    if ((countdownBarFull === null || countdownBarFull === void 0 ? void 0 : countdownBarFull.length) > 0) {
        var cd = countdownBarFull[0];
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkComp/* default */.Z, {
            href: cd === null || cd === void 0 ? void 0 : cd.url,
            style: {
                padding: 0
            },
            onClick: function() {
                return gtag/* default.clickCountdownbar */.ZP.clickCountdownbar(cd);
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).countdownBarFullWrapper,
                style: {
                    backgroundColor: (cd === null || cd === void 0 ? void 0 : cd.backgroundColor) || "#fff"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackBanner */.Up, {
                    isGIF: true,
                    src: cd.imageUrl,
                    fallbackSrc: cd.imageUrl,
                    layout: "fill",
                    width: 2100,
                    alt: cd.name,
                    priority: true
                })
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
}
/* harmony default export */ var Header_CountDownBar = (/*#__PURE__*/(0,react.memo)(CountDownBar));


/***/ }),

/***/ 49752:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ ENUM_COUNTDOWN_BAR_TYPE; },
/* harmony export */   "t": function() { return /* binding */ ENUM_COUNTDOWN_BAR_IMAGE_TYPE; }
/* harmony export */ });
var ENUM_COUNTDOWN_BAR_IMAGE_TYPE = {
    HALF: "HALF",
    FULL: "FULL"
};
// Vị trí hiển thị, khớp "Tùy chọn cài đặt" trên CMS marketing
var ENUM_COUNTDOWN_BAR_TYPE = {
    WEBSITE: "WEBSITE",
    PRODUCT_CATALOG: "PRODUCT_CATALOG"
};


/***/ }),

/***/ 30203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ layout_Header; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(40872);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ButtonBase/ButtonBase.js + 2 modules
var ButtonBase = __webpack_require__(4024);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(868);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(19238);
// EXTERNAL MODULE: ./node_modules/@mui/material/Skeleton/Skeleton.js + 1 modules
var Skeleton = __webpack_require__(18979);
// EXTERNAL MODULE: ./src/clients/Clients.js + 1 modules
var Clients = __webpack_require__(38307);
// EXTERNAL MODULE: ./src/clients/WebServiceClient.js
var WebServiceClient = __webpack_require__(91952);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
;// CONCATENATED MODULE: ./src/components-v2/atoms/CatalogMenuIcon.js
// Icon mục "Danh mục thuốc đang bán": sổ danh mục có dấu tick, vẽ bằng currentColor để đổi màu khi active

function CatalogMenuIcon(param) {
    var _size = param.size, size = _size === void 0 ? 24 : _size, _color = param.color, color = _color === void 0 ? "currentColor" : _color, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "1.7",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: className,
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "4",
                y: "3",
                width: "16",
                height: "18",
                rx: "2.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9 3v2.5a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.5 11.5h7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.5 15h4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m14.5 14.6 1.2 1.2 2.3-2.4"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components-v2/atoms/PremiumStarIcon/index.tsx

// Huy hiệu ngôi sao của gói Premium: badge, menu và avatar dùng chung.
var PremiumStarIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 16 : _size;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "8",
                cy: "8",
                r: "7.1",
                fill: "#1F1F1F",
                stroke: "#D9A536",
                strokeWidth: "1.3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 3.9l1.29 2.62 2.89.42-2.09 2.04.49 2.88L8 10.5l-2.58 1.36.49-2.88L3.82 6.94l2.89-.42L8 3.9z",
                fill: "#FFAC00"
            })
        ]
    });
};
/* harmony default export */ var atoms_PremiumStarIcon = (PremiumStarIcon);

// EXTERNAL MODULE: ./src/components-v2/mocules/NewNotification/interface.ts
var NewNotification_interface = __webpack_require__(1307);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Fade/Fade.js
var Fade = __webpack_require__(73637);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Menu/Menu.js
var Menu = __webpack_require__(38396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tab/Tab.js
var Tab = __webpack_require__(41423);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/TabContext/TabContext.js
var TabContext = __webpack_require__(78207);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/TabList/TabList.js
var TabList = __webpack_require__(37313);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/TabPanel/TabPanel.js
var TabPanel = __webpack_require__(64532);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 1 modules
var styled = __webpack_require__(14745);
// EXTERNAL MODULE: ./src/components/atoms/LinkComp/index.js
var LinkComp = __webpack_require__(24618);
// EXTERNAL MODULE: ./src/components/organisms/LoadingScreen/index.js
var LoadingScreen = __webpack_require__(37071);
// EXTERNAL MODULE: ./src/context/Notifications/index.js + 1 modules
var Notifications = __webpack_require__(37022);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components-v2/mocules/NewNotification/constant.ts
var constant = __webpack_require__(7813);
// EXTERNAL MODULE: ./src/utils/DateTimeUtils.js
var DateTimeUtils = __webpack_require__(33213);
// EXTERNAL MODULE: ./src/components-v2/layout/Header/Notification/Child/styles.module.css
var styles_module = __webpack_require__(10916);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components-v2/layout/Header/Notification/Child/index.tsx












var StyledBox = (0,styled/* default */.ZP)(function(boxProps) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, (0,_object_spread/* default */.Z)({}, boxProps));
})({
    maxWidth: "max-content",
    borderRadius: 4
});
function NotificationChild(param) {
    var notification = param.notification;
    var ref;
    var markReadByCode = (0,Notifications/* useNotify */.d$)().markReadByCode;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            notification.date !== "H\xf4m nay" && /*#__PURE__*/ (0,jsx_runtime.jsx)(DateLabel, {
                label: notification.date
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                children: (ref = notification.noti) === null || ref === void 0 ? void 0 : ref.map(function(child) {
                    var isRead = child.isRead, title = child.title, link = child.link, code = child.code, tags = child.tags, createdTime = child.createdTime;
                    var currentLinkPromotion = "/users/user-promo-codes";
                    var targetLinkPromotion = "/users/my-voucher";
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkComp/* default */.Z, {
                        onClick: function() {
                            return !isRead ? markReadByCode(code) : "";
                        },
                        href: link === currentLinkPromotion ? targetLinkPromotion : link,
                        className: isRead ? (0,clsx/* default */.Z)((styles_module_default()).notificationsItem, (styles_module_default()).read) : (0,clsx/* default */.Z)((styles_module_default()).notificationsItem, (styles_module_default()).unRead),
                        name: undefined,
                        onMouseOver: undefined,
                        target: undefined,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            display: "flex",
                            flexDirection: "column",
                            gap: "8px",
                            width: "100%",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationTag, {
                                    tags: tags,
                                    createdTime: createdTime
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    className: (styles_module_default()).notificationChild_container,
                                    display: "flex",
                                    gap: "12px",
                                    gridColumnGap: 12,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            className: (styles_module_default()).isRead,
                                            children: !isRead && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                className: (styles_module_default()).notification_indicator
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "8px",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                style: {
                                                    color: "#797979",
                                                    fontSize: 14,
                                                    fontFamily: "ggsr",
                                                    fontWeight: 400
                                                },
                                                dangerouslySetInnerHTML: {
                                                    __html: title
                                                }
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }, code);
                })
            })
        ]
    });
};
var NotificationTag = function(param) {
    var tags = param.tags, createdTime = param.createdTime;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Box/* default */.Z, {
        display: "flex",
        gap: "4px",
        justifyContent: "space-between",
        marginLeft: "20px",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            display: "flex",
            gap: "8px",
            flexWrap: "wrap",
            children: [
                tags !== undefined && (tags === null || tags === void 0 ? void 0 : tags.length) > 0 ? tags === null || tags === void 0 ? void 0 : tags.map(function(tag) {
                    var ref, ref1, ref2;
                    return tag !== NewNotification_interface/* ENUM_NOTIFICATION_TAG.IMPORTANT */.T.IMPORTANT && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBox, {
                        bgcolor: constant/* NotificationTagColor */.u === null || constant/* NotificationTagColor */.u === void 0 ? void 0 : (ref = constant/* NotificationTagColor */.u[tag]) === null || ref === void 0 ? void 0 : ref.background,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: (styles_module_default()).notification_label,
                            variant: "body2",
                            style: {
                                color: constant/* NotificationTagColor */.u === null || constant/* NotificationTagColor */.u === void 0 ? void 0 : (ref1 = constant/* NotificationTagColor */.u[tag]) === null || ref1 === void 0 ? void 0 : ref1.text,
                                border: "1px solid ".concat(constant/* NotificationTagColor */.u === null || constant/* NotificationTagColor */.u === void 0 ? void 0 : (ref2 = constant/* NotificationTagColor */.u[tag]) === null || ref2 === void 0 ? void 0 : ref2.border)
                            },
                            children: constant/* NotificationTagLabel */.n[tag]
                        })
                    });
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBox, {
                    bgcolor: "transparent",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: (styles_module_default()).notification_label,
                        variant: "body2"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                    className: (styles_module_default()).createdAt,
                    children: DateTimeUtils/* default.getTimeAgo */.ZP.getTimeAgo(createdTime)
                })
            ]
        })
    });
};
var DateLabel = function(param) {
    var label = param.label;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        className: (styles_module_default()).dateLabel,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
            children: label
        })
    });
};

// EXTERNAL MODULE: ./src/components-v2/layout/Header/Notification/Tabs/styles.module.css
var Tabs_styles_module = __webpack_require__(36142);
var Tabs_styles_module_default = /*#__PURE__*/__webpack_require__.n(Tabs_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/layout/Header/Notification/Tabs/index.tsx


















var StyledTabs = (0,styled/* default */.ZP)(function(tabsProps) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TabList/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tabsProps), {
        TabIndicatorProps: {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "MuiTabs-indicatorSpan"
            })
        }
    }));
})({
    borderBottom: "1px solid #e9e9e9",
    "& .MuiTabs-indicator": {
        display: "flex",
        justifyContent: "center",
        backgroundColor: "transparent"
    },
    "& .MuiTabs-indicatorSpan": {
        maxWidth: 120,
        width: "100%",
        backgroundColor: "#005C29"
    },
    "& .MuiTab-root": {
        minWidth: "unset",
        width: "calc(100%/3)"
    }
});
var StyledTab = (0,styled/* default */.ZP)(function(tabsProps) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, (0,_object_spread/* default */.Z)({
        disableRipple: true
    }, tabsProps));
})(function() {
    return {
        textTransform: "none",
        "&.Mui-selected": {
            color: "#005C29"
        },
        "&.Mui-select ": {
            backgroundColor: "#edfef6",
            color: "#005C29",
            padding: "0 4px"
        }
    };
});
function NotificationTabs(param) {
    var notiTab = param.notiTab, handleSwitchTab = param.handleSwitchTab;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
    var ref16 = (0,Notifications/* useNotify */.d$)(), notification = ref16.notification, numberNotifyWithTab = ref16.numberNotifyWithTab, isLoadingNotify = ref16.isLoadingNotify;
    (0,react.useEffect)(function() {
        handleSwitchTab === null || handleSwitchTab === void 0 ? void 0 : handleSwitchTab(NewNotification_interface/* ENUM_NOTIFICATION_TAB.IMPORTANT */.V.IMPORTANT);
    }, []);
    // update height for popup notify, always make height fit with data
    (0,react.useLayoutEffect)(function() {
        var ref;
        document.querySelectorAll("#newNotifyMenu ul .tabPanel").forEach(function(link, _) {
            link.style.removeProperty("height");
        });
        document.querySelectorAll('#newNotifyMenu [class*="MuiPaper-root"]').forEach(function(link, _) {
            var ref;
            (ref = link) === null || ref === void 0 ? void 0 : ref.style.removeProperty("height");
        });
        var getHeight = (ref = document.querySelector("#newNotifyMenu ul")) === null || ref === void 0 ? void 0 : ref.clientHeight;
        if (getHeight) {
            var calcHeight = getHeight - 100;
            document.querySelectorAll("#newNotifyMenu ul .tabPanel").forEach(function(link, _) {
                link.style.setProperty("height", "".concat(calcHeight, "px"));
            });
            document.querySelectorAll('#newNotifyMenu [class*="MuiPaper-root"]').forEach(function(link, _) {
                var ref;
                (ref = link) === null || ref === void 0 ? void 0 : ref.style.setProperty("height", "".concat(getHeight, "px"));
            });
        }
        return function() {
            document.querySelectorAll("#newNotifyMenu ul .tabPanel").forEach(function(link, index) {
                link.style.removeProperty("height");
            });
            document.querySelectorAll('#newNotifyMenu [class*="MuiPaper-root"]').forEach(function(link, _) {
                var ref;
                (ref = link) === null || ref === void 0 ? void 0 : ref.style.removeProperty("height");
            });
        };
    }, [
        notiTab,
        isLoadingNotify
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            id: "notificationTab_container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabContext/* default */.ZP, {
                value: notiTab,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTabs, {
                        onChange: function(_, value) {
                            return handleSwitchTab(value);
                        },
                        className: (Tabs_styles_module_default()).notification_container,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTab, {
                                className: (Tabs_styles_module_default()).labelTab,
                                value: NewNotification_interface/* ENUM_NOTIFICATION_TAB.IMPORTANT */.V.IMPORTANT,
                                label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    display: "flex",
                                    gap: "4px",
                                    children: [
                                        "Quan trọng",
                                        " ",
                                        (numberNotifyWithTab === null || numberNotifyWithTab === void 0 ? void 0 : (ref = numberNotifyWithTab.important) === null || ref === void 0 ? void 0 : ref.unread) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (Tabs_styles_module_default()).numNoti,
                                            children: (numberNotifyWithTab === null || numberNotifyWithTab === void 0 ? void 0 : (ref1 = numberNotifyWithTab.important) === null || ref1 === void 0 ? void 0 : ref1.unread) || 0
                                        }) : null,
                                        " "
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTab, {
                                className: (Tabs_styles_module_default()).labelTab,
                                value: NewNotification_interface/* ENUM_NOTIFICATION_TAB.PRODUCT */.V.PRODUCT,
                                label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    display: "flex",
                                    gap: "4px",
                                    children: [
                                        "Sản phẩm",
                                        " ",
                                        (numberNotifyWithTab === null || numberNotifyWithTab === void 0 ? void 0 : (ref2 = numberNotifyWithTab.product) === null || ref2 === void 0 ? void 0 : ref2.unread) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (Tabs_styles_module_default()).numNoti,
                                            children: (numberNotifyWithTab === null || numberNotifyWithTab === void 0 ? void 0 : (ref3 = numberNotifyWithTab.product) === null || ref3 === void 0 ? void 0 : ref3.unread) || 0
                                        }) : null,
                                        " "
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTab, {
                                className: (Tabs_styles_module_default()).labelTab,
                                value: NewNotification_interface/* ENUM_NOTIFICATION_TAB.PROMOTION */.V.PROMOTION,
                                label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    display: "flex",
                                    gap: "4px",
                                    children: [
                                        "Khuyến m\xe3i",
                                        " ",
                                        (numberNotifyWithTab === null || numberNotifyWithTab === void 0 ? void 0 : (ref4 = numberNotifyWithTab.promotion) === null || ref4 === void 0 ? void 0 : ref4.unread) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (Tabs_styles_module_default()).numNoti,
                                            children: (numberNotifyWithTab === null || numberNotifyWithTab === void 0 ? void 0 : (ref5 = numberNotifyWithTab.promotion) === null || ref5 === void 0 ? void 0 : ref5.unread) || 0
                                        }) : null,
                                        " "
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabPanel/* default */.Z, {
                        value: NewNotification_interface/* ENUM_NOTIFICATION_TAB.IMPORTANT */.V.IMPORTANT,
                        className: (0,clsx/* default */.Z)((Tabs_styles_module_default()).tabPanel_container, ((ref6 = notification.important) === null || ref6 === void 0 ? void 0 : ref6.length) > 0 && (Tabs_styles_module_default()).tabPanel_containerWithData, "tabPanel"),
                        children: isLoadingNotify ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            className: (Tabs_styles_module_default()).loadingContainer,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingScreen/* default */.Z, {})
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            className: (0,clsx/* default */.Z)((Tabs_styles_module_default()).notifyWrap, (Tabs_styles_module_default()).notification_list, (Tabs_styles_module_default()).notification_tabContainer),
                            children: ((ref7 = notification.important) === null || ref7 === void 0 ? void 0 : ref7.length) > 0 ? (ref8 = notification.important) === null || ref8 === void 0 ? void 0 : ref8.map(function(item) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationChild, {
                                    notification: item
                                });
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyNotification, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabPanel/* default */.Z, {
                        value: NewNotification_interface/* ENUM_NOTIFICATION_TAB.PRODUCT */.V.PRODUCT,
                        className: (0,clsx/* default */.Z)((Tabs_styles_module_default()).tabPanel_container, ((ref9 = notification.product) === null || ref9 === void 0 ? void 0 : ref9.length) > 0 && (Tabs_styles_module_default()).tabPanel_containerWithData, "tabPanel"),
                        children: isLoadingNotify ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            className: (Tabs_styles_module_default()).loadingContainer,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingScreen/* default */.Z, {})
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            className: (0,clsx/* default */.Z)((Tabs_styles_module_default()).notifyWrap, (Tabs_styles_module_default()).notification_list, (Tabs_styles_module_default()).notification_tabContainer),
                            children: ((ref10 = notification.product) === null || ref10 === void 0 ? void 0 : ref10.length) > 0 ? (ref11 = notification.product) === null || ref11 === void 0 ? void 0 : ref11.map(function(item) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationChild, {
                                    notification: item
                                });
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyNotification, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabPanel/* default */.Z, {
                        value: NewNotification_interface/* ENUM_NOTIFICATION_TAB.PROMOTION */.V.PROMOTION,
                        className: (0,clsx/* default */.Z)((Tabs_styles_module_default()).tabPanel_container, ((ref12 = notification.promotion) === null || ref12 === void 0 ? void 0 : ref12.length) > 0 && (Tabs_styles_module_default()).tabPanel_containerWithData, "tabPanel"),
                        children: isLoadingNotify ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            className: (Tabs_styles_module_default()).loadingContainer,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingScreen/* default */.Z, {})
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            className: (0,clsx/* default */.Z)((Tabs_styles_module_default()).notifyWrap, (Tabs_styles_module_default()).notification_list, (Tabs_styles_module_default()).notification_tabContainer),
                            children: ((ref13 = notification.promotion) === null || ref13 === void 0 ? void 0 : ref13.length) > 0 ? (ref14 = notification.promotion) === null || ref14 === void 0 ? void 0 : ref14.map(function(item) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationChild, {
                                    notification: item
                                });
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyNotification, {})
                        })
                    }),
                    !isLoadingNotify && (notification === null || notification === void 0 ? void 0 : (ref15 = notification[notiTab.toLowerCase()]) === null || ref15 === void 0 ? void 0 : ref15.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        className: (Tabs_styles_module_default()).seeMore_container,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkComp/* default */.Z, {
                            className: (Tabs_styles_module_default()).viewAll,
                            href: "/notifications?tab=".concat(notiTab),
                            name: undefined,
                            onMouseOver: undefined,
                            target: undefined,
                            onClick: undefined,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                display: "inline",
                                className: (Tabs_styles_module_default()).viewAllTitle,
                                children: "Xem tất cả"
                            })
                        })
                    })
                ]
            })
        })
    });
};
var EmptyNotification = function() {
    var message = "Hiện tại bạn kh\xf4ng c\xf3 th\xf4ng b\xe1o mới.";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        className: (Tabs_styles_module_default()).emptyNotification,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
            children: message
        })
    });
};

// EXTERNAL MODULE: ./src/constants/Images/index.js
var Images = __webpack_require__(13270);
// EXTERNAL MODULE: ./src/context/Auth/index.js + 4 modules
var Auth = __webpack_require__(95581);
// EXTERNAL MODULE: ./src/utils/ImageFallback.tsx
var ImageFallback = __webpack_require__(43931);
// EXTERNAL MODULE: ./src/components-v2/mocules/NotiComp/styles.module.css
var NotiComp_styles_module = __webpack_require__(19466);
var NotiComp_styles_module_default = /*#__PURE__*/__webpack_require__.n(NotiComp_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/mocules/NotiComp/index.js















function NotiComp() {
    var ref = (0,Notifications/* useNotify */.d$)(), markAll = ref.markAll, numberNotifyWithTab = ref.numberNotifyWithTab, fetchDataByTab = ref.fetchDataByTab, unreadNotification = ref.unread;
    var reloadDataCustomer = (0,Auth/* useAuth */.aC)().reloadDataCustomer;
    var ref1 = (0,react.useState)(null), anchorEl = ref1[0], setAnchorEl = ref1[1];
    var ref2 = (0,react.useState)(NewNotification_interface/* ENUM_NOTIFICATION_TAB.IMPORTANT */.V.IMPORTANT), notiTab = ref2[0], setNotiTab = ref2[1];
    var open = Boolean(anchorEl);
    var handleClick = function(event) {
        var ref;
        if (notiTab && (numberNotifyWithTab === null || numberNotifyWithTab === void 0 ? void 0 : (ref = numberNotifyWithTab[notiTab.toLowerCase()]) === null || ref === void 0 ? void 0 : ref.unread) > 0) {
            markAll(notiTab, false);
        }
        setAnchorEl(event === null || event === void 0 ? void 0 : event.currentTarget);
        reloadDataCustomer();
    };
    var handleClose = function() {
        setAnchorEl(null);
    };
    var handleSwitchTab = function(tab) {
        var ref;
        setNotiTab(tab);
        fetchDataByTab(tab);
        if ((NewNotification_interface/* ENUM_NOTIFICATION_TAB */.V === null || NewNotification_interface/* ENUM_NOTIFICATION_TAB */.V === void 0 ? void 0 : NewNotification_interface/* ENUM_NOTIFICATION_TAB */.V[tab]) && (numberNotifyWithTab === null || numberNotifyWithTab === void 0 ? void 0 : (ref = numberNotifyWithTab[tab.toLowerCase()]) === null || ref === void 0 ? void 0 : ref.unread) > 0) {
            markAll(tab, false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu/* default */.Z, {
                id: "newNotifyMenu",
                open: open,
                anchorEl: anchorEl,
                onClose: handleClose,
                getContentAnchorEl: null,
                TransitionComponent: Fade/* default */.Z,
                elevation: 0,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "right"
                },
                PaperProps: {
                    style: {
                        transform: "translateY(5px)"
                    }
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "right"
                },
                classes: {
                    paper: (0,clsx/* default */.Z)((NotiComp_styles_module_default()).notifyWrap, (NotiComp_styles_module_default()).newNotificationMenu)
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        className: (NotiComp_styles_module_default()).notifyContentTop,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: (NotiComp_styles_module_default()).notifyTitle,
                                variant: "h5",
                                children: "Th\xf4ng b\xe1o"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationTabs, {
                        notiTab: notiTab,
                        handleSwitchTab: handleSwitchTab
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonBase/* default */.Z, {
                className: (NotiComp_styles_module_default()).notiContainer,
                onClick: handleClick,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (NotiComp_styles_module_default()) === null || (NotiComp_styles_module_default()) === void 0 ? void 0 : (NotiComp_styles_module_default()).badgeContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                                src: Images/* NOTI */.jeW,
                                width: "14px",
                                height: "18px",
                                quality: 100,
                                layout: "fixed"
                            }),
                            unreadNotification > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (NotiComp_styles_module_default()) === null || (NotiComp_styles_module_default()) === void 0 ? void 0 : (NotiComp_styles_module_default()).badge,
                                children: unreadNotification > 99 ? "99+" : unreadNotification
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (NotiComp_styles_module_default()) === null || (NotiComp_styles_module_default()) === void 0 ? void 0 : (NotiComp_styles_module_default()).titleNoti,
                        children: "Th\xf4ng b\xe1o"
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControl/FormControl.js
var FormControl = __webpack_require__(64436);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/InputAdornment/InputAdornment.js
var InputAdornment = __webpack_require__(7397);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/NativeSelect/NativeSelect.js
var NativeSelect = __webpack_require__(75445);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TextField/TextField.js
var TextField = __webpack_require__(39803);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ExpandMore.js
var ExpandMore = __webpack_require__(64566);
// EXTERNAL MODULE: ./src/clients/SearchClient.js
var SearchClient = __webpack_require__(20616);
// EXTERNAL MODULE: ./src/clients/SellerClient.js
var SellerClient = __webpack_require__(15537);
// EXTERNAL MODULE: ./src/clients/SupplierClient.js
var SupplierClient = __webpack_require__(78369);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Portal/Portal.js
var Portal = __webpack_require__(76234);
// EXTERNAL MODULE: ./src/components-v2/atoms/OverlayV2/styles.module.css
var OverlayV2_styles_module = __webpack_require__(12045);
var OverlayV2_styles_module_default = /*#__PURE__*/__webpack_require__.n(OverlayV2_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/atoms/OverlayV2/index.tsx






function OverlayV2(param) {
    var isOpen = param.isOpen, _level = param.level, level = _level === void 0 ? 2 : _level;
    if (!isOpen) return null;
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Portal/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (0,clsx/* default */.Z)((OverlayV2_styles_module_default()).MenuOverlay, (OverlayV2_styles_module_default())["level-".concat(level)], (_obj = {}, (0,_define_property/* default */.Z)(_obj, (OverlayV2_styles_module_default()).fadeIn, isOpen), (0,_define_property/* default */.Z)(_obj, (OverlayV2_styles_module_default()).fadeOut, !isOpen), _obj))
        })
    });
};

// EXTERNAL MODULE: ./src/constants/Paths/index.js
var Paths = __webpack_require__(199);
// EXTERNAL MODULE: ./src/constants/data/index.js
var constants_data = __webpack_require__(66520);
// EXTERNAL MODULE: ./src/clients/MarketingClient.js
var MarketingClient = __webpack_require__(13124);
// EXTERNAL MODULE: ./src/sysconfig/index.js
var sysconfig = __webpack_require__(66225);
// EXTERNAL MODULE: ./src/utils/localStorageUtils.js
var localStorageUtils = __webpack_require__(49327);
;// CONCATENATED MODULE: ./src/hooks/useHashtagTopSearch.js









function useHashtagTopSearch() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ttl = ref.ttl, ttl = _ttl === void 0 ? sysconfig/* TTL_CACHE_SERVER */.dq * 1000 : _ttl;
    var user = (0,Auth/* useAuth */.aC)().user;
    var ref1 = (0,react.useState)([]), hashtagTopSearch = ref1[0], setHashtagTopSearch = ref1[1];
    var ref2 = (0,react.useState)(true), isLoading = ref2[0], setIsLoading = ref2[1];
    (0,react.useEffect)(function() {
        (0,_async_to_generator/* default */.Z)(function() {
            var hashtags, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsLoading(true);
                        _tmp = {};
                        return [
                            4,
                            getHashtagTopSearches((_tmp.ttl = ttl, _tmp.customerID = user === null || user === void 0 ? void 0 : user.customerID, _tmp))
                        ];
                    case 1:
                        hashtags = _state.sent();
                        setHashtagTopSearch(hashtags);
                        setIsLoading(false);
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        user === null || user === void 0 ? void 0 : user.customerID
    ]);
    return {
        hashtagTopSearch: hashtagTopSearch,
        isLoading: isLoading
    };
}
function getHashtagTopSearches() {
    return _getHashtagTopSearches.apply(this, arguments);
}
function _getHashtagTopSearches() {
    _getHashtagTopSearches = (0,_async_to_generator/* default */.Z)(function() {
        var ref, _ttl, ttl, customerID, _tmp, cacheKey, cachedHashtags, res, _tmp1, hashtags, _tmp2;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : _tmp, _ttl = ref.ttl, ttl = _ttl === void 0 ? sysconfig/* TTL_CACHE_SERVER */.dq * 1000 : _ttl, customerID = ref.customerID;
                    cacheKey = "".concat(localStorageUtils/* CACHE_KEY.HASHTAG_TOP_SEARCH */.oy.HASHTAG_TOP_SEARCH, "_").concat(customerID || "guest");
                    cachedHashtags = (0,localStorageUtils/* getWithExpiry */.jE)(cacheKey);
                    if (cachedHashtags) {
                        return [
                            2,
                            cachedHashtags
                        ];
                    }
                    _tmp1 = {};
                    return [
                        4,
                        (0,MarketingClient/* getListHashtagSearch */.aQ)((_tmp1.isBasic = true, _tmp1))
                    ];
                case 1:
                    res = _state.sent();
                    hashtags = ((res === null || res === void 0 ? void 0 : res.data) || []).filter(function(item) {
                        if (!(item === null || item === void 0 ? void 0 : item.isActive)) return false;
                        var currentTime = new Date();
                        var startDisplayTime = new Date(item.startDisplayTime);
                        if (currentTime < startDisplayTime) return false;
                        var endDisplayTime = new Date(item.endDisplayTime);
                        if (currentTime > endDisplayTime) return false;
                        return true;
                    }).sort(function(hashtag1, hashtag2) {
                        return (hashtag1 === null || hashtag1 === void 0 ? void 0 : hashtag1.ordinalNumber) - (hashtag2 === null || hashtag2 === void 0 ? void 0 : hashtag2.ordinalNumber);
                    }).map(function(_param) {
                        var _code = _param.code, code = _code === void 0 ? "" : _code, _hashtag = _param.hashtag, hashtag = _hashtag === void 0 ? "" : _hashtag, _url = _param.url, url = _url === void 0 ? "" : _url, item = (0,_object_without_properties/* default */.Z)(_param, [
                            "code",
                            "hashtag",
                            "url"
                        ]);
                        return (0,_object_spread/* default */.Z)({
                            code: code,
                            hashtag: hashtag,
                            url: (url === null || url === void 0 ? void 0 : url.startsWith(sysconfig/* WEB_HOST */.Ul)) ? url.replace(sysconfig/* WEB_HOST */.Ul, "") : url
                        }, item);
                    }) || [];
                    _tmp2 = {};
                    (0,localStorageUtils/* setWithExpiry */.w4)(cacheKey, hashtags, (_tmp2.ttl = ttl, _tmp2));
                    return [
                        2,
                        hashtags
                    ];
            }
        });
    });
    return _getHashtagTopSearches.apply(this, arguments);
}

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/services/SellerService.js
var SellerService = __webpack_require__(62510);
// EXTERNAL MODULE: ./src/services/WebService.js + 1 modules
var WebService = __webpack_require__(98682);
// EXTERNAL MODULE: ./src/utils/debounce.js
var debounce = __webpack_require__(74118);
// EXTERNAL MODULE: ./src/utils/deviceUtils.js
var deviceUtils = __webpack_require__(97121);
// EXTERNAL MODULE: ./src/utils/gtag.js
var gtag = __webpack_require__(57059);
// EXTERNAL MODULE: ./src/zustand-lib/useProductList.ts
var useProductList = __webpack_require__(52261);
// EXTERNAL MODULE: ./src/zustand-lib/useSearchResult.js
var useSearchResult = __webpack_require__(80169);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./src/components-v2/atoms/HighlightText/styles.module.css
var HighlightText_styles_module = __webpack_require__(19060);
var HighlightText_styles_module_default = /*#__PURE__*/__webpack_require__.n(HighlightText_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/atoms/HighlightText/index.js





// Tô đậm các đoạn [start, end) do BE trả về (chỉ số code point trên chuỗi NFC)
function HighlightText(param) {
    var _text = param.text, text = _text === void 0 ? "" : _text, _ranges = param.ranges, ranges = _ranges === void 0 ? [] : _ranges, _className = param.className, className = _className === void 0 ? "" : _className;
    if (!text || !(ranges === null || ranges === void 0 ? void 0 : ranges.length)) {
        return text;
    }
    var chars = Array.from(text.normalize("NFC"));
    var parts = [];
    var start = 0;
    ranges.forEach(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), from = _param[0], to = _param[1];
        if (from > start) {
            parts.push(chars.slice(start, from).join(""));
        }
        parts.push(/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (0,clsx/* default */.Z)((HighlightText_styles_module_default()).highlight, className),
            children: chars.slice(from, to).join("")
        }, from));
        start = to;
    });
    if (start < chars.length) {
        parts.push(chars.slice(start).join(""));
    }
    return parts;
}
/* harmony default export */ var atoms_HighlightText = (/*#__PURE__*/(0,react.memo)(HighlightText));

// EXTERNAL MODULE: ./src/constants/Icons/index.js
var Icons = __webpack_require__(43004);
// EXTERNAL MODULE: ./src/services/ProductServiceV2.js
var ProductServiceV2 = __webpack_require__(5108);
// EXTERNAL MODULE: ./src/services/ProductService.js
var ProductService = __webpack_require__(82681);
// EXTERNAL MODULE: ./src/hooks/useIsKcbVerified.js
var useIsKcbVerified = __webpack_require__(7501);
;// CONCATENATED MODULE: ./src/hooks/useMaxHeightToViewportBottom.js

var MIN_HEIGHT = 240;
// Chiều cao tối đa để phần tử kéo dài xuống gần đáy màn hình, chừa `bottomGap` px
function useMaxHeightToViewportBottom() {
    var bottomGap = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 50;
    var ref = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(), maxHeight = ref1[0], setMaxHeight = ref1[1];
    (0,react.useEffect)(function() {
        var updateMaxHeight = function() {
            if (!ref.current) return;
            var top = ref.current.getBoundingClientRect().top;
            setMaxHeight(Math.max(window.innerHeight - top - bottomGap, MIN_HEIGHT));
        };
        updateMaxHeight();
        window.addEventListener("resize", updateMaxHeight);
        return function() {
            return window.removeEventListener("resize", updateMaxHeight);
        };
    }, [
        bottomGap
    ]);
    return [
        ref,
        maxHeight
    ];
};

// EXTERNAL MODULE: ./src/utils/ImageUtils.tsx
var ImageUtils = __webpack_require__(81989);
// EXTERNAL MODULE: ./src/utils/ObjectUtils.js
var ObjectUtils = __webpack_require__(51380);
// EXTERNAL MODULE: ./src/components-v2/mocules/SearchDropdown/styles.module.css
var SearchDropdown_styles_module = __webpack_require__(53426);
var SearchDropdown_styles_module_default = /*#__PURE__*/__webpack_require__.n(SearchDropdown_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/mocules/SearchDropdown/index.js































function MostSearching(param) {
    var handleClickOutside = param.handleClickOutside;
    var ref = useHashtagTopSearch(), hashtagTopSearch = ref.hashtagTopSearch, isLoading = ref.isLoading;
    (0,react.useEffect)(function() {
        if (isLoading) return;
        setTimeout(function() {
            gtag/* default.displayTopSearch */.ZP.displayTopSearch();
            gtag/* default.showTopSearch */.ZP.showTopSearch(hashtagTopSearch);
        }, 300);
    }, [
        isLoading
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (SearchDropdown_styles_module_default()).mostSearching,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                display: "inline",
                className: (SearchDropdown_styles_module_default()).label,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    display: "inline",
                    style: {
                        fontWeight: "500",
                        fontSize: 14
                    },
                    children: "T\xecm kiếm nhiều nhất"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                className: (SearchDropdown_styles_module_default()).results,
                children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: Array.from({
                        length: 2
                    }).map(function(_, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            className: (SearchDropdown_styles_module_default()).tag,
                            variant: "rectangular",
                            animation: "wave",
                            width: 150
                        }, index);
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: hashtagTopSearch.map(function(_tag) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(LinkComp/* default */.Z, {
                            onClick: function() {
                                handleClickOutside(false);
                                gtag/* default.clickTopSearch */.ZP.clickTopSearch(_tag);
                            },
                            href: _tag.url,
                            className: (SearchDropdown_styles_module_default()).tag,
                            "data-test": "search-dropdown-enter",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (SearchDropdown_styles_module_default()).dot
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (SearchDropdown_styles_module_default()).hashtag,
                                    children: _tag.hashtag
                                }),
                                !!(_tag === null || _tag === void 0 ? void 0 : _tag.svgIcon) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                                    width: 16,
                                    height: 16,
                                    objectFit: "contain",
                                    src: (0,ImageUtils/* getLinkProxyFile */.GD)(_tag.svgIcon || ""),
                                    alt: "img"
                                })
                            ]
                        }, _tag.hashtag);
                    })
                })
            })
        ]
    });
}
var RecentSearchTexts = /*#__PURE__*/ (0,react.memo)(function(param) {
    var _texts = param.texts, texts = _texts === void 0 ? [] : _texts, _searchType = param.searchType, searchType = _searchType === void 0 ? 1 : _searchType;
    var handleClickRecentKeyword = function handleClickRecentKeyword(val, searchType) {
        if (router.pathname.includes("[slug]")) {
            delete router.query.slug;
        }
        if (val && searchType) {
            router.push({
                pathname: "/products",
                query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                    q: val,
                    searchType: searchType
                })
            });
        } else if (val) {
            router.push({
                pathname: "/products",
                query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                    q: val
                })
            });
        }
        setTriggerClearOverlay();
    };
    var router = (0,next_router.useRouter)();
    var setTriggerClearOverlay = (0,useProductList/* userProductListActions */.A)().setTriggerClearOverlay;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (SearchDropdown_styles_module_default()).recentSearchTextContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ICON_HISTORY_CLOCK */.lxP, {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (SearchDropdown_styles_module_default()).recentSearchTextContent,
                        children: "Lịch sử t\xecm kiếm"
                    })
                ]
            }),
            texts.map(function(text) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (SearchDropdown_styles_module_default()).hoveredRecentSearchText,
                    onClick: function() {
                        return handleClickRecentKeyword(text, searchType);
                    },
                    role: "button",
                    children: text
                }, text);
            })
        ]
    });
});
RecentSearchTexts.displayName = "RecentSearchTexts";
// Tiêu đề từng nhóm kết quả: "<keyword> trong <nhóm>"
function SectionHeader(_param) {
    var keyword = _param.keyword, label = _param.label, href = _param.href, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "keyword",
        "label",
        "href"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkComp/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (0,clsx/* default */.Z)((SearchDropdown_styles_module_default()).searchResults, (SearchDropdown_styles_module_default()).sectionHeader),
        href: href
    }, restProps), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                display: "inline",
                className: (SearchDropdown_styles_module_default()).keyword,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    display: "inline",
                    children: keyword
                })
            }),
            "\xa0trong ",
            label
        ]
    }));
}
function SearchDropdown(props) {
    var data = props.data, keyword = props.keyword, type = props.type, handleClickOutside = props.handleClickOutside, _ingredients = props.ingredients, ingredients = _ingredients === void 0 ? [] : _ingredients;
    var isKcbVerified = (0,useIsKcbVerified/* default */.Z)();
    // BV-2197: khung kết quả kéo dài xuống gần đáy màn hình để hiện được nhiều kết quả hơn
    var ref = (0,_sliced_to_array/* default */.Z)(useMaxHeightToViewportBottom(50), 2), dropdownRef = ref[0], dropdownMaxHeight = ref[1];
    var ref1 = (0,react.useState)([]), recentSearchTexts = ref1[0], setRecentSearchTexts = ref1[1];
    var triggerClearOverlay = (0,useProductList/* default */.Z)().triggerClearOverlay;
    var clearTriggerClearOverlay = (0,useProductList/* userProductListActions */.A)().clearTriggerClearOverlay;
    (0,react.useEffect)(function() {
        var isMounted = true;
        var fetchRecentSearchTexts = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var resp;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,WebServiceClient/* getRecentSearchTexts */.nB)()
                            ];
                        case 1:
                            resp = _state.sent();
                            if (resp.status === "OK" && isMounted) {
                                setRecentSearchTexts(resp.data || []);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchRecentSearchTexts() {
                return _ref.apply(this, arguments);
            };
        }();
        if (keyword === "") {
            fetchRecentSearchTexts();
        }
        return function() {
            isMounted = false;
        };
    }, [
        keyword
    ]);
    (0,react.useEffect)(function() {
        if (triggerClearOverlay > 0) {
            handleClickOutside();
        }
        return function() {
            clearTriggerClearOverlay();
        };
    }, [
        triggerClearOverlay
    ]);
    if (!data || !type) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            className: (SearchDropdown_styles_module_default()).searchDropdown,
            "data-test": "search-dropdown",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                display: "inline",
                className: (SearchDropdown_styles_module_default()).searchResults,
                children: [
                    "Kh\xf4ng c\xf3 sản phẩm với từ kh\xf3a ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        display: "inline",
                        children: keyword
                    }),
                    "\xa0\xa0trong\xa0",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: (SearchDropdown_styles_module_default()).textPrimary,
                        children: "Tất Cả Sản Phẩm"
                    })
                ]
            })
        });
    }
    // kq của thuốc
    if (data && type === constants_data/* THUOC_VA_HOAT_CHAT */.K_) {
        var listSearch = data.map(function(item) {
            var info = ProductServiceV2/* default.convertProductV2 */.ZP.convertProductV2(item);
            var displayPriceFormated = info.displayPriceFormated, displayPrice = info.displayPrice, tags = info.tags, name = info.name, seller = info.sellerInfo;
            var sellerInfo = (0,SellerService/* getSellerData */.Kz)({
                seller: seller,
                tags: tags
            });
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                name: name,
                displayPriceFormated: displayPriceFormated,
                displayPrice: displayPrice,
                sellerName: (sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.individualNonVatSellerName) || (sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.sellerName) || ""
            });
        });
        var groupedProductByName = (0,ObjectUtils/* groupArrayOfObjects */.K8)(listSearch, "name");
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            ref: dropdownRef,
            className: (SearchDropdown_styles_module_default()).searchDropdown,
            style: {
                maxHeight: dropdownMaxHeight
            },
            "data-test": "search-dropdown",
            children: [
                keyword !== "" && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeader, {
                    keyword: keyword,
                    label: "Thuốc",
                    href: "".concat(Paths/* PRODUCTS_LOADING_URL */.iB, "?text=").concat(keyword),
                    "data-test": "search-dropdown-enter"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    className: (SearchDropdown_styles_module_default()).styledScroll,
                    children: Object.keys(groupedProductByName).map(function(key) {
                        var ref;
                        var listProduct = groupedProductByName[key];
                        return (ref = (0,ProductService/* moveKcbPriorityFirst */.tP)(listProduct === null || listProduct === void 0 ? void 0 : listProduct.sort(function(a, b) {
                            return (a === null || a === void 0 ? void 0 : a.displayPrice) - (b === null || b === void 0 ? void 0 : b.displayPrice);
                        }), isKcbVerified)) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                            var ref, ref1, ref2;
                            // BV-2197: hoạt chất khớp keyword do BE trả -> "Có chứa <hoạt chất>"
                            var matchedIngredients = (item === null || item === void 0 ? void 0 : (ref = item.product) === null || ref === void 0 ? void 0 : ref.matchedIngredients) || [];
                            // hard code flagship store
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkComp/* default */.Z, {
                                className: (SearchDropdown_styles_module_default()).searchResults,
                                href: (0,Paths/* getPathProductBySlug */.hq)(item.sku.slug),
                                "data-test": "search-dropdown-item",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_HighlightText, {
                                        text: item === null || item === void 0 ? void 0 : (ref1 = item.product) === null || ref1 === void 0 ? void 0 : ref1.name,
                                        ranges: item === null || item === void 0 ? void 0 : (ref2 = item.product) === null || ref2 === void 0 ? void 0 : ref2.nameHighlights
                                    }),
                                    " ",
                                    listProduct.length > 1 && "".concat((item === null || item === void 0 ? void 0 : item.sellerName) && "- ".concat(item === null || item === void 0 ? void 0 : item.sellerName), "  - ").concat(item === null || item === void 0 ? void 0 : item.displayPriceFormated),
                                    matchedIngredients.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: (SearchDropdown_styles_module_default()).ingredientHint,
                                        children: [
                                            "C\xf3 chứa",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                children: matchedIngredients.map(function(ingredient, index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                        children: [
                                                            index > 0 && ", ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_HighlightText, {
                                                                text: ingredient.name,
                                                                ranges: ingredient.highlights
                                                            })
                                                        ]
                                                    }, ingredient.slug || ingredient.name);
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }, "".concat(key, "-").concat(item.sku.slug));
                        });
                    })
                }),
                keyword !== "" && (ingredients === null || ingredients === void 0 ? void 0 : ingredients.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    className: (SearchDropdown_styles_module_default()).ingredientSection,
                    "data-test": "search-dropdown-ingredients",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeader, {
                            keyword: keyword,
                            label: "Hoạt chất",
                            href: Paths/* INGREDIENT */.gL
                        }),
                        ingredients.map(function(ingredient) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkComp/* default */.Z, {
                                className: (SearchDropdown_styles_module_default()).searchResults,
                                href: "".concat(Paths/* INGREDIENT */.gL, "/").concat(ingredient.slug),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_HighlightText, {
                                    text: ingredient.name,
                                    ranges: ingredient.highlights
                                })
                            }, ingredient.code || ingredient.slug);
                        })
                    ]
                }),
                (data === null || data === void 0 ? void 0 : data.length) <= 0 && keyword === "" && /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentSearchTexts, {
                    texts: recentSearchTexts
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MostSearching, {
                    handleClickOutside: handleClickOutside
                })
            ]
        });
    }
    // kq của nhà bán hàng
    if (data && type === constants_data/* NHA_BAN_HANG */.jJ) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            ref: dropdownRef,
            className: (SearchDropdown_styles_module_default()).searchDropdown,
            style: {
                maxHeight: dropdownMaxHeight
            },
            "data-test": "search-dropdown",
            children: [
                keyword !== "" && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeader, {
                    keyword: keyword,
                    label: "Nh\xe0 b\xe1n h\xe0ng",
                    href: "".concat(Paths/* SELLERS */.UI, "?search=").concat(keyword)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    className: (SearchDropdown_styles_module_default()).styledScroll,
                    children: data === null || data === void 0 ? void 0 : data.map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkComp/* default */.Z, {
                            className: (SearchDropdown_styles_module_default()).searchResults,
                            href: item.link,
                            children: item.name
                        }, item.name);
                    })
                }),
                (data === null || data === void 0 ? void 0 : data.length) <= 0 && keyword === "" && /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentSearchTexts, {
                    texts: recentSearchTexts
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MostSearching, {
                    handleClickOutside: handleClickOutside
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        className: (SearchDropdown_styles_module_default()).searchDropdown,
        "data-test": "search-dropdown",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
            display: "inline",
            className: (SearchDropdown_styles_module_default()).searchResults,
            children: [
                "Kh\xf4ng c\xf3 sản phẩm với từ kh\xf3a ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    display: "inline",
                    children: keyword
                }),
                "\xa0\xa0trong\xa0",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    className: (SearchDropdown_styles_module_default()).textPrimary,
                    children: "Tất Cả Sản Phẩm"
                })
            ]
        })
    });
}
/* harmony default export */ var mocules_SearchDropdown = (/*#__PURE__*/(0,react.memo)(SearchDropdown));
MostSearching.displayName = "MostSearching";

// EXTERNAL MODULE: ./src/components-v2/mocules/SearchInput/styles.module.css
var SearchInput_styles_module = __webpack_require__(65602);
var SearchInput_styles_module_default = /*#__PURE__*/__webpack_require__.n(SearchInput_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/mocules/SearchInput/index.js





































var MAX_MATCHED_INGREDIENTS = 5;
var ExpandIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M12.9182 16.006C12.4233 16.5418 11.5768 16.5418 11.0818 16.006L7.01006 11.5982C6.2705 10.7976 6.83834 9.5 7.92825 9.5H16.0718C17.1617 9.5 17.7296 10.7976 16.99 11.5982L12.9182 16.006Z",
            fill: "#555555"
        })
    });
};
function SearchInput(_param) {
    var clearSearchRes = function clearSearchRes() {
        setSearchProduct([]);
        setSearchSeller([]);
        setMatchedIngredients({
            data: [],
            text: ""
        });
    };
    var handleFocus = function handleFocus(e) {
        var ref;
        var val = e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value;
        if (val && val.length > 0) {
            setHidden(true);
            setKeyword(e.target.value);
        }
    };
    var handleChangeTypeSearch = function handleChangeTypeSearch(e) {
        setSearchType(Number(e.target.value));
    };
    var handleKeyDown = function handleKeyDown(event) {
        var trimKeyword = keyword.trim();
        if (event.keyCode === 13) {
            event.preventDefault();
            event.target.blur();
            switch(searchType){
                case constants_data/* THUOC_VA_HOAT_CHAT */.K_:
                    if (router.pathname.includes("[slug]")) {
                        delete router.query.slug;
                    }
                    router.push({
                        pathname: "".concat(Paths/* PRODUCTS_URL */.NL),
                        query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                            q: trimKeyword,
                            searchType: searchType
                        })
                    });
                    break;
                case constants_data/* NHA_BAN_HANG */.jJ:
                    if (router.pathname.includes("[slug]")) {
                        delete router.query.slug;
                    }
                    router.push({
                        pathname: "".concat(Paths/* SELLERS */.UI),
                        query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                            search: trimKeyword,
                            searchType: searchType
                        })
                    });
                    break;
                default:
                    router.push("".concat(Paths/* PRODUCTS_URL */.NL));
                    break;
            }
        }
    };
    var convertSellers = function convertSellers() {
        var seller = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sellerMap = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new Map();
        var ref;
        return (ref = seller === null || seller === void 0 ? void 0 : seller.sort(function(a, b) {
            return a === null || a === void 0 ? void 0 : a.name.localeCompare(b === null || b === void 0 ? void 0 : b.name);
        })) === null || ref === void 0 ? void 0 : ref.map(function(itemSeller) {
            var ref = itemSeller || {}, _name = ref.name, name = _name === void 0 ? null : _name, _slug = ref.slug, slug = _slug === void 0 ? null : _slug, _code = ref.code, code = _code === void 0 ? null : _code;
            var ref1 = (0,SellerService/* getSellerData */.Kz)({
                seller: sellerMap.get(code)
            }) || {}, _linkStore = ref1.linkStore, linkStore = _linkStore === void 0 ? "" : _linkStore, _linkSeller = ref1.linkSeller, linkSeller = _linkSeller === void 0 ? "" : _linkSeller;
            return {
                name: name,
                slug: slug,
                code: code,
                link: linkStore || linkSeller
            };
        });
    };
    var handleClickSearch = function handleClickSearch() {
        focusRef.current = true;
        setIsFocus(true);
    };
    var handleShowFirstClick = function handleShowFirstClick() {
        var ref;
        setShow(true);
        setSearchIcon(true);
        (ref = inputEl.current) === null || ref === void 0 ? void 0 : ref.focus();
        if (keyword.length <= 0) {
            clearSearchRes();
        }
        handleClickSearch();
    };
    var checkStickySelect = function checkStickySelect() {
        if (!scrollSticky) {
            if (isFocus) {
                return (SearchInput_styles_module_default()).focusSelect;
            }
            return null;
        }
        if (isFocus && scrollSticky) {
            return (SearchInput_styles_module_default()).stickySelect;
        }
        return (SearchInput_styles_module_default()).hiddenSelect;
    };
    var checkStickyInput = function checkStickyInput() {
        if (!scrollSticky || isFocus || deviceUtils/* default.isTablet */.Z.isTablet()) {
            return null;
        }
        return (SearchInput_styles_module_default()).root_input_sticky;
    };
    var getDataSearch = function getDataSearch() {
        switch(searchType){
            case constants_data/* THUOC_VA_HOAT_CHAT */.K_:
                if ((searchProduct === null || searchProduct === void 0 ? void 0 : searchProduct.text) === keyword) {
                    return searchProduct === null || searchProduct === void 0 ? void 0 : searchProduct.data;
                }
                return [];
            case constants_data/* NHA_BAN_HANG */.jJ:
                if ((searchSeller === null || searchSeller === void 0 ? void 0 : searchSeller.text) === keyword) {
                    return searchSeller === null || searchSeller === void 0 ? void 0 : searchSeller.data;
                }
                return [];
            default:
                return [];
        }
    };
    var handleBlur = function handleBlur() {
        setIsFocus(false);
        (0,debounce/* debounceFunc200 */.dW)(function() {
            setHidden(false);
        });
    };
    var handleSearchbox = function handleSearchbox(e) {
        var val = e.target.value;
        setKeyword(val);
        setHidden(true);
        (0,debounce/* debounceFunc400 */.EI)(function() {
            if (val) {
                fetchDataSearch(val);
            } else {
                clearSearchRes();
            }
        });
    };
    var handleOnBlur = function handleOnBlur() {
        (0,debounce/* debounceFunc200 */.dW)(function() {
            if (focusRef.current) {
                focusRef.current = false;
            } else {
                handleBlur();
            }
        });
    };
    var handleChangeSelect = function handleChangeSelect(e) {
        focusRef.current = true;
        handleChangeTypeSearch(e);
        handleClickOutside();
    };
    var handleChangeTyping = function handleChangeTyping(e) {
        focusRef.current = true;
        handleSearchbox(e);
    };
    var onClickTypeDropdown = function onClickTypeDropdown() {
        focusRef.current = true;
        setFocusSelect(true);
        setShow(false);
    };
    var handleEnterKeyDown = function handleEnterKeyDown(e) {
        handleKeyDown(e);
        if (e.keyCode === 13) setShow(false);
    };
    var handleClickFocus = function handleClickFocus() {
        handleFocus();
        setIsFocus(true);
        if (!isFocus) {
            gtag/* default.showHashtagTopSearch */.ZP.showHashtagTopSearch(hashtagTopSearch[currentIndex]);
        }
    };
    var handleClickOutside = function handleClickOutside() {
        if (!isFocus) return;
        document.body.style.overflow = "auto";
        setIsVisibleSuggest(true);
        focusRef.current = false;
        setShow(false);
        setSearchIcon(false);
    };
    var classCustom = _param.classCustom, _scrollSticky = _param.scrollSticky, scrollSticky = _scrollSticky === void 0 ? null : _scrollSticky, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "classCustom",
        "scrollSticky"
    ]);
    var ref, ref1, ref2, ref3;
    var wrapperRef = (0,react.useRef)(null);
    var ref4 = (0,react.useState)(false), isFocus = ref4[0], setIsFocus = ref4[1];
    var ref5 = (0,react.useState)(constants_data/* THUOC_VA_HOAT_CHAT */.K_), searchType = ref5[0], setSearchType = ref5[1];
    var ref6 = (0,react.useState)(""), keyword = ref6[0], setKeyword = ref6[1];
    var ref7 = (0,react.useState)([]), searchProduct = ref7[0], setSearchProduct = ref7[1];
    var ref8 = (0,react.useState)(false), hidden = ref8[0], setHidden = ref8[1];
    var ref9 = (0,react.useState)({
        data: [],
        text: ""
    }), matchedIngredients = ref9[0], setMatchedIngredients = ref9[1];
    var ref10 = (0,react.useState)([]), searchSeller = ref10[0], setSearchSeller = ref10[1];
    var inputEl = (0,react.useRef)(null);
    var ref11 = (0,react.useState)(false), show = ref11[0], setShow = ref11[1];
    var ref12 = (0,react.useState)(false), seacrIcon = ref12[0], setSearchIcon = ref12[1];
    var handleSendEventSearchTimeout = (0,useSearchResult/* default */.Z)(function(state) {
        return state.handleSendEventSearchTimeout;
    });
    var suggestIndex = (0,react.useRef)(0);
    var suggestKeywordsRef = (0,react.useRef)(null);
    var ref13 = (0,react.useState)(true), isVisibleSuggest = ref13[0], setIsVisibleSuggest = ref13[1];
    var hashtagTopSearch = useHashtagTopSearch().hashtagTopSearch;
    var ref14 = (0,react.useState)(0), currentIndex = ref14[0], setCurrentIndex = ref14[1];
    var router = (0,next_router.useRouter)();
    var triggerClearOverlay = (0,useProductList/* default */.Z)().triggerClearOverlay;
    var clearTriggerClearOverlay = (0,useProductList/* userProductListActions */.A)().clearTriggerClearOverlay;
    (0,react.useEffect)(function() {
        if (!suggestKeywordsRef.current || !(hashtagTopSearch === null || hashtagTopSearch === void 0 ? void 0 : hashtagTopSearch.length) > 1) return;
        var updateSuggestKeywordDisplay = function(index) {
            if (suggestKeywordsRef.current && !isFocus && isVisibleSuggest) {
                var suggestKeywordListElm = suggestKeywordsRef.current.getElementsByClassName("suggest_keyword");
                Array.from(suggestKeywordListElm).forEach(function(item, i) {
                    var currentItem = item;
                    currentItem.style.opacity = i === index ? "1" : "0";
                    currentItem.style.transform = i === index ? "translateY(55%)" : "translateY(100%)";
                });
            }
        };
        updateSuggestKeywordDisplay(suggestIndex.current);
        var interval = setInterval(function() {
            var nextIndex = (suggestIndex.current + 1) % hashtagTopSearch.length;
            updateSuggestKeywordDisplay(nextIndex);
            setCurrentIndex(nextIndex);
            suggestIndex.current = nextIndex;
        }, 2500);
        return function() {
            return clearInterval(interval);
        };
    }, [
        hashtagTopSearch.length,
        isVisibleSuggest,
        keyword,
        isFocus
    ]);
    var focusRef = (0,react.useRef)(false);
    var handleSendEvSearchTimeout = (0,useSearchResult/* default */.Z)(function(state) {
        return state.handleSendEvSearchTimeout;
    });
    (0,react.useEffect)(function() {
        if (document.activeElement === inputEl.current) {
            setShow(true);
        } else {
            setShow(false);
        }
    }, [
        hidden
    ]);
    var containerRef = (0,react.useRef)(null);
    function handleSearch(_) {
        return _handleSearch.apply(this, arguments);
    }
    function _handleSearch() {
        _handleSearch = (0,_async_to_generator/* default */.Z)(function(param) {
            var _val, val, resData, _tmp, _tmp1, _tmp2, _tmp3;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _val = param.val, val = _val === void 0 ? "" : _val;
                        if (!sysconfig/* IS_WEB_SERVICE_SEARCH_LITE */.GO) return [
                            3,
                            2
                        ];
                        _tmp1 = {};
                        return [
                            4,
                            (0,WebService/* doSearchFuzzyLite */.qR)((_tmp1.body = {
                                text: val,
                                offset: 0,
                                limit: constants_data/* PAGE_SIZE_30 */.AV,
                                searchStrategy: {
                                    text: true,
                                    keyword: true,
                                    ingredient: true
                                },
                                queryOption: {
                                    isReplacePriceAfterVoucher: true
                                }
                            }, _tmp1), true)
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            SearchClient/* default.searchByKeywords */.Z.searchByKeywords(val, true)
                        ];
                    case 3:
                        _tmp = _state.sent();
                        _state.label = 4;
                    case 4:
                        resData = _tmp;
                        _tmp2 = {};
                        setSearchProduct((_tmp2.data = (0,Clients/* getData */.Yu)(resData), _tmp2.text = val, _tmp2));
                        _tmp3 = {};
                        handleSendEventSearchTimeout((_tmp3.resData = resData, _tmp3.searchKeyword = val, _tmp3));
                        return [
                            2
                        ];
                }
            });
        });
        return _handleSearch.apply(this, arguments);
    }
    function handleMatchIngredients(val) {
        return _handleMatchIngredients.apply(this, arguments);
    }
    function _handleMatchIngredients() {
        _handleMatchIngredients = // BV-2197: hoạt chất khớp keyword (BE lọc + đánh dấu highlight), hiện dưới list thuốc
        (0,_async_to_generator/* default */.Z)(function(val) {
            var res, _tmp, _tmp1, e, _tmp2;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        _tmp = {};
                        return [
                            4,
                            (0,WebServiceClient/* searchIngredients */.e8)((_tmp.text = val, _tmp.limit = MAX_MATCHED_INGREDIENTS, _tmp))
                        ];
                    case 1:
                        res = _state.sent();
                        _tmp1 = {};
                        setMatchedIngredients((_tmp1.data = (0,Clients/* getData */.Yu)(res), _tmp1.text = val, _tmp1));
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        _tmp2 = {};
                        setMatchedIngredients((_tmp2.data = [], _tmp2.text = val, _tmp2));
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return _handleMatchIngredients.apply(this, arguments);
    }
    function fetchDataSearch(val) {
        return _fetchDataSearch.apply(this, arguments);
    }
    function _fetchDataSearch() {
        _fetchDataSearch = (0,_async_to_generator/* default */.Z)(function(val) {
            var _tmp, sellerRes, _tmp1, data, sellers, sellerMap, _tmp2;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        switch(searchType){
                            case constants_data/* THUOC_VA_HOAT_CHAT */.K_:
                                return [
                                    3,
                                    1
                                ];
                            case constants_data/* NHA_BAN_HANG */.jJ:
                                return [
                                    3,
                                    2
                                ];
                        }
                        return [
                            3,
                            5
                        ];
                    case 1:
                        _tmp = {};
                        handleSearch((_tmp.val = val, _tmp));
                        handleMatchIngredients(val);
                        gtag/* default.clickSearch */.ZP.clickSearch(constants_data/* THUOC_VA_HOAT_CHAT */.K_, val);
                        return [
                            3,
                            6
                        ];
                    case 2:
                        _tmp1 = {};
                        return [
                            4,
                            (0,SellerClient/* searchStoreByText */.CB)((_tmp1.params = {
                                search: val,
                                offset: 0,
                                limit: 30,
                                getTotal: true,
                                sellerType: constants_data/* ENTERPRISE */.Eo
                            }, _tmp1))
                        ];
                    case 3:
                        sellerRes = _state.sent();
                        handleSendEvSearchTimeout(val, sellerRes === null || sellerRes === void 0 ? void 0 : sellerRes.status, sellerRes === null || sellerRes === void 0 ? void 0 : sellerRes.total);
                        data = (0,Clients/* getData */.Yu)(sellerRes);
                        return [
                            4,
                            SupplierClient/* default.getSellersV2 */.ZP.getSellersV2(data.map(function(item) {
                                return item.code;
                            })).then(Clients/* getData */.Yu)
                        ];
                    case 4:
                        sellers = _state.sent();
                        sellerMap = new Map(sellers.map(function(item) {
                            return [
                                item.code,
                                item
                            ];
                        }));
                        _tmp2 = {};
                        setSearchSeller((_tmp2.data = convertSellers(data, sellerMap), _tmp2.text = val, _tmp2));
                        gtag/* default.clickSearch */.ZP.clickSearch(constants_data/* NHA_BAN_HANG */.jJ, val);
                        return [
                            3,
                            6
                        ];
                    case 5:
                        clearSearchRes();
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return _fetchDataSearch.apply(this, arguments);
    }
    var ref15 = (0,react.useState)(false), focusSelect = ref15[0], setFocusSelect = ref15[1];
    (0,react.useEffect)(function() {
        if (!focusRef.current) {
            handleBlur();
        }
    }, [
        focusRef.current
    ]);
    (0,react.useEffect)(function() {
        if (!isVisibleSuggest) {
            handleShowFirstClick();
        }
    }, [
        isVisibleSuggest
    ]);
    (0,react.useEffect)(function() {
        var handleMouseDown = function(e) {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                handleClickOutside();
            }
        };
        document.addEventListener("mousedown", handleMouseDown);
        return function() {
            document.removeEventListener("mousedown", handleMouseDown);
        };
    }, [
        isFocus
    ]);
    (0,react.useEffect)(function() {
        handleClickOutside();
    }, [
        router.asPath
    ]);
    (0,react.useEffect)(function() {
        if (triggerClearOverlay > 1) {
            handleClickOutside();
        }
        return function() {
            clearTriggerClearOverlay();
        };
    }, [
        triggerClearOverlay
    ]);
    if (deviceUtils/* default.isTablet */.Z.isTablet()) {
        var ref16;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            ref: containerRef,
            className: (0,clsx/* default */.Z)((SearchInput_styles_module_default()).search_wrap, classCustom, (SearchInput_styles_module_default()).search_ic_tablet),
            onBlur: handleOnBlur,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,clsx/* default */.Z)((SearchInput_styles_module_default()).searchTabletContainer, isFocus && (SearchInput_styles_module_default()).border_search_tablet),
                    children: !scrollSticky && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                className: (SearchInput_styles_module_default()).text_field_tablet,
                                onClick: function() {
                                    setIsVisibleSuggest(false);
                                },
                                inputRef: inputEl,
                                value: keyword,
                                classes: {
                                    root: (SearchInput_styles_module_default()).root_input_tablet
                                },
                                ref: wrapperRef,
                                async: true,
                                onChange: handleChangeTyping,
                                onKeyDown: handleEnterKeyDown,
                                InputProps: {
                                    startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                                        position: "start",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: seacrIcon ? Images/* SEARCHV2ACTIVE_ICON */.eC1 : Images/* SEARCHV2_ICON */.RoF,
                                            height: "20px",
                                            width: "20px",
                                            layout: "fixed"
                                        })
                                    }),
                                    placeholder: "T\xecm kiếm ...",
                                    autoComplete: "off"
                                },
                                onFocus: handleFocus
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (SearchInput_styles_module_default()).selectSearch,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
                                    className: (SearchInput_styles_module_default()).formControlTablet,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NativeSelect/* default */.Z, {
                                        className: (0,clsx/* default */.Z)(focusSelect ? (SearchInput_styles_module_default()).selectInputFocus : (SearchInput_styles_module_default()).selectInput, (SearchInput_styles_module_default()).border_none),
                                        inputProps: {
                                            name: "search",
                                            id: "search-type",
                                            placeholder: "Thuốc"
                                        },
                                        IconComponent: ExpandMore/* default */.Z,
                                        onChange: handleChangeSelect,
                                        onClick: onClickTypeDropdown,
                                        onBlur: function() {
                                            return setFocusSelect(false);
                                        },
                                        value: constants_data/* SEARCH_TYPE_LIST.find */.Yb.find(function(item) {
                                            return (item === null || item === void 0 ? void 0 : item.value) === Number(searchType);
                                        }).value || ((ref16 = constants_data/* SEARCH_TYPE_LIST.0 */.Yb[0]) === null || ref16 === void 0 ? void 0 : ref16.value),
                                        onKeyDown: handleKeyDown,
                                        children: constants_data/* SEARCH_TYPE_LIST.map */.Yb.map(function(item) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                value: item.value,
                                                style: {
                                                    cursor: "pointer",
                                                    color: "#000000"
                                                },
                                                children: item.label
                                            }, item.value);
                                        })
                                    })
                                })
                            })
                        ]
                    })
                }),
                show && /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_SearchDropdown, {
                    handleClickOutside: handleClickOutside,
                    keyword: keyword,
                    data: getDataSearch(),
                    type: Number(searchType),
                    ingredients: matchedIngredients.text === keyword ? matchedIngredients.data : []
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        ref: containerRef,
        className: (0,clsx/* default */.Z)((SearchInput_styles_module_default()).search_wrap, classCustom),
        onBlur: handleOnBlur,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx/* default */.Z)((SearchInput_styles_module_default()).searchContainer, (keyword === null || keyword === void 0 ? void 0 : keyword.length) === 250 && (SearchInput_styles_module_default()).err_border),
                "data-test": "search-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        className: (SearchInput_styles_module_default()).root_input_scale,
                        onClick: function() {
                            setIsVisibleSuggest(false);
                        },
                        inputRef: inputEl,
                        value: keyword
                    }, restProps), {
                        classes: {
                            root: (0,clsx/* default */.Z)((SearchInput_styles_module_default()).root_input, checkStickyInput())
                        },
                        ref: wrapperRef,
                        async: true,
                        onChange: handleChangeTyping,
                        onKeyDown: handleEnterKeyDown,
                        inputProps: {
                            maxLength: 250
                        },
                        // eslint-disable-next-line react/jsx-no-duplicate-props
                        InputProps: {
                            startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                                position: "start",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                                    src: seacrIcon ? Images/* SEARCHV2ACTIVE_ICON */.eC1 : Images/* SEARCHV2_ICON */.RoF,
                                    height: "20px",
                                    width: "20px"
                                })
                            }),
                            placeholder: (hashtagTopSearch === null || hashtagTopSearch === void 0 ? void 0 : hashtagTopSearch.length) > 0 && !show ? "" : ((ref = hashtagTopSearch[currentIndex]) === null || ref === void 0 ? void 0 : ref.hashtag) || "Bạn t\xecm g\xec h\xf4m nay?",
                            autoComplete: "off",
                            type: "search"
                        },
                        onFocus: handleClickFocus,
                        "data-test": "search-input"
                    })),
                    isVisibleSuggest && (hashtagTopSearch === null || hashtagTopSearch === void 0 ? void 0 : hashtagTopSearch.length) > 0 && ((ref1 = keyword === null || keyword === void 0 ? void 0 : keyword.trim()) === null || ref1 === void 0 ? void 0 : ref1.length) === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: suggestKeywordsRef,
                        className: (SearchInput_styles_module_default()).placeholder_wrapper,
                        onClick: function() {
                            return setIsVisibleSuggest(false);
                        },
                        role: "button",
                        children: hashtagTopSearch.map(function(suggestKeyword) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,clsx/* default */.Z)((SearchInput_styles_module_default()).placeholder, "suggest_keyword"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: suggestKeyword.hashtag
                                })
                            }, suggestKeyword.code);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx/* default */.Z)((SearchInput_styles_module_default()).selectSearch, checkStickySelect()),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
                            className: (SearchInput_styles_module_default()).formControl,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (SearchInput_styles_module_default()) === null || (SearchInput_styles_module_default()) === void 0 ? void 0 : (SearchInput_styles_module_default()).customHr
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NativeSelect/* default */.Z, {
                                    className: (SearchInput_styles_module_default()).selectInput,
                                    inputProps: {
                                        name: "search",
                                        id: "search-type"
                                    },
                                    IconComponent: ExpandIcon,
                                    onChange: handleChangeSelect,
                                    onClick: onClickTypeDropdown,
                                    onBlur: function() {
                                        return setFocusSelect(false);
                                    },
                                    value: ((ref2 = constants_data/* SEARCH_TYPE_LIST.find */.Yb.find(function(item) {
                                        return (item === null || item === void 0 ? void 0 : item.value) === Number(searchType);
                                    })) === null || ref2 === void 0 ? void 0 : ref2.value) || ((ref3 = constants_data/* SEARCH_TYPE_LIST.0 */.Yb[0]) === null || ref3 === void 0 ? void 0 : ref3.value),
                                    "data-test": "search-select-option",
                                    children: constants_data/* SEARCH_TYPE_LIST.map */.Yb.map(function(item) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: item.value,
                                            style: {
                                                cursor: "pointer",
                                                color: "#000000"
                                            },
                                            children: item.label
                                        }, item.value);
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            show && /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_SearchDropdown, {
                handleClickOutside: handleClickOutside,
                keyword: keyword,
                data: getDataSearch(),
                type: Number(searchType),
                ingredients: matchedIngredients.text === keyword ? matchedIngredients.data : []
            }),
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OverlayV2, {
                isOpen: show,
                level: 2
            })
        ]
    });
}
/* harmony default export */ var mocules_SearchInput = (/*#__PURE__*/(0,react.memo)(SearchInput));

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(95477);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ClickAwayListener/ClickAwayListener.js
var ClickAwayListener = __webpack_require__(52795);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Verified.js
var Verified = __webpack_require__(59382);
// EXTERNAL MODULE: ./src/clients/WishlistClient.js
var WishlistClient = __webpack_require__(56639);
// EXTERNAL MODULE: ./src/clients/CustomerCatalogClient.js
var CustomerCatalogClient = __webpack_require__(88996);
// EXTERNAL MODULE: ./src/components/mocules/NewCustomModal/index.js
var NewCustomModal = __webpack_require__(24547);
// EXTERNAL MODULE: ./src/constants/SVG/index.ts
var SVG = __webpack_require__(69448);
// EXTERNAL MODULE: ./src/context/Cart/CartContext.js + 2 modules
var CartContext = __webpack_require__(15012);
// EXTERNAL MODULE: ./src/services/convertNewAPIProduct.js
var convertNewAPIProduct = __webpack_require__(20402);
;// CONCATENATED MODULE: ./src/hooks/useFetchData.js





var useFetchData = function(getFunc, open, isMapData) {
    var ref = (0,react.useState)(null), data = ref[0], setData = ref[1];
    var ref1 = (0,react.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    var ref2 = (0,react.useState)(null), error = ref2[0], setError = ref2[1];
    var ref3 = (0,react.useState)(0), total = ref3[0], setTotal = ref3[1];
    (0,react.useEffect)(function() {
        if (!open) return;
        (0,_async_to_generator/* default */.Z)(function() {
            var getData, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            3,
                            4
                        ]);
                        setIsLoading(true);
                        return [
                            4,
                            getFunc()
                        ];
                    case 1:
                        getData = _state.sent();
                        if ((0,Clients/* isValid */.JY)(getData)) {
                            setData(function() {
                                return isMapData ? (0,convertNewAPIProduct/* default */.ZP)({
                                    product: getData === null || getData === void 0 ? void 0 : getData.data
                                }) : getData === null || getData === void 0 ? void 0 : getData.data;
                            });
                            setTotal(getData === null || getData === void 0 ? void 0 : getData.total);
                        }
                        return [
                            3,
                            4
                        ];
                    case 2:
                        error = _state.sent();
                        console.error("error", error);
                        setError(error);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        setIsLoading(false);
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        open
    ]);
    return {
        data: data,
        isLoading: isLoading,
        error: error,
        total: total
    };
};

// EXTERNAL MODULE: ./src/hooks/useModal.js
var useModal = __webpack_require__(16028);
// EXTERNAL MODULE: ./src/hooks/usePremium.ts + 1 modules
var usePremium = __webpack_require__(94581);
// EXTERNAL MODULE: ./src/services/UserService.js
var UserService = __webpack_require__(89349);
// EXTERNAL MODULE: ./src/utils/FormatNumber.js
var FormatNumber = __webpack_require__(44097);
// EXTERNAL MODULE: ./src/zustand-lib/storeGlobal.js + 2 modules
var storeGlobal = __webpack_require__(31439);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/CheckCircle.js
var CheckCircle = __webpack_require__(81395);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Lock.js
var Lock = __webpack_require__(44080);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Search.js
var Search = __webpack_require__(88995);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Store.js
var Store = __webpack_require__(984);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/SwapHoriz.js
var SwapHoriz = __webpack_require__(60796);
// EXTERNAL MODULE: ./src/clients/ChainClient.js
var ChainClient = __webpack_require__(78344);
// EXTERNAL MODULE: ./src/utils/SessionUtils.js
var SessionUtils = __webpack_require__(69702);
// EXTERNAL MODULE: ./src/utils/ChainSessionUtils.ts
var ChainSessionUtils = __webpack_require__(98859);
// EXTERNAL MODULE: ./src/utils/NotifyUtils.js
var NotifyUtils = __webpack_require__(25872);
// EXTERNAL MODULE: ./src/components-v2/mocules/ChainStoreSwitcher/styles.module.css
var ChainStoreSwitcher_styles_module = __webpack_require__(85295);
var ChainStoreSwitcher_styles_module_default = /*#__PURE__*/__webpack_require__.n(ChainStoreSwitcher_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/mocules/ChainStoreSwitcher/index.tsx




















var StoreAvatar = function(param) {
    var name = param.name, avatarURL = param.avatarURL, fallbackLetter = param.fallbackLetter;
    var ref = (0,react.useState)(false), hasError = ref[0], setHasError = ref[1];
    var cdnUrl = avatarURL && !hasError ? (0,ImageUtils/* getLinkCDNImage */.wr)(avatarURL) : "";
    if (cdnUrl) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            src: cdnUrl,
            alt: name || "Avatar",
            className: (ChainStoreSwitcher_styles_module_default()).avatarImg,
            onError: function() {
                return setHasError(true);
            }
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (ChainStoreSwitcher_styles_module_default()).avatarFallback,
        children: fallbackLetter || (name ? name.charAt(0).toUpperCase() : "S")
    });
};
var ChainStoreSwitcher = function(param) {
    var user = param.user, onClose = param.onClose;
    var ref = (0,react.useState)(false), expanded = ref[0], setExpanded = ref[1];
    var ref1 = (0,react.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react.useState)(null), switchingAccountId = ref2[0], setSwitchingAccountId = ref2[1];
    var ref3 = (0,react.useState)(""), searchQuery = ref3[0], setSearchQuery = ref3[1];
    var ref4 = (0,react.useState)(null), chainData = ref4[0], setChainData = ref4[1];
    var ref5 = (0,react.useState)(null), chainSession = ref5[0], setChainSession = ref5[1];
    (0,react.useEffect)(function() {
        setChainSession((0,ChainSessionUtils/* getValidatedChainSessionState */.c5)(user));
    }, [
        user
    ]);
    var isImpersonating = Boolean(chainSession === null || chainSession === void 0 ? void 0 : chainSession.isImpersonating);
    (0,react.useEffect)(function() {
        if (!(user === null || user === void 0 ? void 0 : user.isChain) || !(user === null || user === void 0 ? void 0 : user.isParent) || isImpersonating) {
            return;
        }
        var isMounted = true;
        var loadChildren = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var loadedData;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setLoading(true);
                            return [
                                4,
                                (0,ChainSessionUtils/* fetchChainChildrenWithRetry */.VZ)(function() {
                                    return !isMounted;
                                })
                            ];
                        case 1:
                            loadedData = _state.sent();
                            if (!isMounted) return [
                                2
                            ];
                            setLoading(false);
                            if (loadedData) {
                                setChainData(loadedData);
                            } else {
                                setChainData(null);
                                NotifyUtils/* default.error */.Z.error("Kh\xf4ng thể tải danh s\xe1ch chi nh\xe1nh. Vui l\xf2ng thử lại sau.");
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function loadChildren() {
                return _ref.apply(this, arguments);
            };
        }();
        loadChildren();
        return function() {
            isMounted = false;
        };
    }, [
        user === null || user === void 0 ? void 0 : user.isChain,
        user === null || user === void 0 ? void 0 : user.isParent,
        isImpersonating
    ]);
    var filteredChildren = (0,react.useMemo)(function() {
        var list = (chainData === null || chainData === void 0 ? void 0 : chainData.children) || [];
        if (!searchQuery.trim()) return list;
        var q = searchQuery.toLowerCase().trim();
        return list.filter(function(c) {
            return c.name && c.name.toLowerCase().includes(q) || c.code && c.code.toLowerCase().includes(q);
        });
    }, [
        chainData,
        searchQuery
    ]);
    var handleSwitchToChild = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(child) {
            var activeSessionToken, ref, ref1, ref2, ref3, ref4, ref5, resp, _tmp, impersonateToken, ref6, ref7, ref8, ref9, ref10, effectiveParentAccountID, ref11, ref12, ref13, effectiveParentName, effectiveParentCode, effectiveChainCode, _tmp1, _tmp2, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (switchingAccountId !== null) {
                            return [
                                2
                            ];
                        }
                        setSwitchingAccountId(child.accountID);
                        activeSessionToken = (0,SessionUtils/* getSessionTokenClient */.c)();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        _tmp = {};
                        return [
                            4,
                            (0,ChainClient/* switchChildAccount */.y$)((_tmp.childAccountId = child.accountID, _tmp))
                        ];
                    case 2:
                        resp = _state.sent();
                        impersonateToken = (resp === null || resp === void 0 ? void 0 : (ref = resp.data) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.accessToken) || (resp === null || resp === void 0 ? void 0 : (ref2 = resp.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.access_token) || (resp === null || resp === void 0 ? void 0 : (ref4 = resp.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[0]) === null || ref5 === void 0 ? void 0 : ref5.token);
                        _tmp1 = {};
                        _tmp2 = {};
                        if ((0,Clients/* isValid */.JY)(resp) && impersonateToken) {
                            ;
                            ;
                            effectiveParentAccountID = (chainData === null || chainData === void 0 ? void 0 : chainData.parentAccountID) || ((ref10 = (ref9 = (ref8 = user === null || user === void 0 ? void 0 : user.accountID) !== null && ref8 !== void 0 ? ref8 : user === null || user === void 0 ? void 0 : (ref6 = user.account) === null || ref6 === void 0 ? void 0 : ref6.accountId) !== null && ref9 !== void 0 ? ref9 : user === null || user === void 0 ? void 0 : user.accountId) !== null && ref10 !== void 0 ? ref10 : 0);
                            ;
                            effectiveParentName = (chainData === null || chainData === void 0 ? void 0 : chainData.parentName) || ((ref13 = (ref12 = (ref11 = user === null || user === void 0 ? void 0 : user.name) !== null && ref11 !== void 0 ? ref11 : user === null || user === void 0 ? void 0 : user.businessName) !== null && ref12 !== void 0 ? ref12 : user === null || user === void 0 ? void 0 : (ref7 = user.account) === null || ref7 === void 0 ? void 0 : ref7.fullname) !== null && ref13 !== void 0 ? ref13 : "");
                            effectiveParentCode = (user === null || user === void 0 ? void 0 : user.code) || "";
                            effectiveChainCode = (chainData === null || chainData === void 0 ? void 0 : chainData.chainCode) || (user === null || user === void 0 ? void 0 : user.chainCode) || "";
                            (0,ChainSessionUtils/* setChildImpersonationSession */.Gn)(impersonateToken, activeSessionToken, (_tmp1.accountID = effectiveParentAccountID, _tmp1.name = effectiveParentName, _tmp1.code = effectiveParentCode, _tmp1.chainCode = effectiveChainCode, _tmp1), (_tmp2.accountID = child.accountID, _tmp2.code = child.code, _tmp2.name = child.name, _tmp2.avatarURL = child.avatarURL, _tmp2.phone = child.phone, _tmp2.address = child.address, _tmp2.chainCode = effectiveChainCode, _tmp2));
                            NotifyUtils/* default.success */.Z.success("Đ\xe3 chuyển sang chi nh\xe1nh: ".concat(child.name));
                            if (onClose) onClose();
                            window.location.reload();
                        } else {
                            NotifyUtils/* default.error */.Z.error((resp === null || resp === void 0 ? void 0 : resp.message) || "Kh\xf4ng thể chuyển sang t\xe0i khoản chi nh\xe1nh n\xe0y.");
                            setSwitchingAccountId(null);
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        NotifyUtils/* default.error */.Z.error((e === null || e === void 0 ? void 0 : e.message) || "Đ\xe3 c\xf3 lỗi xảy ra khi chuyển t\xe0i khoản.");
                        setSwitchingAccountId(null);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSwitchToChild(child) {
            return _ref.apply(this, arguments);
        };
    }();
    if (!(user === null || user === void 0 ? void 0 : user.isChain) || !(user === null || user === void 0 ? void 0 : user.isParent) || isImpersonating) {
        return null;
    }
    var parentName = (chainData === null || chainData === void 0 ? void 0 : chainData.parentName) || (user === null || user === void 0 ? void 0 : user.name);
    var parentAvatarURL = (chainData === null || chainData === void 0 ? void 0 : chainData.parentAvatarURL) || (user === null || user === void 0 ? void 0 : user.avatarURL);
    var totalStores = (chainData === null || chainData === void 0 ? void 0 : chainData.totalStores) || ((chainData === null || chainData === void 0 ? void 0 : chainData.children) ? chainData.children.length + 1 : 1);
    var renderTooltipContent = function(name, phone, address) {
        var isActive = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (ChainStoreSwitcher_styles_module_default()).tooltipContainer,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ChainStoreSwitcher_styles_module_default()).tooltipName,
                    children: name
                }),
                phone ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (ChainStoreSwitcher_styles_module_default()).tooltipMeta,
                    children: [
                        "SĐT: ",
                        phone
                    ]
                }) : null,
                address ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (ChainStoreSwitcher_styles_module_default()).tooltipMeta,
                    children: [
                        "Địa chỉ: ",
                        address
                    ]
                }) : null,
                !isActive && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ChainStoreSwitcher_styles_module_default()).tooltipInactiveWarning,
                    children: "⚠️ T\xe0i khoản chi nh\xe1nh hiện chưa k\xedch hoạt hoặc tạm kh\xf3a. Vui l\xf2ng li\xean hệ CSKH để được hỗ trợ."
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ChainStoreSwitcher_styles_module_default()).chainSwitcherContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ChainStoreSwitcher_styles_module_default()).headerToggle,
                onClick: function() {
                    return setExpanded(function(v) {
                        return !v;
                    });
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ChainStoreSwitcher_styles_module_default()).chainTitleGroup,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ChainStoreSwitcher_styles_module_default()).chainIcon,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Store/* default */.Z, {
                                    fontSize: "small"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (ChainStoreSwitcher_styles_module_default()).chainName,
                                children: "Hệ Thống Chi Nh\xe1nh"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: (ChainStoreSwitcher_styles_module_default()).badgeCount,
                                children: [
                                    totalStores,
                                    " chi nh\xe1nh"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore/* default */.Z, {
                        fontSize: "small",
                        className: (0,clsx/* default */.Z)((ChainStoreSwitcher_styles_module_default()).chevronIcon, expanded && (ChainStoreSwitcher_styles_module_default()).chevronExpanded)
                    })
                ]
            }),
            expanded && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ChainStoreSwitcher_styles_module_default()).dropdownBody,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ChainStoreSwitcher_styles_module_default()).searchBox,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {
                                className: (ChainStoreSwitcher_styles_module_default()).searchIcon
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "text",
                                className: (ChainStoreSwitcher_styles_module_default()).searchInput,
                                placeholder: "T\xecm kiếm chi nh\xe1nh...",
                                value: searchQuery,
                                onChange: function(e) {
                                    return setSearchQuery(e.target.value);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                        title: renderTooltipContent(parentName, user === null || user === void 0 ? void 0 : user.phone, user === null || user === void 0 ? void 0 : user.address),
                        arrow: true,
                        placement: "left",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,clsx/* default */.Z)((ChainStoreSwitcher_styles_module_default()).parentCard, (ChainStoreSwitcher_styles_module_default()).parentCardActive, switchingAccountId !== null && (ChainStoreSwitcher_styles_module_default()).parentCardDisabled),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (ChainStoreSwitcher_styles_module_default()).storeMeta,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (ChainStoreSwitcher_styles_module_default()).avatarWrapper,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreAvatar, {
                                                name: parentName,
                                                avatarURL: parentAvatarURL,
                                                fallbackLetter: "M"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (ChainStoreSwitcher_styles_module_default()).storeText,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (ChainStoreSwitcher_styles_module_default()).storeName,
                                                    children: parentName
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (ChainStoreSwitcher_styles_module_default()).parentBadge,
                                                    children: "CỬA H\xc0NG CH\xcdNH"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCircle/* default */.Z, {
                                    className: (ChainStoreSwitcher_styles_module_default()).activeCheckIcon
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ChainStoreSwitcher_styles_module_default()).sectionDivider,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (ChainStoreSwitcher_styles_module_default()).sectionDividerText,
                                children: "Chi nh\xe1nh trực thuộc"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ChainStoreSwitcher_styles_module_default()).dividerLine
                            })
                        ]
                    }),
                    loading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ChainStoreSwitcher_styles_module_default()).loadingNotice,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                size: 16,
                                className: (ChainStoreSwitcher_styles_module_default()).switchingSpinner
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Đang tải danh s\xe1ch chi nh\xe1nh..."
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ChainStoreSwitcher_styles_module_default()).childList,
                        children: filteredChildren.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ChainStoreSwitcher_styles_module_default()).emptyNotice,
                            children: "Kh\xf4ng t\xecm thấy chi nh\xe1nh ph\xf9 hợp"
                        }) : filteredChildren.map(function(child) {
                            var isStoreActive = (0,ChainSessionUtils/* isChildStoreActive */.yo)(child);
                            var isCurrentActive = false;
                            var isSwitchingThis = switchingAccountId === child.accountID;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                                title: renderTooltipContent(child.name, child.phone, child.address, isStoreActive),
                                arrow: true,
                                placement: "left",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (0,clsx/* default */.Z)((ChainStoreSwitcher_styles_module_default()).childItem, isCurrentActive && (ChainStoreSwitcher_styles_module_default()).childItemActive, (!isStoreActive || switchingAccountId !== null && !isSwitchingThis) && (ChainStoreSwitcher_styles_module_default()).childItemDisabled, switchingAccountId !== null && !isSwitchingThis && (ChainStoreSwitcher_styles_module_default()).itemDisabledDuringSwitch),
                                    onClick: function() {
                                        if (!isStoreActive || switchingAccountId !== null) return;
                                        if (!isCurrentActive) {
                                            handleSwitchToChild(child);
                                        }
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (ChainStoreSwitcher_styles_module_default()).storeMeta,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (ChainStoreSwitcher_styles_module_default()).avatarWrapper,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreAvatar, {
                                                        name: child.name,
                                                        avatarURL: child.avatarURL,
                                                        fallbackLetter: "C"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (ChainStoreSwitcher_styles_module_default()).storeText,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: (ChainStoreSwitcher_styles_module_default()).storeName,
                                                            children: child.name
                                                        }),
                                                        !isStoreActive && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: (ChainStoreSwitcher_styles_module_default()).inactiveStoreBadge,
                                                            children: "Chưa k\xedch hoạt"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: !isStoreActive ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                                                title: "T\xe0i khoản chưa k\xedch hoạt - Li\xean hệ CSKH",
                                                arrow: true,
                                                placement: "top",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (ChainStoreSwitcher_styles_module_default()).disabledLockBtn,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Lock/* default */.Z, {
                                                        fontSize: "small"
                                                    })
                                                })
                                            }) : isSwitchingThis ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                                size: 16,
                                                className: (ChainStoreSwitcher_styles_module_default()).switchingSpinner
                                            }) : isCurrentActive ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCircle/* default */.Z, {
                                                className: (ChainStoreSwitcher_styles_module_default()).activeCheckIcon
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                                                title: "Chuyển sang chi nh\xe1nh n\xe0y",
                                                arrow: true,
                                                placement: "top",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (ChainStoreSwitcher_styles_module_default()).switchIconBtn,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapHoriz/* default */.Z, {
                                                        fontSize: "small"
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                })
                            }, child.customerID);
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var mocules_ChainStoreSwitcher = (ChainStoreSwitcher);

// EXTERNAL MODULE: ./src/components-v2/mocules/ToggleProfile/styles.module.css
var ToggleProfile_styles_module = __webpack_require__(71503);
var ToggleProfile_styles_module_default = /*#__PURE__*/__webpack_require__.n(ToggleProfile_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/mocules/ToggleProfile/PremiumMembershipBlock.tsx





// Khối trạng thái gói trong dropdown profile, chỉ hiện với khách đang có gói.
var PremiumMembershipBlock = function() {
    var ref = (0,usePremium/* default */.Z)(), hasActiveMembership = ref.hasActiveMembership, membershipName = ref.membershipName, membershipShortName = ref.membershipShortName, expiredAtText = ref.expiredAtText, remainingDays = ref.remainingDays;
    if (!hasActiveMembership) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ToggleProfile_styles_module_default()).premiumBlock,
        "data-test": "profile-premium-block",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: (ToggleProfile_styles_module_default()).premiumBadge,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                        src: Images/* PREMIUM_STAR_ICON */.JFz,
                        width: "14",
                        height: "14",
                        alt: "Premium",
                        objectFit: "contain"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (ToggleProfile_styles_module_default()).premiumBadgeText,
                        children: membershipShortName
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: (ToggleProfile_styles_module_default()).premiumTitle,
                children: [
                    "G\xf3i ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (ToggleProfile_styles_module_default()).premiumProgramName,
                        children: membershipName
                    }),
                    " đang hoạt động"
                ]
            }),
            expiredAtText ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (ToggleProfile_styles_module_default()).premiumExpiry,
                children: "Hiệu lực đến ".concat(expiredAtText, " \xb7 C\xf2n ").concat(remainingDays, " ng\xe0y")
            }) : null
        ]
    });
};
/* harmony default export */ var ToggleProfile_PremiumMembershipBlock = (PremiumMembershipBlock);

;// CONCATENATED MODULE: ./src/components-v2/mocules/ToggleProfile/index.js











































var isMapData = true;
var MenuItemIcon = function(param) {
    var item = param.item, isActive = param.isActive;
    if ((item === null || item === void 0 ? void 0 : item.url) === Paths/* PRODUCT_CATALOG */.lo) return /*#__PURE__*/ (0,jsx_runtime.jsx)(CatalogMenuIcon, {
        color: isActive ? "var(--primary-color)" : "#333"
    });
    var src = (item === null || item === void 0 ? void 0 : item.isMembershipMenu) ? Images/* PREMIUM_MENU_ICON */.mxk : isActive ? item === null || item === void 0 ? void 0 : item.activeIconUrl : item === null || item === void 0 ? void 0 : item.iconUrl;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* default */.ZP, {
        src: src,
        width: "24",
        height: "24",
        objectFit: "contain"
    });
};
var OBJECT_IMAGE = {
    LEVEL_SILVER: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
        src: Images/* SLIVER_PROFILE */.hOh,
        width: "61",
        height: "28",
        alt: "Bạc",
        objectFit: "contain"
    }),
    LEVEL_GOLD: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
        src: Images/* GOLD_PROFILE */.y23,
        width: "69",
        height: "28",
        alt: "V\xe0ng",
        objectFit: "contain"
    }),
    LEVEL_PLATINUM: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
        src: Images/* PLATINUM_PROFILE */.Ga9,
        width: "91",
        height: "28",
        alt: "Bạch kim",
        objectFit: "contain"
    }),
    LEVEL_DIAMOND: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
        src: Images/* DIAMOND_PROFILE */.iTH,
        width: "101",
        height: "28",
        alt: "Kim cương",
        objectFit: "contain"
    })
};
var WishListItem = function(param) {
    var product = param.product, handleClickLink = param.handleClickLink;
    var appSetting = (0,storeGlobal/* useStore */.oR)(function(state) {
        return state.appSetting;
    });
    var errorMessageProduct = (0,convertNewAPIProduct/* getSKUErrorMessage */.V9)(product, appSetting);
    var hasError = errorMessageProduct || !product.salePrice || product.status === "STOP_SELLING" || product.salePrice === 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkComp/* default */.Z, {
        href: "/product/".concat(product === null || product === void 0 ? void 0 : product.slug),
        onClick: handleClickLink,
        className: (ToggleProfile_styles_module_default()) === null || (ToggleProfile_styles_module_default()) === void 0 ? void 0 : (ToggleProfile_styles_module_default()).wishListItem,
        removeStyles: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackProductImage */.nZ, {
                src: product === null || product === void 0 ? void 0 : product.defaultImage,
                width: "70",
                height: "70",
                alt: "H\xecnh ảnh sản phẩm",
                objectFit: "contain",
                size: "thumbnail",
                quality: 100
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ToggleProfile_styles_module_default()) === null || (ToggleProfile_styles_module_default()) === void 0 ? void 0 : (ToggleProfile_styles_module_default()).infoProduct,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (ToggleProfile_styles_module_default()) === null || (ToggleProfile_styles_module_default()) === void 0 ? void 0 : (ToggleProfile_styles_module_default()).name,
                        children: product === null || product === void 0 ? void 0 : product.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (ToggleProfile_styles_module_default()) === null || (ToggleProfile_styles_module_default()) === void 0 ? void 0 : (ToggleProfile_styles_module_default()).volume,
                        children: product === null || product === void 0 ? void 0 : product.volume
                    }),
                    hasError ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: (ToggleProfile_styles_module_default()).error,
                        children: product.requireGPPMessage || errorMessageProduct || (product === null || product === void 0 ? void 0 : product.errorMessage) || "Đang cập nhật gi\xe1"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SVG/* SVGPrice */.X, {
                        displayPriceFormated: (product === null || product === void 0 ? void 0 : product.displayPriceFormated) || 0,
                        size: "sm"
                    })
                ]
            })
        ]
    });
};
function ToggleProfile(_param) {
    var point = _param.point, level = _param.level, classCustom = _param.classCustom, listMenu = _param.listMenu, user = _param.user, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "point",
        "level",
        "classCustom",
        "listMenu",
        "user"
    ]);
    var router = (0,next_router.useRouter)();
    var divRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var ref1 = (0,react.useState)(null), activeTab = ref1[0], setActiveTab = ref1[1];
    var ref2 = (0,react.useState)([]), wishList = ref2[0], setWishList = ref2[1];
    var ref3 = (0,react.useState)(false), loading = ref3[0], setLoading = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(false), 2), showPoupLogout = ref4[0], toggleLogout = ref4[1];
    var ref5 = useFetchData(WishlistClient/* getMeWishlist */.eP, open, isMapData), data = ref5.data, isLoading = ref5.isLoading, total = ref5.total;
    var ref6 = (0,usePremium/* default */.Z)(), hasActiveMembership = ref6.hasActiveMembership, membershipName = ref6.membershipName;
    var clearCart = (0,CartContext/* useCart */.jD)().clearCart;
    var logout = (0,Auth/* useAuth */.aC)().logout;
    // Danh mục thuốc đang bán: chấm đỏ trên nút dropdown + nhấp nháy mục menu đến khi khách vào trang lần đầu
    var ref7 = (0,react.useState)(false), catalogHighlight = ref7[0], setCatalogHighlight = ref7[1];
    (0,react.useEffect)(function() {
        var mounted = true;
        var visited = false;
        try {
            visited = window.localStorage.getItem("customerCatalogVisited") === "1";
        } catch (e) {
            visited = false;
        }
        if (visited || router.pathname === Paths/* PRODUCT_CATALOG */.lo) {
            setCatalogHighlight(false);
            return undefined;
        }
        (0,_async_to_generator/* default */.Z)(function() {
            var ref, res, state, isNew;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,CustomerCatalogClient/* getCustomerCatalogInitState */.JG)()
                        ];
                    case 1:
                        res = _state.sent();
                        if (!mounted) return [
                            2
                        ];
                        state = res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref[0];
                        isNew = !(0,Clients/* isValid */.JY)(res) || (state === null || state === void 0 ? void 0 : state.status) === "NOT_INIT";
                        setCatalogHighlight(isNew);
                        // Đã init (khách từng vào trang ở máy khác) → ghi nhớ để các lần tải sau không gọi lại
                        if ((0,Clients/* isValid */.JY)(res) && !isNew) {
                            try {
                                window.localStorage.setItem("customerCatalogVisited", "1");
                            } catch (e) {
                            // ignore
                            }
                        }
                        return [
                            2
                        ];
                }
            });
        })();
        return function() {
            mounted = false;
        };
    }, [
        router.pathname
    ]);
    // lazy load: only get debt when open profile
    var ref8 = (0,react.useState)(null), debt = ref8[0], setDebt = ref8[1];
    (0,react.useEffect)(function() {
        if (!open) return;
        if (debt) return;
        (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,UserService/* getDebt */.SI)(user)
                        ];
                    case 1:
                        setDebt.apply(void 0, [
                            _state.sent()
                        ]);
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        open
    ]);
    var handleClick = function() {
        setOpen(function(value) {
            return !value;
        });
    };
    var handleLogout = function() {
        logout(function() {}, {
            clearAll: true
        });
        clearCart();
    };
    var handleMouseEnter = function(index) {
        setActiveTab(index);
    };
    var renderWishList = function(data) {
        if ((data === null || data === void 0 ? void 0 : data.length) > 0) {
            return data === null || data === void 0 ? void 0 : data.map(function(item) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(WishListItem, {
                    product: item,
                    handleClickLink: function() {
                        return setOpen(false);
                    }
                }, item === null || item === void 0 ? void 0 : item.slug);
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (ToggleProfile_styles_module_default()) === null || (ToggleProfile_styles_module_default()) === void 0 ? void 0 : (ToggleProfile_styles_module_default()).emptyContainer,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                    src: Images/* GUIDE_WISH_ITEM */.gb5,
                    width: "210",
                    height: "210",
                    alt: "image",
                    objectFit: "contain"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ToggleProfile_styles_module_default()) === null || (ToggleProfile_styles_module_default()) === void 0 ? void 0 : (ToggleProfile_styles_module_default()).wrapperHereGif,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                        src: Images/* HERE */.STB,
                        width: "56",
                        height: "42",
                        alt: "image",
                        objectFit: "contain"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: (ToggleProfile_styles_module_default()) === null || (ToggleProfile_styles_module_default()) === void 0 ? void 0 : (ToggleProfile_styles_module_default()).textGuide,
                    children: [
                        "H\xe3y nhấn v\xe0o biểu tượng ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (ToggleProfile_styles_module_default()) === null || (ToggleProfile_styles_module_default()) === void 0 ? void 0 : (ToggleProfile_styles_module_default()).boldText,
                            children: "“Tr\xe1i tim” tr\xean thẻ sản phẩm"
                        }),
                        " để th\xeam sản phẩm quan t\xe2m bạn nh\xe9"
                    ]
                })
            ]
        });
    };
    var handleScroll = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var div, loadMoreData, _tmp, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        div = divRef.current;
                        if (!(div.scrollTop + div.clientHeight === div.scrollHeight)) return [
                            3,
                            5
                        ];
                        if (!((wishList === null || wishList === void 0 ? void 0 : wishList.length) < total && !loading)) return [
                            3,
                            5
                        ];
                        setLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        _tmp = {};
                        return [
                            4,
                            (0,WishlistClient/* getMeWishlist */.eP)((_tmp.limit = 10, _tmp.offset = wishList === null || wishList === void 0 ? void 0 : wishList.length, _tmp))
                        ];
                    case 2:
                        loadMoreData = _state.sent();
                        if ((0,Clients/* isValid */.JY)(loadMoreData)) {
                            setWishList(function(prevData) {
                                return (0,_to_consumable_array/* default */.Z)(prevData).concat((0,_to_consumable_array/* default */.Z)((0,convertNewAPIProduct/* default */.ZP)({
                                    product: loadMoreData === null || loadMoreData === void 0 ? void 0 : loadMoreData.data
                                })));
                            });
                        }
                        return [
                            3,
                            5
                        ];
                    case 3:
                        error = _state.sent();
                        setLoading(false);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleScroll() {
            return _ref.apply(this, arguments);
        };
    }();
    // Mục gói thành viên chèn ngay sau "Tài khoản của tôi", chỉ cho khách đang có gói
    var menuItems = (0,react.useMemo)(function() {
        var all = (listMenu === null || listMenu === void 0 ? void 0 : listMenu.items) || [];
        if (!all.length) return all;
        // Mục danh mục luôn nằm ngay dưới "Tài khoản của tôi": CMS có thì lấy item CMS (bỏ khỏi vị trí cũ), chưa có thì chèn tạm
        var catalogItem = all.find(function(x) {
            return (x === null || x === void 0 ? void 0 : x.url) === Paths/* PRODUCT_CATALOG */.lo;
        }) || {
            label: "Danh mục thuốc đang b\xe1n",
            url: Paths/* PRODUCT_CATALOG */.lo
        };
        var items = all.filter(function(x) {
            return (x === null || x === void 0 ? void 0 : x.url) !== Paths/* PRODUCT_CATALOG */.lo;
        });
        var accountIdx = Math.max(items.findIndex(function(x) {
            return (x === null || x === void 0 ? void 0 : x.url) === "/my-account";
        }), 0);
        var extra = [
            catalogItem
        ];
        if (hasActiveMembership) extra.push({
            label: membershipName,
            url: sysconfig/* PREMIUM_LANDING_PAGE_URL */.vi,
            isMembershipMenu: true
        });
        return (0,_to_consumable_array/* default */.Z)(items.slice(0, accountIdx + 1)).concat((0,_to_consumable_array/* default */.Z)(extra), (0,_to_consumable_array/* default */.Z)(items.slice(accountIdx + 1)));
    }, [
        listMenu,
        hasActiveMembership,
        membershipName
    ]);
    var handleQuickAccessLoyaltyPoints = function() {
        router.push("/users/loyalty_points");
    };
    (0,react.useEffect)(function() {
        if ((data === null || data === void 0 ? void 0 : data.length) > 0) {
            setWishList(data);
        }
    }, [
        data
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickAwayListener/* default */.Z, {
        onClickAway: function() {
            return setOpen(false);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
            className: (ToggleProfile_styles_module_default()) === null || (ToggleProfile_styles_module_default()) === void 0 ? void 0 : (ToggleProfile_styles_module_default()).profileContainer,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconButton/* default */.Z, {
                    className: (0,clsx/* default */.Z)((ToggleProfile_styles_module_default()).iconInfo, classCustom),
                    onClick: handleClick,
                    "data-test": "btn-toggle-profile",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore/* default */.Z, {}),
                        catalogHighlight && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (ToggleProfile_styles_module_default()).newDot,
                            "aria-hidden": "true"
                        })
                    ]
                }),
                open && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (ToggleProfile_styles_module_default()) === null || (ToggleProfile_styles_module_default()) === void 0 ? void 0 : (ToggleProfile_styles_module_default()).profilePopup,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (ToggleProfile_styles_module_default()) === null || (ToggleProfile_styles_module_default()) === void 0 ? void 0 : (ToggleProfile_styles_module_default()).wishListContainer,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: (ToggleProfile_styles_module_default()) === null || (ToggleProfile_styles_module_default()) === void 0 ? void 0 : (ToggleProfile_styles_module_default()).wishListTitle,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: (ToggleProfile_styles_module_default()) === null || (ToggleProfile_styles_module_default()) === void 0 ? void 0 : (ToggleProfile_styles_module_default()).textTitle,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                                                    src: Images/* HEART */.sxO,
                                                    width: "24",
                                                    height: "24",
                                                    alt: "Tr\xe1i tim",
                                                    quantity: 100,
                                                    objectFit: "contain"
                                                }),
                                                "Sản phẩm quan t\xe2m"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonBase/* default */.Z, {
                                            className: (ToggleProfile_styles_module_default()) === null || (ToggleProfile_styles_module_default()) === void 0 ? void 0 : (ToggleProfile_styles_module_default()).buttonBase,
                                            onClick: function() {
                                                return router.push("/user/wishlist");
                                            },
                                            children: [
                                                "Xem th\xeam ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                                                    src: Images/* ARROW */.i3K,
                                                    width: "16",
                                                    height: "16",
                                                    alt: "Mũi t\xean",
                                                    quantity: 100,
                                                    objectFit: "contain"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    ref: divRef,
                                    onScroll: handleScroll,
                                    className: (0,clsx/* default */.Z)((ToggleProfile_styles_module_default()) === null || (ToggleProfile_styles_module_default()) === void 0 ? void 0 : (ToggleProfile_styles_module_default()).wishListContent, isLoading && ((ToggleProfile_styles_module_default()) === null || (ToggleProfile_styles_module_default()) === void 0 ? void 0 : (ToggleProfile_styles_module_default()).isLoading)),
                                    children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (ToggleProfile_styles_module_default()) === null || (ToggleProfile_styles_module_default()) === void 0 ? void 0 : (ToggleProfile_styles_module_default()).renderWishList,
                                        children: [
                                            renderWishList(wishList),
                                            loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (ToggleProfile_styles_module_default()) === null || (ToggleProfile_styles_module_default()) === void 0 ? void 0 : (ToggleProfile_styles_module_default()).wrapperLoading,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {})
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (ToggleProfile_styles_module_default()) === null || (ToggleProfile_styles_module_default()) === void 0 ? void 0 : (ToggleProfile_styles_module_default()).menuListContainer,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleProfile_PremiumMembershipBlock, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (ToggleProfile_styles_module_default()) === null || (ToggleProfile_styles_module_default()) === void 0 ? void 0 : (ToggleProfile_styles_module_default()).levelContainer,
                                    onClick: handleQuickAccessLoyaltyPoints,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (ToggleProfile_styles_module_default()) === null || (ToggleProfile_styles_module_default()) === void 0 ? void 0 : (ToggleProfile_styles_module_default()).levelIcon,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (ToggleProfile_styles_module_default()) === null || (ToggleProfile_styles_module_default()) === void 0 ? void 0 : (ToggleProfile_styles_module_default()).leftContent,
                                                children: (debt === null || debt === void 0 ? void 0 : debt.isValid) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            className: (ToggleProfile_styles_module_default()) === null || (ToggleProfile_styles_module_default()) === void 0 ? void 0 : (ToggleProfile_styles_module_default()).debtContent,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                                                                    src: Images/* DEBT */.gJ2,
                                                                    width: "20",
                                                                    height: "20",
                                                                    alt: "Debt",
                                                                    quantity: 100,
                                                                    objectFit: "contain"
                                                                }),
                                                                " Hạn Mức"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: (ToggleProfile_styles_module_default()) === null || (ToggleProfile_styles_module_default()) === void 0 ? void 0 : (ToggleProfile_styles_module_default()).debtValue,
                                                            children: (0,FormatNumber/* formatCurrency */.xG)(debt.balance)
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        "Cấp bậc",
                                                        OBJECT_IMAGE[level]
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (ToggleProfile_styles_module_default()) === null || (ToggleProfile_styles_module_default()) === void 0 ? void 0 : (ToggleProfile_styles_module_default()).customHr
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: (ToggleProfile_styles_module_default()) === null || (ToggleProfile_styles_module_default()) === void 0 ? void 0 : (ToggleProfile_styles_module_default()).rightContent,
                                                children: [
                                                    "Điểm t\xedch lũy",
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: (ToggleProfile_styles_module_default()) === null || (ToggleProfile_styles_module_default()) === void 0 ? void 0 : (ToggleProfile_styles_module_default()).score,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                                                                src: Images/* REWARD_PROFILE */.u_x,
                                                                width: "24",
                                                                height: "24",
                                                                alt: "Huy chương",
                                                                objectFit: "contain"
                                                            }),
                                                            FormatNumber/* default.formatFloatNumber */.ZP.formatFloatNumber(point)
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_ChainStoreSwitcher, {
                                    user: user,
                                    onClose: function() {
                                        return setOpen(false);
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (ToggleProfile_styles_module_default()) === null || (ToggleProfile_styles_module_default()) === void 0 ? void 0 : (ToggleProfile_styles_module_default()).menuContainer,
                                    children: menuItems === null || menuItems === void 0 ? void 0 : menuItems.map(function(x, index) {
                                        var ref;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(react.Fragment, {
                                            children: (x === null || x === void 0 ? void 0 : x.url) !== "/logout" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkComp/* default */.Z, {
                                                href: x === null || x === void 0 ? void 0 : x.url,
                                                target: x === null || x === void 0 ? void 0 : x.isMembershipMenu,
                                                onMouseEnter: function() {
                                                    return handleMouseEnter(index);
                                                },
                                                onMouseOut: function() {
                                                    return setActiveTab(null);
                                                },
                                                className: (0,clsx/* default */.Z)((ToggleProfile_styles_module_default()) === null || (ToggleProfile_styles_module_default()) === void 0 ? void 0 : (ToggleProfile_styles_module_default()).menuItem, (x === null || x === void 0 ? void 0 : x.url) === Paths/* PRODUCT_CATALOG */.lo && catalogHighlight && ((ToggleProfile_styles_module_default()) === null || (ToggleProfile_styles_module_default()) === void 0 ? void 0 : (ToggleProfile_styles_module_default()).menuItemHighlight)),
                                                removeStyles: true,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItemIcon, {
                                                        item: x,
                                                        isActive: activeTab === index
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: (0,clsx/* default */.Z)((ToggleProfile_styles_module_default()) === null || (ToggleProfile_styles_module_default()) === void 0 ? void 0 : (ToggleProfile_styles_module_default()).textLabel, (x === null || x === void 0 ? void 0 : x.url) === Paths/* PRODUCT_CATALOG */.lo && (ToggleProfile_styles_module_default()).textLabelNew),
                                                        children: [
                                                            x === null || x === void 0 ? void 0 : x.label,
                                                            (x === null || x === void 0 ? void 0 : x.url) === Paths/* PRODUCT_CATALOG */.lo && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: (ToggleProfile_styles_module_default()).newBadge,
                                                                children: "Mới"
                                                            }),
                                                            (x === null || x === void 0 ? void 0 : (ref = x.url) === null || ref === void 0 ? void 0 : ref.trim()) === Paths/* MY_ACCOUNT */.RX && (user === null || user === void 0 ? void 0 : user.isVerify) === true && /*#__PURE__*/ (0,jsx_runtime.jsx)(Verified/* default */.Z, {
                                                                titleAccess: "Đ\xe3 x\xe1c thực",
                                                                style: {
                                                                    fontSize: 16,
                                                                    color: "#005C29",
                                                                    marginLeft: 4,
                                                                    verticalAlign: "text-bottom"
                                                                }
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, x === null || x === void 0 ? void 0 : x.url) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonBase/* default */.Z, {
                                                onMouseEnter: function() {
                                                    return handleMouseEnter(index);
                                                },
                                                onMouseOut: function() {
                                                    return setActiveTab(null);
                                                },
                                                onClick: toggleLogout,
                                                className: (ToggleProfile_styles_module_default()) === null || (ToggleProfile_styles_module_default()) === void 0 ? void 0 : (ToggleProfile_styles_module_default()).menuItem,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItemIcon, {
                                                        item: x,
                                                        isActive: activeTab === index
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (ToggleProfile_styles_module_default()) === null || (ToggleProfile_styles_module_default()) === void 0 ? void 0 : (ToggleProfile_styles_module_default()).textLabel,
                                                        children: x === null || x === void 0 ? void 0 : x.label
                                                    })
                                                ]
                                            }, x === null || x === void 0 ? void 0 : x.url)
                                        }, x.label);
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(NewCustomModal/* default */.Z, {
                    visible: showPoupLogout,
                    onClose: toggleLogout,
                    title: "Xin x\xe1c nhận",
                    content: "Bạn c\xf3 chắc muốn đăng xuất?",
                    btnOk: "C\xf3",
                    onClickOk: handleLogout,
                    btnOnClose: "Kh\xf4ng"
                }),
                open && /*#__PURE__*/ (0,jsx_runtime.jsx)(Portal/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
                        disableRipple: true,
                        className: (ToggleProfile_styles_module_default()) === null || (ToggleProfile_styles_module_default()) === void 0 ? void 0 : (ToggleProfile_styles_module_default()).backdrop,
                        onClick: function() {
                            return setOpen(false);
                        }
                    })
                })
            ]
        }))
    });
};

// EXTERNAL MODULE: ./src/constants/Enums/index.js
var Enums = __webpack_require__(71569);
// EXTERNAL MODULE: ./src/hooks/useIsInViewportOnce.js
var useIsInViewportOnce = __webpack_require__(92803);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Badge/Badge.js
var Badge = __webpack_require__(59009);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
;// CONCATENATED MODULE: ./src/components-v2/mocules/ImageHoverEffect/index.js

var ImageHoverEffect = function(param) {
    var defaultImage = param.defaultImage, activeImage = param.activeImage, _width = param.width, width = _width === void 0 ? "20px" : _width, _height = param.height, height = _height === void 0 ? "20px" : _height, _hovered = param.hovered, hovered = _hovered === void 0 ? false : _hovered;
    // Function to escape brackets in the file name
    var escapeBracketsInFileName = function(url) {
        var fileName = url.split("/").pop();
        // Check if the file name contains brackets
        if (/\(|\)/.test(fileName)) {
            fileName = fileName.replace(/\(/g, "\\(").replace(/\)/g, "\\)");
            var modifiedUrl = url.replace(/\/([^\/]+)$/, "/" + fileName);
            return modifiedUrl;
        }
        return url;
    };
    var backgroundImage = hovered && activeImage ? "url(".concat(escapeBracketsInFileName(activeImage), ")") : "url(".concat(escapeBracketsInFileName(defaultImage), ")");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "image-container",
        style: {
            position: "relative",
            width: width,
            height: height,
            overflow: "hidden",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundImage: backgroundImage,
            transition: "background-image 0.3s ease"
        }
    });
};
/* harmony default export */ var mocules_ImageHoverEffect = (ImageHoverEffect);

// EXTERNAL MODULE: ./src/components-v2/layout/Navbar/styles.module.css
var Navbar_styles_module = __webpack_require__(81728);
var Navbar_styles_module_default = /*#__PURE__*/__webpack_require__.n(Navbar_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/layout/Navbar/SubMenuV2.tsx













/**
 * SubMenuV2 Component
 *
 * A two-panel dropdown menu component that displays:
 * - Left Panel: Level 2 items (categories)
 * - Right Panel: Level 3 items (products/services under selected category)
 *
 * Features:
 * - Hover-based navigation between left and right panels
 * - Conditional styling based on whether items have sub-items
 * - Analytics tracking for menu interactions
 * - Smooth transitions and visual feedback
 */ /**
   * eventRef
   * Prevents duplicate analytics events when menu opens
   * Set to true after first open, reset when menu closes
*/ /**
 * hasAnySubItems: 
 * Check if ANY Level 2 item has Level 3 sub-items
 * Used to conditionally apply CSS styling:
 * - When true: removes right padding and border-radius from left panel
 * - When false: keeps default padding and rounded corners
 */ function SubMenuV2(param) {
    var items = param.items, children = param.children;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var ref1 = (0,react.useState)(null), activeItemIndex = ref1[0], setActiveItemIndex = ref1[1];
    var ref2 = (0,react.useState)(null), loadingImageIndex = ref2[0], setLoadingImageIndex = ref2[1];
    var eventRef = (0,react.useRef)(false);
    /** Get the currently active Level 2 item based on activeItemIndex */ var activeItem = activeItemIndex !== null ? items[activeItemIndex] : null;
    /** Get Level 3 items (categories) from the active Level 2 item */ var level3Items = (activeItem === null || activeItem === void 0 ? void 0 : activeItem.categories) || [];
    var handleOpenMenu = (0,react.useCallback)(function() {
        setIsOpen(true);
        if (!eventRef.current) {
            // Track analytics only on first open
            items.forEach(function(item) {
                gtag/* default.showSubMenu */.ZP.showSubMenu(item);
            });
            eventRef.current = true;
        }
    }, [
        items
    ]);
    var handleCloseMenu = (0,react.useCallback)(function() {
        setIsOpen(false);
        setActiveItemIndex(null);
        eventRef.current = false;
    }, []);
    var handleLevel3ItemClick = (0,react.useCallback)(function(item) {
        var ref, ref1, ref2;
        // Replace filter with new level3 item (don't add, replace)
        var newFilter = {
            categoryFilters: [
                {
                    code: item === null || item === void 0 ? void 0 : item.code,
                    categoryCodes: [
                        item === null || item === void 0 ? void 0 : item.code
                    ],
                    efficacyCodes: []
                }, 
            ]
        };
        if ((ref = router.query) === null || ref === void 0 ? void 0 : ref.currentTab) {
            // delete current tab on query
            delete router.query.currentTab;
        }
        if ((ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.slug) {
            delete router.query.slug;
        }
        var newQuery = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
            filter: JSON.stringify(newFilter),
            tag: activeItem === null || activeItem === void 0 ? void 0 : (ref2 = activeItem.mapParams) === null || ref2 === void 0 ? void 0 : ref2.tag,
            page: 1
        });
        router.push({
            pathname: "/products",
            query: newQuery
        }, undefined, {
            scroll: false,
            shallow: false
        });
        gtag/* default.clickSubMenubar */.ZP.clickSubMenubar(item);
        handleCloseMenu();
    }, [
        router,
        activeItem,
        handleCloseMenu
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx/* default */.Z)((Navbar_styles_module_default()).MenuTrigger, (0,_define_property/* default */.Z)({}, (Navbar_styles_module_default()).isActiveMenu, isOpen)),
                onMouseEnter: handleOpenMenu,
                onMouseLeave: handleCloseMenu,
                children: [
                    children,
                    isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Navbar_styles_module_default()).MenuV2,
                        onMouseLeave: function() {
                            setActiveItemIndex(null);
                            handleCloseMenu();
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Navbar_styles_module_default()).MenuV2Wrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Navbar_styles_module_default()).SubMenuContainer,
                                children: [
                                    items.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Navbar_styles_module_default()).LeftPanel,
                                        children: items.map(function(item, index) {
                                            // Check if this specific item has Level 3 categories
                                            var isActive = activeItemIndex === index;
                                            var _obj;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                onMouseEnter: function() {
                                                    setActiveItemIndex(index);
                                                    setLoadingImageIndex(index);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkComp/* default */.Z, {
                                                    removeStyles: true,
                                                    href: (item === null || item === void 0 ? void 0 : item.url) || "#",
                                                    target: undefined,
                                                    className: (0,clsx/* default */.Z)((Navbar_styles_module_default()).LeftPanelItem, (_obj = {}, // Active state: applied when item is hovered
                                                    (0,_define_property/* default */.Z)(_obj, (Navbar_styles_module_default()).LeftPanelItemActive, isActive), // Conditional styling: applied when any item has sub-items
                                                    (0,_define_property/* default */.Z)(_obj, (Navbar_styles_module_default()).LeftPanelItemWithSubItems, (item === null || item === void 0 ? void 0 : item.categories) && item.categories.length > 0), _obj)),
                                                    onClick: function() {
                                                        gtag/* default.clickSubMenubar */.ZP.clickSubMenubar(item);
                                                        handleCloseMenu();
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (Navbar_styles_module_default()).LeftPanelItemContent,
                                                        children: [
                                                            (item === null || item === void 0 ? void 0 : item.iconUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (Navbar_styles_module_default()).LeftPanelIcon,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    width: "24",
                                                                    height: "24",
                                                                    src: (0,ImageUtils/* getLinkCDNImage */.wr)(isActive && (item === null || item === void 0 ? void 0 : item.iconActiveUrl) ? item.iconActiveUrl : item.iconUrl),
                                                                    alt: item.label,
                                                                    unoptimized: true,
                                                                    style: {
                                                                        opacity: loadingImageIndex === index ? 0.5 : 1,
                                                                        transition: "opacity 0.3s ease-in-out"
                                                                    },
                                                                    onLoadingComplete: function() {
                                                                        return setLoadingImageIndex(null);
                                                                    }
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (Navbar_styles_module_default()).LeftPanelLabel,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: item.label
                                                                    }),
                                                                    (item === null || item === void 0 ? void 0 : item.badgeIconUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: (Navbar_styles_module_default()).BadgeIcon,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                            width: "16",
                                                                            height: "16",
                                                                            src: (0,ImageUtils/* getLinkCDNImage */.wr)(item.badgeIconUrl),
                                                                            alt: "badge",
                                                                            unoptimized: true
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            }, "".concat(item.label, "-").concat(item.url));
                                        })
                                    }),
                                    activeItem && level3Items.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Navbar_styles_module_default()).RightPanel,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (Navbar_styles_module_default()).RightPaneCover,
                                            children: level3Items.map(function(item) {
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                                    className: (Navbar_styles_module_default()).RightPanelItem,
                                                    onClick: function() {
                                                        return handleLevel3ItemClick(item);
                                                    },
                                                    role: "button",
                                                    tabIndex: 0,
                                                    onKeyDown: function(e) {
                                                        if (e.key === "Enter" || e.key === " ") {
                                                            handleLevel3ItemClick(item);
                                                        }
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (Navbar_styles_module_default()).RightPanelItemContent,
                                                        children: [
                                                            (item === null || item === void 0 ? void 0 : item.iconCategory) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (Navbar_styles_module_default()).RightPanelIcon,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    width: "60",
                                                                    height: "60",
                                                                    src: (0,ImageUtils/* getLinkCDNImage */.wr)(item === null || item === void 0 ? void 0 : item.iconCategory),
                                                                    alt: item === null || item === void 0 ? void 0 : item.name
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: (Navbar_styles_module_default()).RightPanelLabel,
                                                                children: item === null || item === void 0 ? void 0 : item.name
                                                            })
                                                        ]
                                                    })
                                                }, "".concat(item === null || item === void 0 ? void 0 : item.code, "-").concat(item === null || item === void 0 ? void 0 : item.categoryID));
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OverlayV2, {
                isOpen: isOpen,
                level: 1
            })
        ]
    });
}
/* harmony default export */ var Navbar_SubMenuV2 = (/*#__PURE__*/(0,react.memo)(SubMenuV2));

;// CONCATENATED MODULE: ./src/components-v2/layout/Navbar/index.js





























var getUrl = function(url, redirectUrl) {
    if (redirectUrl) {
        return redirectUrl;
    }
    return url;
};
var getTrackingData = function(url) {
    var dataTracking = [
        {
            action: "CLICK_GO_TO_PRODUCTS_PAGE",
            trackingPath: "/products"
        },
        {
            action: "CLICK_GO_TO_INGREDIENTS_PAGE",
            trackingPath: "/ingredients"
        },
        {
            action: "CLICK_GO_TO_QUICKORDER_PAGE",
            trackingPath: "/quick-order"
        },
        {
            action: "CLICK_GO_TO_CAMPAIGN_PAGE",
            trackingPath: "/khuyenmai"
        },
        {
            action: "CLICK_GO_TO_PROMO_CODES_PAGE",
            trackingPath: "/promo-codes"
        },
        {
            action: "CLICK_GO_TO_SELLER_PAGE",
            trackingPath: "/sellers"
        }, 
    ];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // eslint-disable-next-line no-restricted-syntax
        for(var _iterator = dataTracking[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var data = _step.value;
            if (url.includes(data.trackingPath)) return data;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        action: "CLICK_GO_TO_EVENTS_PAGE",
        trackingPath: "/events"
    };
};
var KEY_MENU_BAR = "menuBar";
var MINUTE_CACHE_MENU = 5;
function Navbar() {
    var ref = (0,Auth/* useAuth */.aC)(), isAuthenticated = ref.isAuthenticated, toggleLogin = ref.toggleLogin;
    var router = (0,next_router.useRouter)();
    var totalItem = (0,CartContext/* useCart */.jD)().totalItem;
    var ref1 = (0,react.useState)([]), menuBar = ref1[0], setMenuBarData = ref1[1];
    var menuBarRender = [];
    if ((menuBar === null || menuBar === void 0 ? void 0 : menuBar.length) > 0) {
        menuBarRender = menuBar.map(function(item, index) {
            var label = item.label, url = item.url, iconWebActiveUrl = item.iconWebActiveUrl, iconWebUrl = item.iconWebUrl, _subMenuItems = item.subMenuItems, subMenuItems = _subMenuItems === void 0 ? [] : _subMenuItems;
            return {
                id: index,
                name: label,
                icon: (0,ImageUtils/* getLinkCDNImage */.wr)(iconWebUrl),
                iconActive: (0,ImageUtils/* getLinkCDNImage */.wr)(iconWebActiveUrl),
                url: url,
                isNew: false,
                width: "20px",
                height: "20px",
                eventPage: false,
                tracking: getTrackingData(url),
                subMenuItems: subMenuItems
            };
        });
    }
    var getActivePage = function() {
        var pathname = (router || {}).pathname;
        if (pathname === "/products" || pathname === "/categories/[slug]" || pathname === "/manufacturers/[slug]" || pathname === Paths/* PRODUCTS_LOADING_URL */.iB) {
            return Paths/* PRODUCTS_URL */.NL;
        }
        if (pathname === Paths/* SELLERS_LOADING_URL */.kH) {
            return Paths/* SELLERS */.UI;
        }
        if (pathname === Paths/* KHUYEN_MAI_LOADING */.hN) {
            return Paths/* KHUYEN_MAI */.ab;
        }
        return router.pathname;
    };
    var handleCheck = function(e) {
        if (!isAuthenticated) {
            e.preventDefault();
            NotifyUtils/* default.error */.Z.error("Bạn cần đăng nhập để v\xe0o trang n\xe0y");
            setTimeout(function() {
                toggleLogin();
            }, 300);
        }
    // setClick(false);
    };
    // useEffect(() => {
    //   gtag.displayTopSearch();
    // }, []);
    var Cart = function(param) {
        var className = param.className;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkComp/* default */.Z, {
                href: Paths/* CART_URL */.fh,
                className: (0,clsx/* default */.Z)((Navbar_styles_module_default()).cartLink, className),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                    badgeContent: totalItem,
                    max: 1000,
                    color: "secondary",
                    overlap: "rectangular",
                    "data-test": "cart-num",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                        title: "Giỏ h\xe0ng",
                        arrow: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            className: (Navbar_styles_module_default()).cart,
                            "data-test": "cart-link",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                                src: Images/* CARTV2_ICON */.iuj,
                                width: "20px",
                                height: "24px",
                                layout: "fixed"
                            })
                        })
                    })
                })
            })
        });
    };
    var renderMenu = function() {
        return menuBarRender === null || menuBarRender === void 0 ? void 0 : menuBarRender.map(function(element) {
            var ref;
            var isParent = (element === null || element === void 0 ? void 0 : (ref = element.subMenuItems) === null || ref === void 0 ? void 0 : ref.length) > 0;
            var isActive = element.url === getActivePage();
            var menuName = isParent ? element.name : "";
            var updatedSubMenuItems = ((element === null || element === void 0 ? void 0 : element.subMenuItems) || []).map(function(item) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                    menuName: menuName
                });
            });
            var renderItems = function(props) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                    className: (0,clsx/* default */.Z)((Navbar_styles_module_default()).link, isActive && (Navbar_styles_module_default()).active),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkComp/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        className: (0,clsx/* default */.Z)((Navbar_styles_module_default()).flexItem),
                        name: element.name,
                        href: getUrl(element.url, element.redirectUrl),
                        target: element.redirectUrl && "_blank",
                        onClick: function(e) {
                            handleCheck(e);
                            gtag/* default.clickMenubar */.ZP.clickMenubar(element);
                        },
                        padding: "0px"
                    }, props), {
                        children: (element === null || element === void 0 ? void 0 : element.icon) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Navbar_styles_module_default()).menuIcons,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_ImageHoverEffect, {
                                defaultImage: (0,ImageUtils/* getLinkCDNImage */.wr)(element === null || element === void 0 ? void 0 : element.icon),
                                activeImage: (0,ImageUtils/* getLinkCDNImage */.wr)(element === null || element === void 0 ? void 0 : element.iconActive),
                                hovered: element.url === getActivePage(element.url)
                            })
                        })
                    }))
                }, element.url);
            };
            if (isParent) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar_SubMenuV2, {
                    items: updatedSubMenuItems,
                    children: renderItems({
                        iconRight: isActive ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ARROW_DOWN_ACTIVE */.UKY, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ARROW_DOWN */.qNi, {})
                    })
                }, element.url);
            }
            return renderItems();
        });
    };
    var fetchMenuBar = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var getListMenuLocal, fetchData, currentTime;
            return (0,tslib_es6.__generator)(this, function(_state) {
                getListMenuLocal = JSON.parse(localStorage.getItem(KEY_MENU_BAR));
                fetchData = function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function() {
                        var res, _tmp, ref, _items, items, expiry, _tmp1;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _tmp = {};
                                    return [
                                        4,
                                        (0,WebServiceClient/* getMenuBar */.F7)(_tmp)
                                    ];
                                case 1:
                                    res = _state.sent();
                                    _tmp1 = {};
                                    if ((0,Clients/* isValid */.JY)(res)) {
                                        ref = (0,Clients/* getFirst */.Xi)(res), _items = ref.items, items = _items === void 0 ? [] : _items;
                                        setMenuBarData(items);
                                        expiry = new Date().getTime() + MINUTE_CACHE_MENU * 60 * 1000;
                                        localStorage.setItem(KEY_MENU_BAR, JSON.stringify((_tmp1.data = items, _tmp1.dayExpired = expiry, _tmp1)));
                                    }
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function fetchData() {
                        return _ref.apply(this, arguments);
                    };
                }();
                if (getListMenuLocal) {
                    currentTime = new Date().getTime();
                    if (getListMenuLocal.dayExpired < currentTime) {
                        fetchData();
                    } else {
                        setMenuBarData(getListMenuLocal === null || getListMenuLocal === void 0 ? void 0 : getListMenuLocal.data);
                    }
                } else {
                    fetchData();
                }
                return [
                    2
                ];
            });
        });
        return function fetchMenuBar() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        fetchMenuBar();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        className: (0,clsx/* default */.Z)((Navbar_styles_module_default()).nav),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            style: {
                maxWidth: "1180px"
            },
            className: (Navbar_styles_module_default()).wrap,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: (0,clsx/* default */.Z)((Navbar_styles_module_default()).WrapmenuFocus),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        container: true,
                        className: (0,clsx/* default */.Z)((Navbar_styles_module_default()).menu, (Navbar_styles_module_default()).h40),
                        style: {
                            width: "100%",
                            transition: "width 1s"
                        },
                        children: renderMenu()
                    }),
                    isAuthenticated && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        className: (0,clsx/* default */.Z)((Navbar_styles_module_default()).wrapSticky),
                        style: {
                            width: "25%",
                            transition: "width 1s"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_SearchInput, {
                                className: (Navbar_styles_module_default()).SearchInput,
                                classCustom: (Navbar_styles_module_default()).hiddenWidth
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                className: (Navbar_styles_module_default()).wrapStickRight,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Cart, {
                                    className: (Navbar_styles_module_default()).cartSticky
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var layout_Navbar = (/*#__PURE__*/(0,react.memo)(Navbar));

// EXTERNAL MODULE: ./src/components-v2/layout/Header/CountDownBar.js + 2 modules
var CountDownBar = __webpack_require__(1553);
// EXTERNAL MODULE: ./src/zustand-lib/useCart.ts
var useCart = __webpack_require__(68140);
// EXTERNAL MODULE: ./src/components-v2/layout/Header/Notification/styles.module.css
var Notification_styles_module = __webpack_require__(11968);
var Notification_styles_module_default = /*#__PURE__*/__webpack_require__.n(Notification_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/layout/Header/Notification/index.tsx






var CartIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "#005C29",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.3943 2.4H3.74199L2.66095 0.369213C2.53961 0.141267 2.31006 0 2.061 0H0.687001C0.307581 0 0 0.322355 0 0.72C0 1.11765 0.307581 1.44 0.687001 1.44H1.65759L2.72446 3.44415L5.1849 9.14964L5.18742 9.15547L5.40414 9.658L2.93383 12.4196C2.7562 12.6181 2.7006 12.9047 2.79013 13.1602C2.87965 13.4157 3.09899 13.5964 3.35701 13.6273L5.60867 13.897C8.42507 14.2344 11.269 14.2344 14.0854 13.897L16.337 13.6273C16.714 13.5822 16.9847 13.2253 16.9416 12.8302C16.8985 12.4352 16.558 12.1515 16.181 12.1967L13.9294 12.4664C11.2166 12.7913 8.47741 12.7913 5.76468 12.4664L4.8711 12.3593L6.68422 10.3324C6.70175 10.3128 6.71804 10.2925 6.73308 10.2715L7.42266 10.3655C8.38897 10.4973 9.36576 10.5231 10.3372 10.4426C12.6029 10.2548 14.7027 9.12488 16.1688 7.30471L16.6983 6.64728C16.7161 6.6252 16.7326 6.60202 16.7477 6.57787L17.7346 5.00169C18.4341 3.88447 17.6694 2.4 16.3943 2.4Z",
                fill: "#005C29"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.80901 15.12C4.05017 15.12 3.435 15.7647 3.435 16.56C3.435 17.3553 4.05017 18 4.80901 18C5.56785 18 6.18301 17.3553 6.18301 16.56C6.18301 15.7647 5.56785 15.12 4.80901 15.12Z",
                fill: "#005C29"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.511 16.56C13.511 15.7647 14.1262 15.12 14.885 15.12C15.6439 15.12 16.259 15.7647 16.259 16.56C16.259 17.3553 15.6439 18 14.885 18C14.1262 18 13.511 17.3553 13.511 16.56Z",
                fill: "#005C29"
            })
        ]
    });
};
function NotificationV2() {
    var cartState = (0,useCart/* default */.ZP)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        className: (Notification_styles_module_default()).headerStatus,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            id: "cart__icon",
            className: (Notification_styles_module_default()).cartContainer,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkComp/* default */.Z, {
                href: Paths/* CART_URL */.fh,
                className: (Notification_styles_module_default()).cartLink,
                name: undefined,
                onMouseOver: undefined,
                target: undefined,
                onClick: undefined,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Notification_styles_module_default()).cart,
                    "data-test": "cart-link",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Notification_styles_module_default()) === null || (Notification_styles_module_default()) === void 0 ? void 0 : (Notification_styles_module_default()).badgeContainer,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CartIcon, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (Notification_styles_module_default()) === null || (Notification_styles_module_default()) === void 0 ? void 0 : (Notification_styles_module_default()).badge,
                                    children: cartState.totalItems >= 100 ? "99+" : cartState.totalItems || 0
                                })
                            ]
                        }),
                        "Giỏ H\xe0ng"
                    ]
                })
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ExitToApp.js
var ExitToApp = __webpack_require__(12972);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/LocationOn.js
var LocationOn = __webpack_require__(59832);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Phone.js
var Phone = __webpack_require__(69193);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/SupervisorAccount.js
var SupervisorAccount = __webpack_require__(71686);
// EXTERNAL MODULE: ./src/components-v2/layout/Header/ImpersonationBanner.module.css
var ImpersonationBanner_module = __webpack_require__(95649);
var ImpersonationBanner_module_default = /*#__PURE__*/__webpack_require__.n(ImpersonationBanner_module);
;// CONCATENATED MODULE: ./src/components-v2/layout/Header/ImpersonationBanner.tsx
























var ImpersonationBanner_StoreAvatar = function(param) {
    var name = param.name, avatarURL = param.avatarURL, fallbackLetter = param.fallbackLetter;
    var ref = (0,react.useState)(false), hasError = ref[0], setHasError = ref[1];
    var cdnUrl = avatarURL && !hasError ? (0,ImageUtils/* getLinkCDNImage */.wr)(avatarURL) : "";
    if (cdnUrl) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            src: cdnUrl,
            alt: name || "Avatar",
            className: (ImpersonationBanner_module_default()).avatarImg,
            onError: function() {
                return setHasError(true);
            }
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (ImpersonationBanner_module_default()).avatarFallback,
        children: fallbackLetter || (name ? name.charAt(0).toUpperCase() : "S")
    });
};
var ImpersonationBanner = function(param) {
    var user = param.user;
    var ref;
    var ref1 = (0,react.useState)(false), mounted = ref1[0], setMounted = ref1[1];
    var ref2 = (0,react.useState)(null), chainSession = ref2[0], setChainSession = ref2[1];
    var ref3 = (0,react.useState)(false), dropdownOpen = ref3[0], setDropdownOpen = ref3[1];
    var ref4 = (0,react.useState)(false), loading = ref4[0], setLoading = ref4[1];
    var ref5 = (0,react.useState)(null), switchingAccountId = ref5[0], setSwitchingAccountId = ref5[1];
    var ref6 = (0,react.useState)(""), searchQuery = ref6[0], setSearchQuery = ref6[1];
    var ref7 = (0,react.useState)(null), chainData = ref7[0], setChainData = ref7[1];
    (0,react.useEffect)(function() {
        setMounted(true);
        setChainSession((0,ChainSessionUtils/* getValidatedChainSessionState */.c5)(user));
    }, [
        user
    ]);
    (0,react.useEffect)(function() {
        if (!user || !(user === null || user === void 0 ? void 0 : user.accountID) || !(chainSession === null || chainSession === void 0 ? void 0 : chainSession.isImpersonating)) return;
        var isMounted = true;
        var loadChildren = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var loadedData;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setLoading(true);
                            return [
                                4,
                                (0,ChainSessionUtils/* fetchChainChildrenWithRetry */.VZ)(function() {
                                    return !isMounted;
                                })
                            ];
                        case 1:
                            loadedData = _state.sent();
                            if (!isMounted) return [
                                2
                            ];
                            setLoading(false);
                            if (loadedData) {
                                setChainData(loadedData);
                            } else {
                                setChainData(null);
                                NotifyUtils/* default.error */.Z.error("Kh\xf4ng thể tải danh s\xe1ch chi nh\xe1nh. Vui l\xf2ng thử lại sau.");
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function loadChildren() {
                return _ref.apply(this, arguments);
            };
        }();
        loadChildren();
        return function() {
            isMounted = false;
        };
    }, [
        user,
        chainSession === null || chainSession === void 0 ? void 0 : chainSession.isImpersonating
    ]);
    if (!mounted || !user || !(user === null || user === void 0 ? void 0 : user.accountID) || !chainSession || !chainSession.isImpersonating) {
        return null;
    }
    var handleReturn = function() {
        if (switchingAccountId !== null) {
            return;
        }
        (0,ChainSessionUtils/* restoreParentSession */.nI)();
        NotifyUtils/* default.success */.Z.success("Đ\xe3 trở về t\xe0i khoản ch\xednh");
        window.location.reload();
    };
    var activeChildAccountId = chainSession.activeChildAccountId;
    var activeChild = chainData === null || chainData === void 0 ? void 0 : (ref = chainData.children) === null || ref === void 0 ? void 0 : ref.find(function(c) {
        return c.accountID === activeChildAccountId;
    });
    var childName = (activeChild === null || activeChild === void 0 ? void 0 : activeChild.name) || chainSession.activeChildStoreName || (user === null || user === void 0 ? void 0 : user.name) || "Chi nh\xe1nh";
    var parentName = (chainData === null || chainData === void 0 ? void 0 : chainData.parentName) || chainSession.parentCustomerName || "Cửa h\xe0ng ch\xednh";
    var parentAvatarURL = chainData === null || chainData === void 0 ? void 0 : chainData.parentAvatarURL;
    var totalStores = (chainData === null || chainData === void 0 ? void 0 : chainData.totalStores) || ((chainData === null || chainData === void 0 ? void 0 : chainData.children) ? chainData.children.length + 1 : 1);
    var currentPhone = (activeChild === null || activeChild === void 0 ? void 0 : activeChild.phone) || chainSession.activeChildPhone || (user === null || user === void 0 ? void 0 : user.phone);
    var currentAddress = (activeChild === null || activeChild === void 0 ? void 0 : activeChild.address) || chainSession.activeChildAddress || (user === null || user === void 0 ? void 0 : user.address);
    var hasValidAddress = Boolean(currentAddress);
    var filteredChildren = ((chainData === null || chainData === void 0 ? void 0 : chainData.children) || []).filter(function(c) {
        if (!searchQuery.trim()) return true;
        var q = searchQuery.toLowerCase().trim();
        return c.name && c.name.toLowerCase().includes(q) || c.code && c.code.toLowerCase().includes(q);
    });
    var handleSwitchToChild = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(child) {
            var activeSessionToken, parentToken, ref, ref1, ref2, ref3, ref4, ref5, resp, _tmp, impersonateToken, _tmp1, _tmp2, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (switchingAccountId !== null || activeChildAccountId === child.accountID) {
                            return [
                                2
                            ];
                        }
                        setSwitchingAccountId(child.accountID);
                        activeSessionToken = (0,SessionUtils/* getSessionTokenClient */.c)();
                        parentToken = chainSession.parentToken || activeSessionToken;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        _tmp = {};
                        return [
                            4,
                            (0,ChainClient/* switchChildAccount */.y$)((_tmp.childAccountId = child.accountID, _tmp.token = parentToken, _tmp))
                        ];
                    case 2:
                        resp = _state.sent();
                        impersonateToken = (resp === null || resp === void 0 ? void 0 : (ref = resp.data) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.accessToken) || (resp === null || resp === void 0 ? void 0 : (ref2 = resp.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.access_token) || (resp === null || resp === void 0 ? void 0 : (ref4 = resp.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[0]) === null || ref5 === void 0 ? void 0 : ref5.token);
                        _tmp1 = {};
                        _tmp2 = {};
                        if ((0,Clients/* isValid */.JY)(resp) && impersonateToken) {
                            (0,ChainSessionUtils/* setChildImpersonationSession */.Gn)(impersonateToken, parentToken, (_tmp1.accountID = (chainData === null || chainData === void 0 ? void 0 : chainData.parentAccountID) || chainSession.parentAccountId, _tmp1.name = (chainData === null || chainData === void 0 ? void 0 : chainData.parentName) || chainSession.parentCustomerName, _tmp1.code = chainSession.parentCustomerCode || "", _tmp1.chainCode = (chainData === null || chainData === void 0 ? void 0 : chainData.chainCode) || chainSession.chainCode || "", _tmp1), (_tmp2.accountID = child.accountID, _tmp2.code = child.code, _tmp2.name = child.name, _tmp2.avatarURL = child.avatarURL, _tmp2.phone = child.phone, _tmp2.address = child.address, _tmp2.chainCode = (chainData === null || chainData === void 0 ? void 0 : chainData.chainCode) || chainSession.chainCode || "", _tmp2));
                            NotifyUtils/* default.success */.Z.success("Đ\xe3 chuyển sang chi nh\xe1nh: ".concat(child.name));
                            setDropdownOpen(false);
                            window.location.reload();
                        } else {
                            if (activeSessionToken) {
                                (0,ChainSessionUtils/* restoreActiveChildSession */.d3)(activeSessionToken);
                            }
                            NotifyUtils/* default.error */.Z.error((resp === null || resp === void 0 ? void 0 : resp.message) || "Kh\xf4ng thể chuyển sang t\xe0i khoản chi nh\xe1nh n\xe0y.");
                            setSwitchingAccountId(null);
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        if (activeSessionToken) {
                            (0,ChainSessionUtils/* restoreActiveChildSession */.d3)(activeSessionToken);
                        }
                        NotifyUtils/* default.error */.Z.error((e === null || e === void 0 ? void 0 : e.message) || "Đ\xe3 c\xf3 lỗi xảy ra khi chuyển t\xe0i khoản.");
                        setSwitchingAccountId(null);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSwitchToChild(child) {
            return _ref.apply(this, arguments);
        };
    }();
    var renderTooltipContent = function(name, phone, address) {
        var isActive = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (ImpersonationBanner_module_default()).tooltipContainer,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ImpersonationBanner_module_default()).tooltipName,
                    children: name
                }),
                phone ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (ImpersonationBanner_module_default()).tooltipMeta,
                    children: [
                        "SĐT: ",
                        phone
                    ]
                }) : null,
                address ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (ImpersonationBanner_module_default()).tooltipMeta,
                    children: [
                        "Địa chỉ: ",
                        address
                    ]
                }) : null,
                !isActive && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ImpersonationBanner_module_default()).tooltipInactiveWarning,
                    children: "⚠️ T\xe0i khoản chi nh\xe1nh hiện chưa k\xedch hoạt hoặc tạm kh\xf3a. Vui l\xf2ng li\xean hệ CSKH để được hỗ trợ."
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (ImpersonationBanner_module_default()).bannerContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (ImpersonationBanner_module_default()).contentWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (ImpersonationBanner_module_default()).leftGroup,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (ImpersonationBanner_module_default()).roleTag,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SupervisorAccount/* default */.Z, {
                                    className: (ImpersonationBanner_module_default()).roleIcon
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "ĐẠI DIỆN CHUỖI"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (ImpersonationBanner_module_default()).divider,
                            children: "|"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: (ImpersonationBanner_module_default()).bannerText,
                            children: [
                                "Đang thao t\xe1c tại:",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                                    title: childName,
                                    arrow: true,
                                    placement: "bottom",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (ImpersonationBanner_module_default()).bannerStoreName,
                                        children: childName
                                    })
                                })
                            ]
                        }),
                        currentPhone ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (ImpersonationBanner_module_default()).bulletDot,
                                    children: "•"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                                    title: "SĐT: ".concat(currentPhone),
                                    arrow: true,
                                    placement: "bottom",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: (ImpersonationBanner_module_default()).metaItem,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Phone/* default */.Z, {
                                                className: (ImpersonationBanner_module_default()).metaIcon
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (ImpersonationBanner_module_default()).metaText,
                                                children: currentPhone
                                            })
                                        ]
                                    })
                                })
                            ]
                        }) : null,
                        hasValidAddress ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (ImpersonationBanner_module_default()).bulletDot,
                                    children: "•"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                                    title: "Địa chỉ: ".concat(currentAddress),
                                    arrow: true,
                                    placement: "bottom",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: (ImpersonationBanner_module_default()).metaItem,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationOn/* default */.Z, {
                                                className: (ImpersonationBanner_module_default()).metaIcon
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (ImpersonationBanner_module_default()).metaTextAddress,
                                                children: currentAddress
                                            })
                                        ]
                                    })
                                })
                            ]
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (ImpersonationBanner_module_default()).rightGroup,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickAwayListener/* default */.Z, {
                            onClickAway: function() {
                                return setDropdownOpen(false);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (ImpersonationBanner_module_default()).dropdownContainer,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        type: "button",
                                        className: (0,clsx/* default */.Z)((ImpersonationBanner_module_default()).dropdownTriggerBtn, dropdownOpen && (ImpersonationBanner_module_default()).dropdownTriggerActive),
                                        onClick: function() {
                                            return setDropdownOpen(function(v) {
                                                return !v;
                                            });
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapHoriz/* default */.Z, {
                                                fontSize: "small"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "Đổi chi nh\xe1nh"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore/* default */.Z, {
                                                className: (0,clsx/* default */.Z)((ImpersonationBanner_module_default()).chevronIcon, dropdownOpen && (ImpersonationBanner_module_default()).chevronOpen)
                                            })
                                        ]
                                    }),
                                    dropdownOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (ImpersonationBanner_module_default()).bannerDropdownPopover,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (ImpersonationBanner_module_default()).popoverTitle,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "Hệ Thống Chi Nh\xe1nh"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: (ImpersonationBanner_module_default()).popoverCountBadge,
                                                        children: [
                                                            totalStores,
                                                            " chi nh\xe1nh"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            totalStores > 3 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (ImpersonationBanner_module_default()).searchBox,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {
                                                        className: (ImpersonationBanner_module_default()).searchIcon
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "text",
                                                        className: (ImpersonationBanner_module_default()).searchInput,
                                                        placeholder: "T\xecm kiếm chi nh\xe1nh...",
                                                        value: searchQuery,
                                                        onChange: function(e) {
                                                            return setSearchQuery(e.target.value);
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                                                title: renderTooltipContent(parentName),
                                                arrow: true,
                                                placement: "left",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (0,clsx/* default */.Z)((ImpersonationBanner_module_default()).parentCard, switchingAccountId !== null && (ImpersonationBanner_module_default()).parentCardDisabled),
                                                    onClick: handleReturn,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (ImpersonationBanner_module_default()).storeMeta,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (ImpersonationBanner_module_default()).avatarWrapper,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImpersonationBanner_StoreAvatar, {
                                                                        name: parentName,
                                                                        avatarURL: parentAvatarURL,
                                                                        fallbackLetter: "M"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: (ImpersonationBanner_module_default()).storeText,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: (ImpersonationBanner_module_default()).storeName,
                                                                            children: parentName
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: (ImpersonationBanner_module_default()).parentBadge,
                                                                            children: "CỬA H\xc0NG CH\xcdNH"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                                                            title: "Quay lại t\xe0i khoản ch\xednh",
                                                            arrow: true,
                                                            placement: "top",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (ImpersonationBanner_module_default()).switchIconBtn,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapHoriz/* default */.Z, {
                                                                    fontSize: "small"
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (ImpersonationBanner_module_default()).sectionDivider,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (ImpersonationBanner_module_default()).sectionDividerText,
                                                        children: "Chi nh\xe1nh trực thuộc"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (ImpersonationBanner_module_default()).dividerLine
                                                    })
                                                ]
                                            }),
                                            loading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (ImpersonationBanner_module_default()).loadingNotice,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                                        size: 16,
                                                        className: (ImpersonationBanner_module_default()).switchingSpinner
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "Đang tải danh s\xe1ch chi nh\xe1nh..."
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (ImpersonationBanner_module_default()).childList,
                                                children: filteredChildren.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (ImpersonationBanner_module_default()).emptyNotice,
                                                    children: "Kh\xf4ng t\xecm thấy chi nh\xe1nh ph\xf9 hợp"
                                                }) : filteredChildren.map(function(child) {
                                                    var isStoreActive = (0,ChainSessionUtils/* isChildStoreActive */.yo)(child);
                                                    var isCurrentActive = activeChildAccountId === child.accountID;
                                                    var isSwitchingThis = switchingAccountId === child.accountID;
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                                                        title: renderTooltipContent(child.name, child.phone, child.address, isStoreActive),
                                                        arrow: true,
                                                        placement: "left",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (0,clsx/* default */.Z)((ImpersonationBanner_module_default()).childItem, isCurrentActive && (ImpersonationBanner_module_default()).childItemActive, (!isStoreActive || switchingAccountId !== null && !isSwitchingThis) && (ImpersonationBanner_module_default()).childItemDisabled, switchingAccountId !== null && !isSwitchingThis && (ImpersonationBanner_module_default()).itemDisabledDuringSwitch),
                                                            onClick: function() {
                                                                if (!isStoreActive || switchingAccountId !== null) return;
                                                                if (!isCurrentActive) {
                                                                    handleSwitchToChild(child);
                                                                }
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: (ImpersonationBanner_module_default()).storeMeta,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: (ImpersonationBanner_module_default()).avatarWrapper,
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImpersonationBanner_StoreAvatar, {
                                                                                name: child.name,
                                                                                avatarURL: child.avatarURL,
                                                                                fallbackLetter: "C"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (ImpersonationBanner_module_default()).storeText,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: (ImpersonationBanner_module_default()).storeName,
                                                                                    children: child.name
                                                                                }),
                                                                                !isStoreActive && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: (ImpersonationBanner_module_default()).inactiveStoreBadge,
                                                                                    children: "Chưa k\xedch hoạt"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    children: !isStoreActive ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                                                                        title: "T\xe0i khoản chưa k\xedch hoạt - Li\xean hệ CSKH",
                                                                        arrow: true,
                                                                        placement: "top",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: (ImpersonationBanner_module_default()).disabledLockBtn,
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Lock/* default */.Z, {
                                                                                fontSize: "small"
                                                                            })
                                                                        })
                                                                    }) : isSwitchingThis ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                                                        size: 16,
                                                                        className: (ImpersonationBanner_module_default()).switchingSpinner
                                                                    }) : isCurrentActive ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCircle/* default */.Z, {
                                                                        className: (ImpersonationBanner_module_default()).activeCheckIcon
                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                                                                        title: "Chuyển sang chi nh\xe1nh n\xe0y",
                                                                        arrow: true,
                                                                        placement: "top",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: (ImpersonationBanner_module_default()).switchIconBtn,
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapHoriz/* default */.Z, {
                                                                                fontSize: "small"
                                                                            })
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }, child.customerID);
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            type: "button",
                            className: (0,clsx/* default */.Z)((ImpersonationBanner_module_default()).returnBtn, switchingAccountId !== null && (ImpersonationBanner_module_default()).itemDisabledDuringSwitch),
                            onClick: handleReturn,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ExitToApp/* default */.Z, {
                                    fontSize: "small"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Trở về t\xe0i khoản ch\xednh"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Header_ImpersonationBanner = (ImpersonationBanner);

// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Warning.js
var Warning = __webpack_require__(21727);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/NotificationImportant.js
var NotificationImportant = __webpack_require__(37401);
// EXTERNAL MODULE: ./src/components-v2/mocules/ConcurrentPresenceOverlay/styles.module.css
var ConcurrentPresenceOverlay_styles_module = __webpack_require__(52479);
var ConcurrentPresenceOverlay_styles_module_default = /*#__PURE__*/__webpack_require__.n(ConcurrentPresenceOverlay_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/mocules/ConcurrentPresenceOverlay/index.tsx





var ConcurrentPresenceOverlay = function(param) {
    var isConcurrent = param.isConcurrent, presence = param.presence, isMinimized = param.isMinimized, onAcknowledge = param.onAcknowledge, onReopen = param.onReopen, isImpersonating = param.isImpersonating;
    if (!isConcurrent) {
        return null;
    }
    if (isMinimized) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (ConcurrentPresenceOverlay_styles_module_default()).minimizedPill,
            onClick: onReopen,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationImportant/* default */.Z, {
                    fontSize: "small"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "Ph\xe1t hiện phi\xean đăng nhập đồng thời"
                })
            ]
        });
    }
    var isImpersonatorView = presence === "owner-active" || isImpersonating;
    var warningMessage = isImpersonatorView ? "Chủ t\xe0i khoản chi nh\xe1nh đang online v\xe0 tương t\xe1c đồng thời. Vui l\xf2ng cẩn trọng khi thực hiện đơn h\xe0ng hoặc chỉnh sửa giỏ h\xe0ng để tr\xe1nh xung đột dữ liệu." : "Cửa h\xe0ng ch\xednh đang đồng thời đăng nhập v\xe0 thao t\xe1c tr\xean t\xe0i khoản của bạn. Vui l\xf2ng lưu \xfd c\xe1c thay đổi th\xf4ng tin hoặc giỏ h\xe0ng c\xf3 thể bị ảnh hưởng.";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (ConcurrentPresenceOverlay_styles_module_default()).overlayBackdrop,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (ConcurrentPresenceOverlay_styles_module_default()).modalCard,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ConcurrentPresenceOverlay_styles_module_default()).iconHeader,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Warning/* default */.Z, {
                        className: (ConcurrentPresenceOverlay_styles_module_default()).warningIcon
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ConcurrentPresenceOverlay_styles_module_default()).warningTitle,
                    children: "Ph\xe1t Hiện Đăng Nhập Đồng Thời"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ConcurrentPresenceOverlay_styles_module_default()).warningBody,
                    children: warningMessage
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    type: "button",
                    className: (ConcurrentPresenceOverlay_styles_module_default()).acknowledgeBtn,
                    onClick: onAcknowledge,
                    children: "Đ\xe3 hiểu & Tiếp tục"
                })
            ]
        })
    });
};
/* harmony default export */ var mocules_ConcurrentPresenceOverlay = (ConcurrentPresenceOverlay);

;// CONCATENATED MODULE: ./src/hooks/useConcurrentPresencePolling.ts





function readMinimizedState() {
    if (false) {}
    try {
        return sessionStorage.getItem(ChainSessionUtils/* CHAIN_PRESENCE_MINIMIZED_KEY */.Pp) === "1";
    } catch (e) {
        return false;
    }
}
function writeMinimizedState(minimized) {
    if (false) {}
    try {
        if (minimized) {
            sessionStorage.setItem(ChainSessionUtils/* CHAIN_PRESENCE_MINIMIZED_KEY */.Pp, "1");
        } else {
            sessionStorage.removeItem(ChainSessionUtils/* CHAIN_PRESENCE_MINIMIZED_KEY */.Pp);
        }
    } catch (e) {
    /* ignore storage access error */ }
}
/**
 * Periodically polls concurrent presence status for chain accounts or impersonated sessions.
 */ function useConcurrentPresencePolling() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _isChildOrImpersonating = ref.isChildOrImpersonating, isChildOrImpersonating = _isChildOrImpersonating === void 0 ? false : _isChildOrImpersonating;
    var ref1 = (0,react.useState)(false), isConcurrent = ref1[0], setIsConcurrent = ref1[1];
    var ref2 = (0,react.useState)("none"), presence = ref2[0], setPresence = ref2[1];
    var ref3 = (0,react.useState)(function() {
        return readMinimizedState();
    }), isMinimized = ref3[0], setIsMinimized = ref3[1];
    var shouldPoll = Boolean(isChildOrImpersonating);
    var acknowledge = (0,react.useCallback)(function() {
        setIsMinimized(true);
        writeMinimizedState(true);
    }, []);
    var reopen = (0,react.useCallback)(function() {
        setIsMinimized(false);
        writeMinimizedState(false);
    }, []);
    var reset = (0,react.useCallback)(function() {
        setIsConcurrent(false);
        setPresence("none");
        setIsMinimized(false);
        writeMinimizedState(false);
    }, []);
    (0,react.useEffect)(function() {
        if (!shouldPoll) {
            setIsConcurrent(false);
            setPresence("none");
            return;
        }
        var isMounted = true;
        var isStoppedByAuth = false;
        var checkPresence = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var res, data, concurrent, presenceStatus, e;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (isStoppedByAuth) {
                                return [
                                    2
                                ];
                            }
                            if (typeof document !== "undefined" && document.visibilityState === "hidden") {
                                return [
                                    2
                                ];
                            }
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                (0,ChainClient/* getConcurrentPresence */.Zp)()
                            ];
                        case 2:
                            res = _state.sent();
                            if (!isMounted) {
                                return [
                                    2
                                ];
                            }
                            if ((res === null || res === void 0 ? void 0 : res.status) === 401 || (res === null || res === void 0 ? void 0 : res.status) === 403) {
                                isStoppedByAuth = true;
                                return [
                                    2
                                ];
                            }
                            if (res && (res.status === "OK" || res.status === 200) && Array.isArray(res.data)) {
                                data = res.data[0];
                                concurrent = Boolean(data === null || data === void 0 ? void 0 : data.isConcurrent);
                                presenceStatus = (data === null || data === void 0 ? void 0 : data.presence) || "none";
                                setIsConcurrent(concurrent);
                                setPresence(presenceStatus);
                                if (!concurrent) {
                                    setIsMinimized(false);
                                    writeMinimizedState(false);
                                } else {
                                    setIsMinimized(readMinimizedState());
                                }
                            }
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function checkPresence() {
                return _ref.apply(this, arguments);
            };
        }();
        var handleVisibilityChange = function() {
            if (document.visibilityState === "visible") {
                checkPresence();
            }
        };
        checkPresence();
        var intervalId = setInterval(checkPresence, 30000);
        if (typeof document !== "undefined") {
            document.addEventListener("visibilitychange", handleVisibilityChange);
        }
        return function() {
            isMounted = false;
            clearInterval(intervalId);
            if (typeof document !== "undefined") {
                document.removeEventListener("visibilitychange", handleVisibilityChange);
            }
        };
    }, [
        shouldPoll,
        reset
    ]);
    return {
        isConcurrent: isConcurrent,
        presence: presence,
        isMinimized: isMinimized,
        acknowledge: acknowledge,
        reopen: reopen,
        reset: reset
    };
}
/* harmony default export */ var hooks_useConcurrentPresencePolling = ((/* unused pure expression or super */ null && (useConcurrentPresencePolling)));

// EXTERNAL MODULE: ./src/components-v2/layout/Header/styles.module.css
var Header_styles_module = __webpack_require__(4530);
var Header_styles_module_default = /*#__PURE__*/__webpack_require__.n(Header_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/layout/Header/index.js











































var KEY_DROPDOWN_LOCAL = "dropDownMenuList";
var Header_MINUTE_CACHE_MENU = 5;
var DEFAULT_MENU_PROFILE = {
    items: [
        {
            activeColor: "var(--primary-color)",
            activeIconUrl: "https://cdn-gcs.thuocsi.vn/thuocsi-live/internal/cms/20246ba740922e7c9353359ffba9f70dIcon.svg",
            code: "2EEQ1PGE",
            color: "#333333",
            iconUrl: "https://cdn-gcs.thuocsi.vn/thuocsi-live/internal/cms/2024aee7e46390bba5781d7cf6cd5392Icon-1.svg",
            isActive: true,
            label: "T\xe0i khoản của t\xf4i",
            platform: "WEB",
            priority: 1,
            systemDisplay: "BUYMED",
            type: "MENU_PROFILE",
            url: "/my-account"
        },
        {
            activeColor: "var(--primary-color)",
            activeIconUrl: "https://cdn-gcs.thuocsi.vn/thuocsi-live/internal/cms/2024cc22f4c18f5dc848b92873c869c0Product_Cost.svg",
            code: "4T84FW96",
            color: "#333333",
            iconUrl: "https://cdn-gcs.thuocsi.vn/thuocsi-live/internal/cms/20244180af43ac1ca5e1cdb5df436694Product_Cost-1.svg",
            isActive: true,
            label: "Đơn h\xe0ng của t\xf4i",
            platform: "WEB",
            priority: 2,
            systemDisplay: "BUYMED",
            type: "MENU_PROFILE",
            url: "/my-order"
        },
        {
            activeColor: "var(--primary-color)",
            activeIconUrl: "https://cdn-gcs.thuocsi.vn/thuocsi-live/internal/cms/202457835cb20dd863215c8ac22dd082diem_tich_luy_active.svg",
            code: "6U961PGE",
            color: "#333333",
            iconUrl: "https://cdn-gcs.thuocsi.vn/thuocsi-live/internal/cms/20249410565fc83ff432dea126f4fda8dtl_non.svg",
            isActive: true,
            label: "Điểm t\xedch lũy",
            platform: "WEB",
            priority: 3,
            systemDisplay: "BUYMED",
            type: "MENU_PROFILE",
            url: "/users/loyalty_points"
        },
        {
            activeColor: "var(--primary-color)",
            activeIconUrl: "https://cdn-gcs.thuocsi.vn/thuocsi-live/internal/cms/2024019ec790f3dcc5814b1ee8cab352Message_4.svg",
            code: "7P2AXHR2",
            color: "#333333",
            iconUrl: "https://cdn-gcs.thuocsi.vn/thuocsi-live/internal/cms/20240c5f136a9b1b9692d7e21927ba73phan_hoi_non_ac.svg",
            isActive: true,
            label: "Phản hồi của t\xf4i	",
            platform: "WEB",
            priority: 4,
            systemDisplay: "BUYMED",
            type: "MENU_PROFILE",
            url: "/users/my-ticket	"
        },
        {
            activeColor: "var(--primary-color)",
            activeIconUrl: "https://cdn-gcs.thuocsi.vn/thuocsi-live/internal/cms/2024d9bb427cd768e5eecc562578f2f2ct_tt.svg",
            code: "8AV84FW9",
            color: "#333333",
            iconUrl: "https://cdn-gcs.thuocsi.vn/thuocsi-live/internal/cms/2024fcf7f1a1b808d3f8c39c9e5a8502ct_tt_non.svg",
            isActive: true,
            label: "Chương tr\xecnh trả thưởng",
            platform: "WEB",
            priority: 5,
            systemDisplay: "BUYMED",
            type: "MENU_PROFILE",
            url: "/users/rewards	"
        },
        {
            activeColor: "15A959",
            activeIconUrl: "https://cdn-gcs.thuocsi.vn/thuocsi-live/internal/cms/2024521d938a6672f226bc320bf08c9fdang_xuat_ac.svg",
            code: "1WJYJYJY",
            color: "#333333",
            iconUrl: "https://cdn-gcs.thuocsi.vn/thuocsi-live/internal/cms/2024da9fe07660ac55f017addf3fb57dFrame-3.svg",
            isActive: true,
            label: "Đăng xuất",
            platform: "WEB",
            priority: 6,
            systemDisplay: "BUYMED",
            type: "MENU_PROFILE",
            url: "/logout"
        }, 
    ]
};
function Logo() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkComp/* default */.Z, {
        href: "/home",
        id: "logo-thuocsi",
        padding: "0px",
        title: constants_data/* DEFAULT_THUOCSI_LONG_TITLE */.A1,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            className: (Header_styles_module_default()).logo,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                src: Images/* THUOCSI_HEADER_LOGO_SVG */.g2u,
                width: "108px",
                height: "22px",
                quality: 100,
                layout: "fixed",
                alt: constants_data/* DEFAULT_THUOCSI_LONG_TITLE */.A1,
                title: constants_data/* DEFAULT_THUOCSI_LONG_TITLE */.A1
            })
        })
    });
}
var HeadericonRight = /*#__PURE__*/ (0,react.memo)(function HeadericonRight(props) {
    var ref, ref1;
    var ref2 = (0,Notifications/* useNotify */.d$)(), markAll = ref2.markAll, numberNotifyWithTab = ref2.numberNotifyWithTab, fetchDataByTab = ref2.fetchDataByTab;
    var reloadDataCustomer = (0,Auth/* useAuth */.aC)().reloadDataCustomer;
    var ref3 = (0,usePremium/* default */.Z)(), hasActiveMembership = ref3.hasActiveMembership, membershipName = ref3.membershipName;
    var ref4 = (0,react.useState)(null), anchorEl = ref4[0], setAnchorEl = ref4[1];
    var ref5 = (0,react.useState)(NewNotification_interface/* ENUM_NOTIFICATION_TAB.IMPORTANT */.V.IMPORTANT), notiTab = ref5[0], setNotiTab = ref5[1];
    var open = Boolean(anchorEl);
    var handleClick = function(event) {
        var ref;
        if (notiTab && (numberNotifyWithTab === null || numberNotifyWithTab === void 0 ? void 0 : (ref = numberNotifyWithTab[notiTab.toLowerCase()]) === null || ref === void 0 ? void 0 : ref.unread) > 0) {
            markAll(notiTab, false);
        }
        setAnchorEl(event === null || event === void 0 ? void 0 : event.currentTarget);
        reloadDataCustomer();
    };
    var handleClose = function() {
        setAnchorEl(null);
    };
    var handleSwitchTab = function(tab) {
        var ref;
        setNotiTab(tab);
        fetchDataByTab(tab);
        if ((NewNotification_interface/* ENUM_NOTIFICATION_TAB */.V === null || NewNotification_interface/* ENUM_NOTIFICATION_TAB */.V === void 0 ? void 0 : NewNotification_interface/* ENUM_NOTIFICATION_TAB */.V[tab]) && (numberNotifyWithTab === null || numberNotifyWithTab === void 0 ? void 0 : (ref = numberNotifyWithTab[tab.toLowerCase()]) === null || ref === void 0 ? void 0 : ref.unread) > 0) {
            markAll(tab, false);
        }
    };
    var handleCustomCustomerLevel = function(level) {
        if (!level) return "";
        var upperCaseLevel = level.replace(/\w\S*/g, function(txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
        return "Kh\xe1ch H\xe0ng Hạng ".concat(upperCaseLevel);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        className: (Header_styles_module_default()).headerIconLogged,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationV2, {
                open: open,
                anchorEl: anchorEl,
                handleClick: handleClick,
                handleClose: handleClose,
                notiTab: notiTab,
                handleSwitchTab: handleSwitchTab
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                className: (Header_styles_module_default()).profile,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "profile__guide",
                    className: (Header_styles_module_default()).borderRadius,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Header_styles_module_default()).wrapperProfile,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkComp/* default */.Z, {
                                href: Paths/* MY_ACCOUNT */.RX,
                                padding: "0px",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                                    title: handleCustomCustomerLevel(Enums/* LEVEL_CUSTOMER */.LB[(ref = props.user) === null || ref === void 0 ? void 0 : ref.level]) || "",
                                    arrow: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        className: (Header_styles_module_default()).avatar,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* default */.ZP, {
                                            src: props.user.avatarURL || Images/* AVATAR */.pA0,
                                            width: "36px",
                                            height: "36px",
                                            quality: 100,
                                            layout: "fixed"
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                className: (Header_styles_module_default()).profile_name,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        children: ((ref1 = props.user) === null || ref1 === void 0 ? void 0 : ref1.name) || ""
                                    }),
                                    hasActiveMembership ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                                        title: "Đang c\xf3 g\xf3i ".concat(membershipName),
                                        arrow: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (Header_styles_module_default()).premiumStar,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_PremiumStarIcon, {
                                                size: 20
                                            })
                                        })
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleProfile, {
                                user: props.user,
                                point: props.point,
                                level: props.level,
                                listMenu: props === null || props === void 0 ? void 0 : props.listMenu
                            })
                        ]
                    })
                })
            })
        ]
    });
});
var HeaderTop = /*#__PURE__*/ (0,react.memo)(function HeaderTop(param) {
    var isAuthenticated = param.isAuthenticated;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Header_styles_module_default()).headerTop,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Header_styles_module_default()) === null || (Header_styles_module_default()) === void 0 ? void 0 : (Header_styles_module_default()).wrapperLink,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkComp/* default */.Z, {
                        name: "Đăng k\xfd b\xe1n h\xe0ng",
                        href: sysconfig/* DOMAIN_SELLER_CENTER */.Ri,
                        target: true,
                        onClick: function() {
                            return gtag/* default.viewSeller */.ZP.viewSeller();
                        },
                        removeStyles: true,
                        className: (0,clsx/* default */.Z)((Header_styles_module_default()).linkMenu),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                            src: Images/* WHITE_HOUSE */.Bm2,
                            width: "24px",
                            height: "24px",
                            quality: 100,
                            layout: "fixed"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkComp/* default */.Z, {
                        name: "Hướng dẫn đặt h\xe0ng",
                        href: sysconfig/* DOMAIN_FEEDBACK */.PQ,
                        removeStyles: true,
                        target: true,
                        onClick: function() {
                            return gtag/* default.viewBlog */.ZP.viewBlog();
                        },
                        className: (Header_styles_module_default()).linkMenu,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                            src: Images/* HELP */.Msl,
                            width: "24px",
                            height: "24px",
                            quality: 100,
                            layout: "fixed"
                        })
                    }),
                    isAuthenticated && /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkComp/* default */.Z, {
                        name: "Danh mục thuốc đang b\xe1n",
                        href: Paths/* PRODUCT_CATALOG */.lo,
                        removeStyles: true,
                        className: (Header_styles_module_default()).linkMenu,
                        iconRight: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (Header_styles_module_default()).catalogNewBadge,
                            children: "Mới"
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CatalogMenuIcon, {
                            size: 20
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Header_styles_module_default()).wrapperLink,
                children: [
                    isAuthenticated && /*#__PURE__*/ (0,jsx_runtime.jsx)(NotiComp, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkComp/* default */.Z, {
                        name: "Tin tức",
                        href: Paths/* PATH_NEWS */.zw,
                        target: true,
                        removeStyles: true,
                        onClick: function() {
                            return gtag/* default.viewBlog */.ZP.viewBlog();
                        },
                        className: (Header_styles_module_default()).linkMenu,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                            src: Images/* PAPER */.eAt,
                            width: "24px",
                            height: "24px",
                            quality: 100,
                            layout: "fixed"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkComp/* default */.Z, {
                        name: "Tuyển dụng",
                        href: Paths/* PATH_CAREER */.Ph,
                        target: true,
                        removeStyles: true,
                        onClick: function() {
                            return gtag/* default.viewCareer */.ZP.viewCareer();
                        },
                        className: (Header_styles_module_default()).linkMenu,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                            src: Images/* HIRING */.y1H,
                            width: "24px",
                            height: "24px",
                            quality: 100,
                            layout: "fixed"
                        })
                    })
                ]
            })
        ]
    });
});
function TopSearchKeywordList() {
    var ref = useHashtagTopSearch(), hashtagTopSearch = ref.hashtagTopSearch, isLoading = ref.isLoading;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Header_styles_module_default()).listSearch,
        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: Array.from({
                length: 2
            }).map(function(_, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    className: (Header_styles_module_default()).mostSearchItem,
                    variant: "rectangular",
                    animation: "wave",
                    width: 150
                }, index);
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: hashtagTopSearch.map(function(item) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(TopSearchKeyword, (0,_object_spread/* default */.Z)({}, item), item === null || item === void 0 ? void 0 : item.code);
            })
        })
    });
}
function TopSearchKeyword(_param) {
    var item = (0,_extends/* default */.Z)({}, _param);
    var elementRef = (0,useIsInViewportOnce/* useIsInViewportOnce */.z)({
        callback: function() {
            var _trackDisplayTopSearch = (0,_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    gtag/* default.displayTopSearchOutside */.ZP.displayTopSearchOutside(item);
                    return [
                        2
                    ];
                });
            });
            function trackDisplayTopSearch() {
                return _trackDisplayTopSearch.apply(this, arguments);
            }
            return trackDisplayTopSearch;
        }()
    }).elementRef;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkComp/* default */.Z, {
        "data-test": "search-outside",
        href: item.url,
        onClick: function() {
            return gtag/* default.clickTopSearchOutside */.ZP.clickTopSearchOutside(item);
        },
        className: (Header_styles_module_default()).mostSearchItem,
        removeStyles: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            ref: elementRef,
            children: item === null || item === void 0 ? void 0 : item.hashtag
        })
    });
}
var Header = /*#__PURE__*/ (0,react.memo)(function Header(param) {
    var _balance = param.balance, balance = _balance === void 0 ? 0 : _balance, _pageName = param.pageName, pageName = _pageName === void 0 ? "" : _pageName, _point = param.point, point = _point === void 0 ? 0 : _point, _compact = param.compact, compact = _compact === void 0 ? false : _compact, countdownBarType = param.countdownBarType;
    var ref;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,react.useState)(DEFAULT_MENU_PROFILE), listMenu = ref1[0], setListMenu = ref1[1];
    var currentUrl = router.asPath;
    var ref2 = (0,Auth/* useAuth */.aC)(), user = ref2.user, isAuthenticated = ref2.isAuthenticated, toggleLogin = ref2.toggleLogin, toggleSignUp = ref2.toggleSignUp;
    var ref3 = (0,react.useState)(null), chainSession = ref3[0], setChainSession = ref3[1];
    (0,react.useEffect)(function() {
        setChainSession((0,ChainSessionUtils/* getValidatedChainSessionState */.c5)(user));
    }, [
        user
    ]);
    var isImpersonating = Boolean(user && (chainSession === null || chainSession === void 0 ? void 0 : chainSession.isImpersonating));
    var isChildOrImpersonating = Boolean((user === null || user === void 0 ? void 0 : user.isChain) && !(user === null || user === void 0 ? void 0 : user.isParent) || isImpersonating);
    var ref4 = useConcurrentPresencePolling({
        isChildOrImpersonating: isChildOrImpersonating
    }), isConcurrent = ref4.isConcurrent, presence = ref4.presence, isMinimized = ref4.isMinimized, acknowledge = ref4.acknowledge, reopen = ref4.reopen;
    (0,react.useEffect)(function() {
        (0,_async_to_generator/* default */.Z)(function() {
            var getListMenuLocal, fetchData, currentTime, ref, ref1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                getListMenuLocal = JSON.parse(localStorage.getItem(KEY_DROPDOWN_LOCAL));
                fetchData = function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function() {
                        var menuListRes, _tmp, expiry, _tmp1;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _tmp = {};
                                    return [
                                        4,
                                        (0,WebServiceClient/* getMenuList */.Af)(_tmp)
                                    ];
                                case 1:
                                    menuListRes = _state.sent();
                                    _tmp1 = {};
                                    if ((0,Clients/* isValid */.JY)(menuListRes)) {
                                        setListMenu(function(prevState) {
                                            var ref, ref1, ref2, ref3;
                                            return (menuListRes === null || menuListRes === void 0 ? void 0 : (ref = menuListRes.data) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.items) === null || ref2 === void 0 ? void 0 : ref2.length) >= 6 ? menuListRes === null || menuListRes === void 0 ? void 0 : (ref3 = menuListRes.data) === null || ref3 === void 0 ? void 0 : ref3[0] : prevState;
                                        });
                                        expiry = new Date().getTime() + Header_MINUTE_CACHE_MENU * 60 * 1000;
                                        localStorage.setItem(KEY_DROPDOWN_LOCAL, JSON.stringify((_tmp1.data = menuListRes === null || menuListRes === void 0 ? void 0 : menuListRes.data[0], _tmp1.dayExpired = expiry, _tmp1)));
                                    }
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function fetchData() {
                        return _ref.apply(this, arguments);
                    };
                }();
                if (getListMenuLocal) {
                    currentTime = new Date().getTime();
                    if (getListMenuLocal.dayExpired < currentTime) {
                        fetchData();
                    } else {
                        ;
                        setListMenu((getListMenuLocal === null || getListMenuLocal === void 0 ? void 0 : (ref = getListMenuLocal.data) === null || ref === void 0 ? void 0 : (ref1 = ref.items) === null || ref1 === void 0 ? void 0 : ref1.length) >= 6 ? getListMenuLocal === null || getListMenuLocal === void 0 ? void 0 : getListMenuLocal.data : DEFAULT_MENU_PROFILE);
                    }
                } else {
                    fetchData();
                }
                return [
                    2
                ];
            });
        })();
    }, []);
    var renderUnAuth = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            className: (Header_styles_module_default()).headerCenter_Status,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
                    "data-test": "btn-signup",
                    className: (Header_styles_module_default()).register,
                    onClick: toggleSignUp,
                    disableRipple: true,
                    children: "ĐĂNG K\xdd"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
                    "data-test": "btn-signin",
                    className: (Header_styles_module_default()).login,
                    onClick: toggleLogin,
                    disableRipple: true,
                    children: "ĐĂNG NHẬP"
                })
            ]
        });
    };
    var renderAuth = function() {
        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                !compact && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    id: "search__homepage",
                    className: (Header_styles_module_default()).searchBar,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_SearchInput, {
                            className: (Header_styles_module_default()).SearchInput
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TopSearchKeywordList, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadericonRight, {
                    balance: balance,
                    point: user === null || user === void 0 ? void 0 : user.point,
                    level: user === null || user === void 0 ? void 0 : user.level,
                    user: user,
                    listMenu: listMenu
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_ImpersonationBanner, {
                user: user
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_ConcurrentPresenceOverlay, {
                isConcurrent: isConcurrent,
                presence: presence,
                isMinimized: isMinimized,
                onAcknowledge: acknowledge,
                onReopen: reopen,
                isImpersonating: isImpersonating
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Header_styles_module_default()) === null || (Header_styles_module_default()) === void 0 ? void 0 : (Header_styles_module_default()).containerHeader,
                children: [
                    !compact && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Header_styles_module_default()) === null || (Header_styles_module_default()) === void 0 ? void 0 : (Header_styles_module_default()).topMenuContainer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderTop, {
                            isAuthenticated: isAuthenticated,
                            isShowAnnouncement: (user === null || user === void 0 ? void 0 : user.isCashback) && [
                                Paths/* HOME */.Sd
                            ].includes(router === null || router === void 0 ? void 0 : router.pathname),
                            currentUrl: currentUrl
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Header_styles_module_default()).headerCenter,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CountDownBar/* default */.Z, {
                            type: countdownBarType
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx/* default */.Z)((Header_styles_module_default()).stickyHeaderSearch, isImpersonating && (Header_styles_module_default()).stickyHeaderSearchImpersonating),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    className: (Header_styles_module_default()).headerCenter_wrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {}),
                        (router === null || router === void 0 ? void 0 : (ref = router.pathname) === null || ref === void 0 ? void 0 : ref.includes("/loading")) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : isAuthenticated ? renderAuth() : renderUnAuth()
                    ]
                })
            }),
            isAuthenticated && !compact && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx/* default */.Z)((Header_styles_module_default()).stickyHeaderMenu, (Header_styles_module_default()) === null || (Header_styles_module_default()) === void 0 ? void 0 : (Header_styles_module_default()).stickyTopSearch, isImpersonating && (Header_styles_module_default()).stickyHeaderMenuImpersonating),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_Navbar, {
                    pageName: pageName,
                    point: point,
                    balance: balance
                })
            })
        ]
    });
});
/* harmony default export */ var layout_Header = (Header);


/***/ }),

/***/ 7813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ NotificationTagLabel; },
/* harmony export */   "u": function() { return /* binding */ NotificationTagColor; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var _interface__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1307);


var _obj;
var NotificationTagLabel = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _interface__WEBPACK_IMPORTED_MODULE_0__/* .ENUM_NOTIFICATION_TAG.ACCOUNT */ .T.ACCOUNT, "T\xe0i khoản"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _interface__WEBPACK_IMPORTED_MODULE_0__/* .ENUM_NOTIFICATION_TAG.IMPORTANT */ .T.IMPORTANT, "Quan trọng"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _interface__WEBPACK_IMPORTED_MODULE_0__/* .ENUM_NOTIFICATION_TAG.ORDER */ .T.ORDER, "Đơn h\xe0ng"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _interface__WEBPACK_IMPORTED_MODULE_0__/* .ENUM_NOTIFICATION_TAG.PRICE */ .T.PRICE, "Đơn gi\xe1"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _interface__WEBPACK_IMPORTED_MODULE_0__/* .ENUM_NOTIFICATION_TAG.PRODUCT */ .T.PRODUCT, "Sản phẩm"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _interface__WEBPACK_IMPORTED_MODULE_0__/* .ENUM_NOTIFICATION_TAG.PROMOTION */ .T.PROMOTION, "Khuyến m\xe3i"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _interface__WEBPACK_IMPORTED_MODULE_0__/* .ENUM_NOTIFICATION_TAG.TICKET */ .T.TICKET, "Phiếu hỗ trợ"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _interface__WEBPACK_IMPORTED_MODULE_0__/* .ENUM_NOTIFICATION_TAG.FAVORITE */ .T.FAVORITE, "Y\xeau th\xedch"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _interface__WEBPACK_IMPORTED_MODULE_0__/* .ENUM_NOTIFICATION_TAG.LOYALTY_POINT */ .T.LOYALTY_POINT, "Điểm t\xedch luỹ"), _obj);
var _obj1;
var NotificationTagColor = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, _interface__WEBPACK_IMPORTED_MODULE_0__/* .ENUM_NOTIFICATION_TAG.ACCOUNT */ .T.ACCOUNT, {
    text: "#D55D2A",
    background: "#FFF4EF",
    border: "#D55D2A"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, _interface__WEBPACK_IMPORTED_MODULE_0__/* .ENUM_NOTIFICATION_TAG.IMPORTANT */ .T.IMPORTANT, {
    text: "#D4323B",
    background: "#FFF4EF",
    border: "#D4323B"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, _interface__WEBPACK_IMPORTED_MODULE_0__/* .ENUM_NOTIFICATION_TAG.ORDER */ .T.ORDER, {
    text: "var(--primary-color)",
    background: "#EDFDF6",
    border: "var(--primary-color)"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, _interface__WEBPACK_IMPORTED_MODULE_0__/* .ENUM_NOTIFICATION_TAG.PRICE */ .T.PRICE, {
    text: "#0E1983",
    background: "#F9F9FF",
    border: "#0E1983"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, _interface__WEBPACK_IMPORTED_MODULE_0__/* .ENUM_NOTIFICATION_TAG.PRODUCT */ .T.PRODUCT, {
    text: "#6C3B0D",
    background: "rgba(108, 59, 13, 0.05)",
    border: "#6C3B0D"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, _interface__WEBPACK_IMPORTED_MODULE_0__/* .ENUM_NOTIFICATION_TAG.PROMOTION */ .T.PROMOTION, {
    text: "#F9B710",
    background: "#fffbf3",
    border: "#F9B710"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, _interface__WEBPACK_IMPORTED_MODULE_0__/* .ENUM_NOTIFICATION_TAG.TICKET */ .T.TICKET, {
    text: "#783DC3",
    background: "#F9EFFF",
    border: "#783DC3"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, _interface__WEBPACK_IMPORTED_MODULE_0__/* .ENUM_NOTIFICATION_TAG.FAVORITE */ .T.FAVORITE, {
    text: "rgb(147, 60, 136)",
    background: "rgb(207 162 199 / 5%)",
    border: "rgb(147, 60, 136)"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, _interface__WEBPACK_IMPORTED_MODULE_0__/* .ENUM_NOTIFICATION_TAG.LOYALTY_POINT */ .T.LOYALTY_POINT, {
    text: "var(--primary-color-price)",
    background: "#EDFDF6",
    border: "var(--primary-color)"
}), _obj1);


/***/ }),

/***/ 57894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var utils_SEOUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40398);



var HeadPage = function(param) {
    var title = param.title, _useSubTitle = param.useSubTitle, useSubTitle = _useSubTitle === void 0 ? false : _useSubTitle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                charSet: "utf-8"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1.0, minimum-scale=1.0"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                httpEquiv: "Cache-Control",
                content: "no-cache"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                httpEquiv: "Expires",
                content: "-1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: "thuốc sỉ"
            }),
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: (0,utils_SEOUtils__WEBPACK_IMPORTED_MODULE_2__/* .getTitle */ .Y)(title, useSubTitle)
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeadPage);


/***/ }),

/***/ 92803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ useIsInViewportOnce; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10253);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


/**
 * @typedef {Object} UseIsInViewportOnceReturnType
 * @property {import('react').RefObject<HTMLElement>} elementRef - the ref to hook into the element
 * @property {boolean} isInViewport
 */ /**
 * Track an elementRef is in view once, then trigger callback
 * @param {object} props
 * @param {boolean} props.shouldTrack
 * @param {CallableFunction} props.callback
 * @param {number} props.timeout
 * @param {number} props.threshold
 * @returns {UseIsInViewportOnceReturnType}
 */ function useIsInViewportOnce(param) {
    var _shouldTrack = param.shouldTrack, shouldTrack = _shouldTrack === void 0 ? true : _shouldTrack, callback = param.callback, _timeout = param.timeout, timeout = _timeout === void 0 ? 0 : _timeout, _threshold = param.threshold, threshold = _threshold === void 0 ? 0 : _threshold;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isInViewport = ref[0], setIsInViewport = ref[1];
    var elementRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    var timerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!shouldTrack) return;
        if (!elementRef.current) return;
        if (isInViewport) return;
        var obs = new IntersectionObserver(function(param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 1), entry = _param[0];
            // If the item is in viewport, and user not scroll for at least xx miliseconds -> trigger callback
            clearTimeout(timerRef.current);
            if (entry.isIntersecting) {
                timerRef.current = setTimeout(callback, timeout);
                setIsInViewport(true);
                obs.unobserve(elementRef.current);
            }
        }, {
            threshold: threshold
        });
        if (elementRef.current) obs.observe(elementRef.current);
        return function() {
            if (elementRef.current) obs.unobserve(elementRef.current);
        };
    }, [
        shouldTrack,
        elementRef.current
    ]);
    return {
        elementRef: elementRef,
        isInViewport: isInViewport
    };
}


/***/ }),

/***/ 94581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hooks_usePremium; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./src/constants/Enums/premium.ts
// BUYMED PREMIUM - Phase 1. Màu/gradient khai báo ở :root trong styles/globals.css.
// Đọc từ field `membershipType` của customer (API customer/me).

var ENUM_MEMBERSHIP_TYPE;
(function(ENUM_MEMBERSHIP_TYPE) {
    ENUM_MEMBERSHIP_TYPE["NORMAL"] = "NORMAL";
    ENUM_MEMBERSHIP_TYPE["PREMIUM"] = "PREMIUM";
})(ENUM_MEMBERSHIP_TYPE || (ENUM_MEMBERSHIP_TYPE = {}));
// Gói lạ (BE thêm gói mà FE chưa hỗ trợ) quy về NORMAL để không hiện sai quyền lợi.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var getMembershipType = function(user) {
    var membershipType = user === null || user === void 0 ? void 0 : user.membershipType;
    return Object.values(ENUM_MEMBERSHIP_TYPE).includes(membershipType) ? membershipType : ENUM_MEMBERSHIP_TYPE.NORMAL;
};
var PREMIUM_PROGRAM_NAME = "Buymed Premium";
var _obj;
// Tên gói do BE trả về trong `customer.membership`. Map này chỉ là fallback cho
// môi trường BE chưa deploy, gói mới không cần thêm vào đây.
var MEMBERSHIP_FALLBACK = (_obj = {}, (0,_define_property/* default */.Z)(_obj, ENUM_MEMBERSHIP_TYPE.NORMAL, {
    name: "",
    shortName: ""
}), (0,_define_property/* default */.Z)(_obj, ENUM_MEMBERSHIP_TYPE.PREMIUM, {
    name: PREMIUM_PROGRAM_NAME,
    shortName: "Premium"
}), _obj);

// EXTERNAL MODULE: ./src/context/Auth/index.js + 4 modules
var Auth = __webpack_require__(95581);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/sysconfig/index.js
var sysconfig = __webpack_require__(66225);
// EXTERNAL MODULE: ./src/utils/FormatDate.js
var FormatDate = __webpack_require__(45901);
;// CONCATENATED MODULE: ./src/hooks/usePremium.ts





var MS_PER_DAY = 24 * 60 * 60 * 1000;
var PREVIEW_EXPIRED_DAYS = 30;
/**
 * Luồng UI trên cart theo gói của khách:
 * - PREMIUM: ẩn banner + block "Giá với Premium" (quyền lợi 2% hiện dưới dạng
 *   voucher PREMIUM trong Tổng giảm giá, do BE trả về).
 * - NORMAL: hiện banner + block "Giá với Premium" kèm CTA đăng ký.
 *
 * Đừng dùng field `customerType` - UserService.getAccount đang ghi đè field này
 * bằng customer type của Insider.
 */ var usePremium = function() {
    var ref;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var user = (0,Auth/* useAuth */.aC)().user;
    var router = (0,next_router.useRouter)();
    // Xem trước 2 luồng UI ở non-prd: /cart?premium=1 hoặc /cart?premium=0
    var previewParam = router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.premium;
    var isPreviewMode = !sysconfig/* isPrd */.gR && typeof previewParam === "string";
    // BE set `membership` khi gói còn hiệu lực. getMembershipType là fallback cho
    // môi trường BE chưa deploy.
    var membership = user === null || user === void 0 ? void 0 : user.membership;
    var membershipType = isPreviewMode ? previewParam === "1" && ENUM_MEMBERSHIP_TYPE.PREMIUM || ENUM_MEMBERSHIP_TYPE.NORMAL : (membership === null || membership === void 0 ? void 0 : membership.type) || getMembershipType(user);
    var hasActiveMembership = membershipType !== ENUM_MEMBERSHIP_TYPE.NORMAL;
    var fallback = MEMBERSHIP_FALLBACK[membershipType] || MEMBERSHIP_FALLBACK[ENUM_MEMBERSHIP_TYPE.NORMAL];
    var openLandingPage = function() {
        if (!sysconfig/* PREMIUM_LANDING_PAGE_URL */.vi) return;
        window.open(sysconfig/* PREMIUM_LANDING_PAGE_URL */.vi, "_blank", "noopener,noreferrer");
    };
    // Preview ở non-prd chưa có data thật thì tự sinh ngày hết hạn để xem được UI
    var getExpiredAt = function() {
        if (!hasActiveMembership) return null;
        var expiredAt = (membership === null || membership === void 0 ? void 0 : membership.expiredAt) || (user === null || user === void 0 ? void 0 : user.membershipExpiredAt);
        if (expiredAt) return new Date(expiredAt);
        return isPreviewMode ? new Date(Date.now() + PREVIEW_EXPIRED_DAYS * MS_PER_DAY) : null;
    };
    var expiredAt = getExpiredAt();
    var remainingDays = expiredAt ? Math.max(0, Math.ceil((expiredAt.getTime() - Date.now()) / MS_PER_DAY)) : 0;
    return {
        membershipType: membershipType,
        membershipName: (membership === null || membership === void 0 ? void 0 : membership.name) || fallback.name,
        membershipShortName: (membership === null || membership === void 0 ? void 0 : membership.shortName) || fallback.shortName,
        hasActiveMembership: hasActiveMembership,
        expiredAtText: expiredAt ? (0,FormatDate/* formatDate3 */.T6)(expiredAt.toISOString(), true) : "",
        remainingDays: remainingDays,
        landingPageUrl: sysconfig/* PREMIUM_LANDING_PAGE_URL */.vi,
        openLandingPage: openLandingPage
    };
};
/* harmony default export */ var hooks_usePremium = (usePremium);


/***/ }),

/***/ 45901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qe": function() { return /* binding */ formatDate2; },
/* harmony export */   "T6": function() { return /* binding */ formatDate3; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; }
/* harmony export */ });
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42298);

function formatDate() {
    var val = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    if (!val) {
        return "";
    }
    var date = new Date(val);
    var dateStr = "".concat("00".concat(date.getDate()).slice(-2), "/").concat("00".concat(date.getMonth() + 1).slice(-2), "/").concat(date.getFullYear(), " ").concat("00".concat(date.getHours()).slice(-2), ":").concat("00".concat(date.getMinutes()).slice(-2), ":").concat("00".concat(date.getSeconds()).slice(-2));
    return dateStr || "";
}
function formatDate2() {
    var val = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    if (!val) {
        return "";
    }
    var date = new Date(val);
    var dateStr = "".concat("00".concat(date.getHours()).slice(-2), ":").concat("00".concat(date.getMinutes()).slice(-2), ":").concat("00".concat(date.getSeconds()).slice(-2), " Ng\xe0y ").concat("00".concat(date.getDate()).slice(-2), "/").concat("00".concat(date.getMonth() + 1).slice(-2), "/").concat(date.getFullYear(), " ");
    return dateStr || "";
}
function formatDate3() {
    var val = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", isDay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (!val) {
        return "";
    }
    var date = (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(new Date(val), isDay ? "dd/MM/yyyy" : "dd/MM/yyyy (HH:mm:ss)");
    return date || "";
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    formatDate: formatDate,
    formatDate2: formatDate2
});


/***/ }),

/***/ 40398:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ getTitle; }
/* harmony export */ });
/* harmony import */ var constants_data__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66520);

var getTitle = function() {
    var title = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : constants_data__WEBPACK_IMPORTED_MODULE_0__/* .DEFAULT_THUOCSI_TITLE */ .Vw, useSubTitle = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    return (title || constants_data__WEBPACK_IMPORTED_MODULE_0__/* .DEFAULT_THUOCSI_TITLE */ .Vw) + (useSubTitle ? " - ".concat(constants_data__WEBPACK_IMPORTED_MODULE_0__/* .DEFAULT_THUOCSI_SUBTITLE */ .s7) : "");
};


/***/ }),

/***/ 97121:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ checkIOS; }
/* harmony export */ });
/* harmony import */ var constants_Device__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32826);

var TABLET = /ipad|android|android 3.0|xoom|sch-i800|playbook|tablet|kindle/i;
var isTablet = function() {
    var ref;
    return TABLET.test(navigator === null || navigator === void 0 ? void 0 : (ref = navigator.userAgent) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || false;
};
var isMobileFromCtx = function(ctx) {
    var devices = ctx.req.headers["user-agent"];
    return Boolean(devices.match(constants_Device__WEBPACK_IMPORTED_MODULE_0__/* .MOBILE */ .Jq));
};
function checkIOS() {
    return [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod"
    ].includes(navigator.platform) || // iPad on iOS 13 detection
    (navigator.userAgent.includes("Mac") && "ontouchend" in document);
}
/* harmony default export */ __webpack_exports__["Z"] = ({
    isTablet: isTablet,
    TABLET: TABLET,
    isMobileFromCtx: isMobileFromCtx
});


/***/ }),

/***/ 19060:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"highlight":"styles_highlight__1slLZ"};

/***/ }),

/***/ 12045:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"MenuOverlay":"styles_MenuOverlay__TshbT","level-1":"styles_level-1__s6Lb1","level-2":"styles_level-2__KQ_gr","fadeIn":"styles_fadeIn__9jaw5","fadeOut":"styles_fadeOut__5517h"};

/***/ }),

/***/ 95649:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bannerContainer":"ImpersonationBanner_bannerContainer__lm6cu","contentWrapper":"ImpersonationBanner_contentWrapper__pEi4a","leftGroup":"ImpersonationBanner_leftGroup__reTJu","roleTag":"ImpersonationBanner_roleTag__xHw8_","roleIcon":"ImpersonationBanner_roleIcon__lzdSe","divider":"ImpersonationBanner_divider__JEfam","bannerText":"ImpersonationBanner_bannerText__TCPTL","bannerStoreName":"ImpersonationBanner_bannerStoreName__6MfTq","bulletDot":"ImpersonationBanner_bulletDot__RIGs2","metaItem":"ImpersonationBanner_metaItem__YbFp7","metaIcon":"ImpersonationBanner_metaIcon__vNwGm","metaText":"ImpersonationBanner_metaText__nJPXp","metaTextAddress":"ImpersonationBanner_metaTextAddress__DmTn_","rightGroup":"ImpersonationBanner_rightGroup__V4ZoH","dropdownContainer":"ImpersonationBanner_dropdownContainer__tVSJp","dropdownTriggerBtn":"ImpersonationBanner_dropdownTriggerBtn__QHalN","dropdownTriggerActive":"ImpersonationBanner_dropdownTriggerActive__OsWFF","chevronIcon":"ImpersonationBanner_chevronIcon__XetLn","chevronOpen":"ImpersonationBanner_chevronOpen__g1SrO","returnBtn":"ImpersonationBanner_returnBtn__Vu8_B","bannerDropdownPopover":"ImpersonationBanner_bannerDropdownPopover__jtIn_","popoverFadeIn":"ImpersonationBanner_popoverFadeIn__VVgQa","popoverTitle":"ImpersonationBanner_popoverTitle__pc1DT","popoverCountBadge":"ImpersonationBanner_popoverCountBadge___R1mO","searchBox":"ImpersonationBanner_searchBox__GpD8C","searchInput":"ImpersonationBanner_searchInput__9LdSv","searchIcon":"ImpersonationBanner_searchIcon__WCLJn","parentCard":"ImpersonationBanner_parentCard__KaxT_","storeMeta":"ImpersonationBanner_storeMeta__W5Ct7","avatarWrapper":"ImpersonationBanner_avatarWrapper__EUFNI","avatarImg":"ImpersonationBanner_avatarImg__v4TQJ","avatarFallback":"ImpersonationBanner_avatarFallback__b2dns","storeText":"ImpersonationBanner_storeText__YVNld","storeName":"ImpersonationBanner_storeName__HNWGY","parentBadge":"ImpersonationBanner_parentBadge__7qbiD","sectionDivider":"ImpersonationBanner_sectionDivider__xdaEO","sectionDividerText":"ImpersonationBanner_sectionDividerText__LX6Lt","dividerLine":"ImpersonationBanner_dividerLine__QOccY","childList":"ImpersonationBanner_childList__UXOyS","childItem":"ImpersonationBanner_childItem__jjHaV","childItemActive":"ImpersonationBanner_childItemActive__nzQ80","switchIconBtn":"ImpersonationBanner_switchIconBtn__XfCE9","activeCheckIcon":"ImpersonationBanner_activeCheckIcon__t_qFM","switchingSpinner":"ImpersonationBanner_switchingSpinner__6XC5Z","tooltipContainer":"ImpersonationBanner_tooltipContainer__dJ8wm","tooltipName":"ImpersonationBanner_tooltipName__SofN1","tooltipMeta":"ImpersonationBanner_tooltipMeta__bLaeF","childItemDisabled":"ImpersonationBanner_childItemDisabled__W39wT","disabledLockBtn":"ImpersonationBanner_disabledLockBtn__7ZdVy","inactiveStoreBadge":"ImpersonationBanner_inactiveStoreBadge__Y_3OH","tooltipInactiveWarning":"ImpersonationBanner_tooltipInactiveWarning__TjmxX","loadingNotice":"ImpersonationBanner_loadingNotice__pIcZQ","emptyNotice":"ImpersonationBanner_emptyNotice__dYga6","parentCardDisabled":"ImpersonationBanner_parentCardDisabled__zYiV5","itemDisabledDuringSwitch":"ImpersonationBanner_itemDisabledDuringSwitch__6EmoT"};

/***/ }),

/***/ 10916:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"notificationChild_container":"styles_notificationChild_container__vbuxp","notification_indicator":"styles_notification_indicator__8A1Bi","notification_label":"styles_notification_label__M5clx","notification_title":"styles_notification_title__uRUsH","isRead":"styles_isRead___fiA9","notificationsItem":"styles_notificationsItem__Y42KH","read":"styles_read__WIgTK","unRead":"styles_unRead__iPJbc","createdAt":"styles_createdAt__cgZM_","dateLabel":"styles_dateLabel__tqB9r"};

/***/ }),

/***/ 36142:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"labelTab":"styles_labelTab__8z_uZ","notification_container":"styles_notification_container__yJ6wA","numNoti":"styles_numNoti__eWM__","notification_tabContainer":"styles_notification_tabContainer__lUnx6","alreadyRead":"styles_alreadyRead__WvfXv","viewAll":"styles_viewAll__5vUfK","viewAllTitle":"styles_viewAllTitle__izmDc","dateLabel":"styles_dateLabel__UsNX9","emptyNotification":"styles_emptyNotification__3zPSZ","tabPanel_container":"styles_tabPanel_container__M53so","seeMore_container":"styles_seeMore_container__VUTpz","loadingContainer":"styles_loadingContainer__Hs_3C"};

/***/ }),

/***/ 11968:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"logo":"styles_logo__R0Twa","iconTopSeller":"styles_iconTopSeller__lDb35","headerCenter":"styles_headerCenter__iDJLS","headerStatus":"styles_headerStatus__0lZR5","cart":"styles_cart__kVp3U","cartLink":"styles_cartLink__6kL_q","badge":"styles_badge__9thnG","headerCenter_wrapper":"styles_headerCenter_wrapper__RheJr","ins-preview-wrapper":"styles_ins-preview-wrapper__9Zy7v","notifyIcon":"styles_notifyIcon__Nnq77","icon":"styles_icon__KSSqJ","cartContainer":"styles_cartContainer__0sVOi","badgeContainer":"styles_badgeContainer__krkFJ"};

/***/ }),

/***/ 4530:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"logo":"styles_logo__185XE","topMenuContainer":"styles_topMenuContainer__0sPLC","headerTop":"styles_headerTop__cWk5j","iconTopSeller":"styles_iconTopSeller__r0MKu","wrapperLink":"styles_wrapperLink__VBuUw","linkMenu":"styles_linkMenu__8r7wM","catalogNewBadge":"styles_catalogNewBadge__0jQgX","catalogNewBlink":"styles_catalogNewBlink__l3ppp","headerCenter":"styles_headerCenter__rkkQJ","headerCenter_wrapper":"styles_headerCenter_wrapper__ibONV","headerCenter_Status":"styles_headerCenter_Status__Ju01k","headerCenter_Icon":"styles_headerCenter_Icon__M3Ak0","headerStatus":"styles_headerStatus__hKAPz","SearchInput":"styles_SearchInput__G_RwG","headerIconLogged":"styles_headerIconLogged__QrNnI","notice":"styles_notice___r5m2","cart":"styles_cart__vnEHX","cartLink":"styles_cartLink__4EJyO","info":"styles_info__geNyl","profile":"styles_profile__MKk3m","avatar":"styles_avatar__QQJbp","avatarIcon":"styles_avatarIcon__hgz3G","profile_name":"styles_profile_name__11tu9","badge":"styles_badge__Vr96h","ins-preview-wrapper":"styles_ins-preview-wrapper__PLoxD","notifyWrap":"styles_notifyWrap__V9uUr","notifyContentTop":"styles_notifyContentTop__pA30X","notifyTitle":"styles_notifyTitle__9D1vQ","notifyStatus":"styles_notifyStatus__V1d6E","markAll":"styles_markAll__tv_SV","notificationsItem":"styles_notificationsItem__vlFX7","read":"styles_read__cx75L","unRead":"styles_unRead__tl3Mh","notifyIcon":"styles_notifyIcon__2hcMD","icon":"styles_icon__F6AWN","notifyContent":"styles_notifyContent__tHz9w","notifyContentTitle":"styles_notifyContentTitle__xYFRv","notifyContentDescription":"styles_notifyContentDescription__zEp7_","createdAt":"styles_createdAt__KMJdQ","viewAll":"styles_viewAll__4tpSk","viewAllTitle":"styles_viewAllTitle__5GZca","buttonStyle":"styles_buttonStyle__VxlRq","countdownBarHalfContainer":"styles_countdownBarHalfContainer__6yuK9","countdownBarHalfWrapper":"styles_countdownBarHalfWrapper__QSwEJ","countdownBarHalf":"styles_countdownBarHalf__GyYDV","countdownBarHalfLimit":"styles_countdownBarHalfLimit__rRS1t","countdownBarFullWrapper":"styles_countdownBarFullWrapper__H__ia","headerTopLink":"styles_headerTopLink__8yOVV","headerTop_wrapper":"styles_headerTop_wrapper__A1PEv","appBanner":"styles_appBanner__bfZDx","frame":"styles_frame__HMZLJ","iconText":"styles_iconText__icDPP","button":"styles_button__4rx61","text":"styles_text__9f_xl","searchBar":"styles_searchBar__IODZZ","wrapperProfile":"styles_wrapperProfile__nQGUN","borderRadius":"styles_borderRadius__Q_n1v","stickyContainer":"styles_stickyContainer__BBidR","isGuide":"styles_isGuide__U2XAs","register":"styles_register__RiH2g","login":"styles_login__2NdrK","mostSearchWrap":"styles_mostSearchWrap__YOHPL","containerHeader":"styles_containerHeader__qmsyu","stickyHeaderSearch":"styles_stickyHeaderSearch__TZM5L","stickyHeaderMenu":"styles_stickyHeaderMenu__UKzGl","stickyTopSearch":"styles_stickyTopSearch__XCqci","stickyHeaderSearchImpersonating":"styles_stickyHeaderSearchImpersonating__UbnFo","stickyHeaderMenuImpersonating":"styles_stickyHeaderMenuImpersonating__fJmbB","listSearch":"styles_listSearch__CrHam","mostSearchItem":"styles_mostSearchItem__tpPe7","premiumStar":"styles_premiumStar__LWHCv"};

/***/ }),

/***/ 81728:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"nav":"styles_nav__gjQVz","wrap":"styles_wrap__MTNld","menu":"styles_menu__3jSIP","h40":"styles_h40__NJwsv","menuIcons":"styles_menuIcons__zD_BG","SearchInput":"styles_SearchInput__tDU7j","cartSticky":"styles_cartSticky__QS8Iw","profileSticky":"styles_profileSticky__dvI_w","hiddenWidth":"styles_hiddenWidth__qcqaa","customProfile":"styles_customProfile__V7kyy","wrapSticky":"styles_wrapSticky__ME2_Y","showInput":"styles_showInput__kHxZm","link":"styles_link__t2Gkc","cart":"styles_cart__y9UxC","cartLink":"styles_cartLink__9Ajbt","active":"styles_active__sCa_A","flexItem":"styles_flexItem__D9O0C","WrapmenuFocus":"styles_WrapmenuFocus__aMUXE","mostSearchWrap":"styles_mostSearchWrap__G_3FO","mostSearchTab":"styles_mostSearchTab__7bF0S","Loading":"styles_Loading__l6Kg4","labelShowAnimate":"styles_labelShowAnimate__kos_I","fadeHide":"styles_fadeHide__2tVG4","labelHideAnimate":"styles_labelHideAnimate__fO8BD","fadeShow":"styles_fadeShow__d59R4","wrapStickRight":"styles_wrapStickRight__l8xSS","badge":"styles_badge__dN4pj","SubMenu":"styles_SubMenu__ZOgqW","wrapperSubmenu":"styles_wrapperSubmenu__uAj53","MenuItems":"styles_MenuItems__ashml","MenuTrigger":"styles_MenuTrigger__RkWVE","isActiveMenu":"styles_isActiveMenu__boSSG","Menu":"styles_Menu__O8Bqq","MenuV2":"styles_MenuV2__Dqzo5","MenuV2Wrapper":"styles_MenuV2Wrapper__Q3ik_","SubMenuContainer":"styles_SubMenuContainer__rKcIG","LeftPanel":"styles_LeftPanel__j42hT","LeftPanelItem":"styles_LeftPanelItem__l4X_d","LeftPanelItemWithSubItems":"styles_LeftPanelItemWithSubItems__bXX8R","LeftPanelItemActive":"styles_LeftPanelItemActive__VTo7C","LeftPanelItemContent":"styles_LeftPanelItemContent__iJGN4","LeftPanelIcon":"styles_LeftPanelIcon__r4TtA","LeftPanelLabel":"styles_LeftPanelLabel__k8uR2","BadgeIcon":"styles_BadgeIcon__CBDxU","RightPanel":"styles_RightPanel__f_KDj","RightPaneCover":"styles_RightPaneCover__V18Ol","RightPanelItem":"styles_RightPanelItem__DPU5m","RightPanelItemContent":"styles_RightPanelItemContent___OTW6","RightPanelIcon":"styles_RightPanelIcon__s_LEU","RightPanelLabel":"styles_RightPanelLabel__NWtS9","Level3Panel":"styles_Level3Panel__XP7Sn","Level2MenuItem":"styles_Level2MenuItem__lDGj_","Level2MenuItemActive":"styles_Level2MenuItemActive__GaBSX","Level2MenuItemContent":"styles_Level2MenuItemContent__vmJVw","Level2MenuIcon":"styles_Level2MenuIcon__wzUGT","Level2MenuLabel":"styles_Level2MenuLabel__3hItj","Level3MenuItem":"styles_Level3MenuItem__fXjt_","Level3MenuItemContent":"styles_Level3MenuItemContent__YIr3x","Level3MenuIcon":"styles_Level3MenuIcon__TD1V_","Level3MenuLabel":"styles_Level3MenuLabel__Ix8AV","fadeLoad":"styles_fadeLoad__4Z0wp"};

/***/ }),

/***/ 85295:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"chainSwitcherContainer":"styles_chainSwitcherContainer__CSS36","headerToggle":"styles_headerToggle__WFG4E","chainTitleGroup":"styles_chainTitleGroup__5XpWT","chainIcon":"styles_chainIcon__K2UzG","chainName":"styles_chainName__Zfioj","badgeCount":"styles_badgeCount__DaSb8","chevronIcon":"styles_chevronIcon__Ut_Ad","chevronExpanded":"styles_chevronExpanded__CcnnJ","dropdownBody":"styles_dropdownBody__XOTA_","searchBox":"styles_searchBox__PdeV_","searchInput":"styles_searchInput__LVLln","searchIcon":"styles_searchIcon__giP5f","parentCard":"styles_parentCard__slp7_","parentCardActive":"styles_parentCardActive__E52dg","parentCardDisabled":"styles_parentCardDisabled__RfCnE","itemDisabledDuringSwitch":"styles_itemDisabledDuringSwitch__CMQj3","storeMeta":"styles_storeMeta__3PXSF","avatarWrapper":"styles_avatarWrapper__v9Ook","avatarImg":"styles_avatarImg__hhqJN","avatarFallback":"styles_avatarFallback__4_vwt","storeText":"styles_storeText__9Pt_W","storeName":"styles_storeName__d0DJS","parentBadge":"styles_parentBadge__tnvWN","sectionDivider":"styles_sectionDivider__9Rfb8","sectionDividerText":"styles_sectionDividerText__uqj3F","dividerLine":"styles_dividerLine__7hLev","childList":"styles_childList__1va4n","childItem":"styles_childItem__KPqGb","childItemActive":"styles_childItemActive__56ycu","emptyNotice":"styles_emptyNotice__LSSlO","loadingNotice":"styles_loadingNotice__ZRvIx","switchIconBtn":"styles_switchIconBtn___HFf2","activeCheckIcon":"styles_activeCheckIcon__CQmjJ","switchingSpinner":"styles_switchingSpinner__mmvNf","tooltipContainer":"styles_tooltipContainer__jz4Ne","tooltipName":"styles_tooltipName__vJa3C","tooltipMeta":"styles_tooltipMeta__ZdCc7","childItemDisabled":"styles_childItemDisabled__U0r11","disabledLockBtn":"styles_disabledLockBtn__mGfLx","inactiveStoreBadge":"styles_inactiveStoreBadge__EL6E2","tooltipInactiveWarning":"styles_tooltipInactiveWarning__0JMw7"};

/***/ }),

/***/ 52479:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"overlayBackdrop":"styles_overlayBackdrop__uK5QY","fadeIn":"styles_fadeIn__Tlfo0","modalCard":"styles_modalCard__Lh2Me","scaleUp":"styles_scaleUp__B405j","iconHeader":"styles_iconHeader__l40Im","iconGlow":"styles_iconGlow__x6emx","warningIcon":"styles_warningIcon__gaSe5","warningTitle":"styles_warningTitle__jkLQc","warningBody":"styles_warningBody__b1yny","acknowledgeBtn":"styles_acknowledgeBtn__vYK1C","minimizedPill":"styles_minimizedPill__hGZKM","pillPulse":"styles_pillPulse__mVH6Z"};

/***/ }),

/***/ 19466:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"notiContainer":"styles_notiContainer__6m2CD","titleNoti":"styles_titleNoti__To2Qd","notifyWrap":"styles_notifyWrap__BH8_d","notifyContentTop":"styles_notifyContentTop__ZIytL","notifyTitle":"styles_notifyTitle__nl0fr","notifyStatus":"styles_notifyStatus__V4sLB","markAll":"styles_markAll__Dso4F","notificationsItem":"styles_notificationsItem__UpFPg","read":"styles_read__slmW4","unRead":"styles_unRead__uFK8E","badgeContainer":"styles_badgeContainer__wVKFh","badge":"styles_badge__AJ2Ij"};

/***/ }),

/***/ 53426:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"searchDropdown":"styles_searchDropdown___Jm9a","keyword":"styles_keyword__NSeFl","searchResults":"styles_searchResults__YLodG","textPrimary":"styles_textPrimary__gKZmk","mostSearching":"styles_mostSearching__Dg1XV","results":"styles_results__eK7hJ","label":"styles_label__MQGtX","tag":"styles_tag__p1F53","hashtag":"styles_hashtag__UR_9Q","hoveredRecentSearchText":"styles_hoveredRecentSearchText__i5Wqf","styledScroll":"styles_styledScroll__Fxtup","recentSearchTextContainer":"styles_recentSearchTextContainer__GQbeo","recentSearchTextContent":"styles_recentSearchTextContent__gi1Jl","dot":"styles_dot__tt_Qd","ingredientHint":"styles_ingredientHint__aRWp7","ingredientSection":"styles_ingredientSection__jMRat","sectionHeader":"styles_sectionHeader__zOQ6Z"};

/***/ }),

/***/ 65602:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root_input":"styles_root_input__4ABPe","root_input_tablet":"styles_root_input_tablet__DemCG","input":"styles_input__Ic4Jc","HeaderSearch":"styles_HeaderSearch__24vJp","SearchInput":"styles_SearchInput__CuBZ_","search_wrap":"styles_search_wrap__HLrm2","search_ic_tablet":"styles_search_ic_tablet__J01f1","selectSearch":"styles_selectSearch__VtsX7","formControl":"styles_formControl__utyhi","formControlTablet":"styles_formControlTablet__rO8Ts","selectInput":"styles_selectInput__T0khH","hiddenSelect":"styles_hiddenSelect__45e9W","stickySelect":"styles_stickySelect__S53qz","showWidthSelect":"styles_showWidthSelect__W3McW","selectInputFocus":"styles_selectInputFocus__8weNg","searchContainer":"styles_searchContainer__bowJ2","searchTabletContainer":"styles_searchTabletContainer__nUK2v","root_input_sticky":"styles_root_input_sticky__Fcfle","root_input_scale":"styles_root_input_scale__nXySn","text_field_tablet":"styles_text_field_tablet__F3rqD","focusSelect":"styles_focusSelect__8PrHa","border_search_tablet":"styles_border_search_tablet__zI7R0","border_tablet":"styles_border_tablet__jiwsb","border_none":"styles_border_none__qbrZh","err_border":"styles_err_border__8f8gB","customHr":"styles_customHr__2wCvq","placeholder_wrapper":"styles_placeholder_wrapper__Y944P","placeholder":"styles_placeholder__v2N9g","slideInUp":"styles_slideInUp__x2qpU"};

/***/ }),

/***/ 71503:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"profileContainer":"styles_profileContainer__mXrKq","iconInfo":"styles_iconInfo__4tIMU","profilePopup":"styles_profilePopup__kmf_N","pause":"styles_pause__360Uq","wishListContainer":"styles_wishListContainer__1EJmY","slide":"styles_slide__6WE4j","wishListContent":"styles_wishListContent__f4dPT","isLoading":"styles_isLoading__p7Oa0","backdrop":"styles_backdrop__Rzvjb","effect":"styles_effect__zigxS","menuListContainer":"styles_menuListContainer__Rsl7M","levelContainer":"styles_levelContainer__P3_xx","levelIcon":"styles_levelIcon__TZCC4","leftContent":"styles_leftContent__M_Hm6","rightContent":"styles_rightContent__9EvAr","score":"styles_score__WtCxP","customHr":"styles_customHr__qtDq_","nameLevel":"styles_nameLevel__Pwsxl","sliver":"styles_sliver__E_2M8","gold":"styles_gold__gzFDD","platinum":"styles_platinum__E3iML","diamond":"styles_diamond__lZ_gm","menuContainer":"styles_menuContainer__OIcff","menuItem":"styles_menuItem__yyh7A","wishListItem":"styles_wishListItem__EPIOr","wishListTitle":"styles_wishListTitle__xc0uJ","infoProduct":"styles_infoProduct__3zay7","name":"styles_name__1gBDC","volume":"styles_volume__zn0f8","renderWishList":"styles_renderWishList__s7sHq","buttonBase":"styles_buttonBase__zNndN","textTitle":"styles_textTitle__zk4mU","wrapperLoading":"styles_wrapperLoading__rc3Vf","emptyContainer":"styles_emptyContainer__ogwgU","wrapperHereGif":"styles_wrapperHereGif__AutGe","textGuide":"styles_textGuide__gcz76","boldText":"styles_boldText__940y9","error":"styles_error__H16Ih","debtContent":"styles_debtContent__a5Ii2","debtValue":"styles_debtValue__HYvz5","premiumBlock":"styles_premiumBlock__mG5wT","premiumBadge":"styles_premiumBadge__nxEYM","premiumBadgeText":"styles_premiumBadgeText__MhJ89","premiumTitle":"styles_premiumTitle___u_4e","premiumProgramName":"styles_premiumProgramName__othew","premiumExpiry":"styles_premiumExpiry__AMB5m","menuItemHighlight":"styles_menuItemHighlight__pCOMJ","catalogPulse":"styles_catalogPulse__vlC_D","textLabelNew":"styles_textLabelNew__H9GRW","newBadge":"styles_newBadge__y77Zo","newDot":"styles_newDot__Ns7CI","newDotPulse":"styles_newDotPulse__4zvG2"};

/***/ })

}]);